import { resolveComponent as S, openBlock as s, createElementBlock as o, normalizeClass as A, withKeys as pe, withModifiers as R, createTextVNode as E, toDisplayString as B, createVNode as w, createCommentVNode as k, createElementVNode as y, withDirectives as Ne, vModelText as We, createBlock as T, withCtx as b, Fragment as Z, renderList as q, renderSlot as V, defineComponent as ge, resolveDynamicComponent as Le, mergeProps as j, vModelDynamic as Xe, normalizeStyle as ae, normalizeProps as qe, computed as oe, ref as K, watch as Te, unref as Ge } from "vue";
import { createNamespacedHelpers as Je } from "vuex";
import { defineStore as Qe, storeToRefs as et } from "pinia";
import { onBeforeRouteLeave as tt } from "vue-router";
const be = {
  dynPadClasses() {
    let e = "";
    return this.padding && (e += G(this.padding)), e;
  }
}, ne = {
  padding: {
    default: null,
    type: String
  }
}, G = (e) => {
  if (!e)
    return;
  let t = e.split(" "), n = "";
  return t.forEach((c, r) => {
    let i = "", _ = "";
    if (t.length === 4) {
      switch (r) {
        case 0:
          i = "top";
          break;
        case 1:
          i = "right";
          break;
        case 2:
          i = "bottom";
          break;
        case 3:
          i = "left";
          break;
      }
      c !== "0" && (n += ` pad-${i}--${c}`);
    } else if (t.length === 2) {
      switch (r) {
        case 0:
          i = "top", _ = "bottom";
          break;
        case 1:
          i = "right", _ = "left";
          break;
      }
      c !== "0" && (n += ` pad-${i}--${c}`), c !== "0" && (n += ` pad-${_}--${c}`);
    } else
      c !== "0" && (n += ` pad--${c}`);
  }), n.trim();
}, nt = (e) => e && e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const d = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [c, r] of t)
    n[c] = r;
  return n;
}, it = {
  name: "AutoSuggest",
  props: {
    ...ne,
    label: {
      default: null,
      type: String
    },
    val: {
      default: null,
      type: [String, Object]
    },
    name: {
      default: null,
      type: String
    },
    placeholder: {
      default: null,
      type: String
    },
    disabled: {
      default: null,
      type: Boolean
    },
    inline: {
      default: null,
      type: Boolean
    },
    showSuggestionOnClick: {
      default: !1,
      type: Boolean
    },
    suggestions: {
      default: null,
      type: Array
    },
    suggestionLabel: {
      default: null,
      type: [String, Array, Object]
    },
    hasDescriptions: {
      default: !1,
      type: Boolean
    },
    keepSearch: {
      default: !1,
      type: Boolean
    },
    forcePicking: {
      default: !1,
      type: Boolean
    },
    freeField: {
      default: !1,
      type: Boolean
    },
    noSuggestionAction: {
      default: !1,
      type: Boolean
    },
    noSuggestionCTA: {
      default: null,
      type: String
    },
    action: {
      default: null,
      type: Function
    },
    args: {
      default: null,
      type: [Number, String, Array]
    },
    dark: {
      default: !1,
      type: Boolean
    },
    valType: {
      default: null,
      type: [String, Object]
    },
    labelDescription: {
      default: null,
      type: String
    },
    required: {
      default: null,
      type: Boolean
    },
    selectAnyVal: {
      default: !1,
      type: Boolean
    },
    focused: {
      default: !1,
      type: Boolean
    },
    hasCta: {
      defaut: !1,
      type: Boolean
    },
    hasReset: {
      defaut: !1,
      type: Boolean
    },
    dataTestHandle: {
      default: null,
      type: String
    }
  },
  emits: ["input", "keypress", "paste", "blur", "focus"],
  data: function() {
    return {
      searchKey: this.val,
      viewList: !1,
      hideNoSuggestion: !this.showSuggestionOnClick,
      resetSuggestions: !1,
      touched: !1
    };
  },
  computed: {
    ...be,
    dynClasses() {
      return {
        "cc-ui-autosuggest": !0,
        "cc-ui-autosuggest--inline": this.inline,
        "cc-ui-autosuggest--dark": this.dark,
        [this.dynPadClasses]: !0
      };
    },
    showList() {
      return !this.touched || !this.searchKey && !this.showSuggestionOnClick || this.searchKey === "" && !this.showSuggestionOnClick || this.filteredSuggestions.length < 1 && this.showSuggestionOnClick && !this.viewList || this.filteredSuggestions.length < 1 && !this.noSuggestionAction ? !1 : this.filteredSuggestions.length > 0 && !this.resetSuggestions || this.filteredSuggestions && this.showSuggestionOnClick && this.viewList || this.noSuggestionAction && !this.hideNoSuggestion;
    },
    suggestionListClasses() {
      return {
        "cc-ui-autosuggest__list": !0,
        "cc-ui-autosuggest__list--open": this.showList
      };
    },
    filteredSuggestions() {
      if (!this.touched || !this.viewList && this.showSuggestionOnClick)
        return [];
      if (this.searchKey && this.searchKey !== "") {
        const e = new RegExp(`${nt(this.searchKey)}([\\W])*`, "gi");
        return this.suggestions.filter((t) => typeof t == "string" ? t.toLowerCase().trim().indexOf(this.searchKey.toLowerCase().trim()) > -1 && t : Object.values(t).join(" ").match(e) && t);
      }
      return this.suggestions;
    }
  },
  watch: {
    val: function(e) {
      this.searchKey = e;
    }
  },
  mounted() {
    var e, t;
    this.focused && ((t = (e = this.$refs) == null ? void 0 : e.inputbox) == null || t.focus());
  },
  methods: {
    onInput(e) {
      this.toggleNoSuggestion(e.target.value), this.touched || (this.touched = !0), this.resetSuggestions && (this.resetSuggestions = !1), this.viewList || (this.viewList = !0), this.$emit("input", e);
    },
    capitalize(e) {
      var t;
      return e ? `${(t = e[0]) == null ? void 0 : t.toUpperCase()}${e.substring(1)}` : "";
    },
    onEnter() {
      this.resetFilteredSuggestions(this.searchKey, "enter");
    },
    onAcknowledge() {
      this.action && this.action(this.searchKey), this.hideNoSuggestion = !0;
    },
    onReset() {
      this.onEsc(), this.searchKey = "", this.action && this.action("");
    },
    onDelete(e) {
      this.searchKey === "" && this.resetFilteredSuggestions(e.target.value, "delete");
    },
    onFocus(e) {
      this.focused || (this.touched = !0), this.$emit("focus", e);
    },
    onBlur(e) {
      this.freeField && this.filteredSuggestions.length < 1 && !this.noSuggestionAction && this.hideNoSuggestion && !this.resetSuggestions && this.resetFilteredSuggestions(e.target.value, "blur"), this.$emit("blur", e);
    },
    onEsc() {
      this.showSuggestionOnClick && this.viewList && (this.viewList = !1), this.resetSuggestions = !0, this.noSuggestionAction && (this.hideNoSuggestion = !0);
    },
    onInputClick() {
      this.showSuggestionOnClick && (this.viewList = !this.viewList, this.noSuggestionAction && (this.hideNoSuggestion = !0));
    },
    toggleNoSuggestion(e) {
      e.length > 0 && this.noSuggestionAction && this.hideNoSuggestion && this.filteredSuggestions.length < 1 && (this.hideNoSuggestion = !1);
    },
    resetFilteredSuggestions(e, t) {
      var c, r;
      let n = e;
      t === "enter" && (this.forcePicking ? this.filteredSuggestions.length > 0 && (n = this.filteredSuggestions && this.filteredSuggestions[0], this.action && this.action(n, this.args)) : (this.selectAnyVal || this.freeField || !this.val && e === "") && this.action && this.action(n, this.args)), t === "click" && this.action && this.action(e, this.args), this.showSuggestionOnClick && (this.viewList = !1), this.resetSuggestions = !0, this.noSuggestionAction && (this.hideNoSuggestion = !0), n !== this.searchKey && this.keepSearch ? this.searchKey = n && typeof n == "string" ? n : this.valType ? n[this.valType] : Object.values(n)[0] : this.keepSearch || (this.searchKey = ""), (r = (c = this.$refs) == null ? void 0 : c.inputbox) == null || r.focus();
    },
    navigateSuggestions(e, t) {
      var n;
      if (!(this.filteredSuggestions.length < 1 || !e)) {
        if (e === "down") {
          if (!t.parentElement.nextSibling && !t.nextElementSibling)
            return;
          if (t.tagName === "INPUT")
            (n = this.$refs["suggestion-button"][0]) == null || n.focus();
          else if (t.tagName === "BUTTON") {
            const c = this.$refs["suggestion-button"].findIndex((r) => r.isSameNode(t));
            c > -1 && this.$refs["suggestion-button"][c + 1].focus();
          }
        } else if (t.tagName === "BUTTON") {
          const c = this.$refs["suggestion-button"].findIndex((r) => r.isSameNode(t));
          c > 0 && this.$refs["suggestion-button"][c - 1].focus();
        }
      }
    },
    preventShortCuts(e) {
      e.keyCode === 84 && e.altKey && e.preventDefault();
    },
    onContainerKeyPress(e) {
      this.$emit("keypress", e);
    }
  }
}, st = ["data-test-handle"], ot = ["for", "required"], at = ["data-title"], lt = ["data-test-handle", "placeholder", "name", "aria-label", "inline", "disabled", "required"], ct = ["data-test-handle"], rt = ["onClick"], ut = { class: "cc-ui-autosuggest__category" }, dt = {
  key: 2,
  class: "cc-ui-autosuggest__desc"
}, _t = { key: 1 };
function ht(e, t, n, c, r, i) {
  const _ = S("cognitive-icon"), a = S("cognitive-button");
  return s(), o("div", {
    class: A(i.dynClasses),
    "data-test-handle": n.dataTestHandle,
    onKeypress: t[9] || (t[9] = (...l) => i.onContainerKeyPress && i.onContainerKeyPress(...l)),
    onKeydown: [
      t[10] || (t[10] = (...l) => i.preventShortCuts && i.preventShortCuts(...l)),
      t[11] || (t[11] = pe(R((l) => i.navigateSuggestions("down", l.target), ["stop", "prevent"]), ["down"])),
      t[12] || (t[12] = pe(R((l) => i.navigateSuggestions("up", l.target), ["stop", "prevent"]), ["up"])),
      t[13] || (t[13] = pe((...l) => i.onEsc && i.onEsc(...l), ["esc"]))
    ]
  }, [
    n.label ? (s(), o("label", {
      key: 0,
      class: "cc-ui-autosuggest__label",
      for: n.name,
      required: n.required
    }, [
      E(B(n.label) + " ", 1),
      n.labelDescription ? (s(), o("span", {
        key: 0,
        class: "cc-ui-autosuggest__hint",
        "data-title": n.labelDescription
      }, [
        w(_, {
          "icon-type": "css",
          "icon-name": "IconHelp",
          width: "17",
          scale: "15"
        })
      ], 8, at)) : k("", !0)
    ], 8, ot)) : k("", !0),
    y("div", null, [
      Ne(y("input", {
        ref: "inputbox",
        "onUpdate:modelValue": t[0] || (t[0] = (l) => e.searchKey = l),
        type: "search",
        class: "cc-ui-autosuggest__search",
        "data-test-handle": `${n.dataTestHandle}-input`,
        placeholder: n.placeholder,
        name: n.name,
        "aria-label": `Search ${n.name}`,
        inline: n.inline,
        disabled: n.disabled,
        required: n.required,
        autocomplete: "off",
        onInput: t[1] || (t[1] = (...l) => i.onInput && i.onInput(...l)),
        onPaste: t[2] || (t[2] = (l) => e.$emit("paste", l)),
        onBlur: t[3] || (t[3] = R((...l) => i.onBlur && i.onBlur(...l), ["stop"])),
        onFocus: t[4] || (t[4] = R((...l) => i.onFocus && i.onFocus(...l), ["stop"])),
        onKeydown: [
          t[5] || (t[5] = pe(R((...l) => i.onEnter && i.onEnter(...l), ["stop"]), ["enter"])),
          t[6] || (t[6] = pe(R((...l) => i.onDelete && i.onDelete(...l), ["stop"]), ["delete"]))
        ],
        onClick: t[7] || (t[7] = R((...l) => i.onInputClick && i.onInputClick(...l), ["stop"]))
      }, null, 40, lt), [
        [We, e.searchKey]
      ]),
      n.hasReset ? (s(), T(a, {
        key: 0,
        "data-test-handle": `${n.dataTestHandle}-reset-button`,
        version: "link",
        size: "sm",
        class: "cc-ui-autosuggest__reset",
        disabled: e.searchKey === "",
        onClick: i.onReset
      }, {
        default: b(() => [
          w(_, {
            "icon-type": "css",
            "icon-name": "IconPlus",
            rotation: "45",
            height: "17",
            scale: "15"
          })
        ]),
        _: 1
      }, 8, ["data-test-handle", "disabled", "onClick"])) : k("", !0),
      n.hasCta ? (s(), T(a, {
        key: 1,
        version: "link",
        size: "sm",
        class: "cc-ui-autosuggest__cta",
        "data-test-handle": `${n.dataTestHandle}-cta`,
        onClick: i.onEnter
      }, {
        default: b(() => [
          w(_, {
            "icon-type": "css",
            "icon-name": "IconSearch",
            height: "17",
            scale: "15"
          })
        ]),
        _: 1
      }, 8, ["data-test-handle", "onClick"])) : k("", !0)
    ]),
    y("ul", {
      ref: "suggestion-list",
      class: A(i.suggestionListClasses),
      "data-test-handle": `${n.dataTestHandle}-suggestion-list`
    }, [
      i.filteredSuggestions && i.filteredSuggestions.length > 0 ? (s(!0), o(Z, { key: 0 }, q(i.filteredSuggestions, (l, f) => (s(), o("li", {
        key: `suggestion-${f}`,
        ref_for: !0,
        ref: "suggestion",
        class: "cc-ui-autosuggest__item"
      }, [
        y("button", {
          ref_for: !0,
          ref: "suggestion-button",
          onClick: R((I) => i.resetFilteredSuggestions(l, "click"), ["stop"])
        }, [
          n.suggestionLabel && typeof n.suggestionLabel == "string" ? (s(), o(Z, { key: 0 }, [
            E(B(i.capitalize(l[n.suggestionLabel])), 1)
          ], 64)) : n.suggestionLabel && typeof n.suggestionLabel == "object" ? (s(), o(Z, { key: 1 }, [
            l[n.suggestionLabel] ? (s(), o(Z, { key: 0 }, [
              E(B(i.capitalize(l[n.suggestionLabel])), 1)
            ], 64)) : (s(), o(Z, { key: 1 }, [
              y("span", ut, B(i.capitalize(l[n.suggestionLabel[0]])), 1),
              typeof n.suggestionLabel[1] == "object" ? (s(), o(Z, { key: 0 }, [
                E(B(i.capitalize(l[n.suggestionLabel[1][0]])) + " " + B(l[n.suggestionLabel[1][1]] ? `(${l[n.suggestionLabel[1][1]]})` : null), 1)
              ], 64)) : (s(), o(Z, { key: 1 }, [
                E(B(i.capitalize(l[n.suggestionLabel[1]])), 1)
              ], 64)),
              n.hasDescriptions ? (s(), o("span", dt, B(l[n.suggestionLabel[2]]), 1)) : k("", !0)
            ], 64))
          ], 64)) : (s(), o(Z, { key: 2 }, [
            E(B(l), 1)
          ], 64))
        ], 8, rt)
      ]))), 128)) : (!i.filteredSuggestions || i.filteredSuggestions.length < 1) && n.noSuggestionAction && e.searchKey && e.searchKey.length > 1 ? (s(), o("li", _t, [
        y("span", null, [
          V(e.$slots, "action"),
          n.noSuggestionCTA ? (s(), T(a, {
            key: 0,
            version: "link",
            size: "sm",
            onClick: t[8] || (t[8] = (l) => i.onAcknowledge())
          }, {
            default: b(() => [
              E(B(n.noSuggestionCTA), 1)
            ]),
            _: 1
          })) : k("", !0)
        ])
      ])) : k("", !0)
    ], 10, ct)
  ], 42, st);
}
const ft = /* @__PURE__ */ d(it, [["render", ht]]);
const gt = ge({
  name: "CoreBlock",
  props: {
    spaced: {
      default: !1,
      type: Boolean
    },
    inline: {
      default: !1,
      type: Boolean
    },
    type: {
      default: "div",
      type: String
    },
    version: {
      default: null,
      type: String
    },
    ...ne
  },
  setup(e) {
    let t = ["cc-ui-block"];
    return e.spaced && t.push("cc-ui-block--spaced"), e.inline && t.push("cc-ui-block--inline"), e.version === "card" && t.push("cc-ui-block--card"), e.padding && G(e.padding) && t.push(G(e.padding)), {
      classes: t
    };
  }
});
function mt(e, t, n, c, r, i) {
  return s(), T(Le(e.type), {
    class: A(e.classes)
  }, {
    default: b(() => [
      V(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]);
}
const vt = /* @__PURE__ */ d(gt, [["render", mt]]);
const yt = ge({
  name: "CoreButton",
  props: {
    version: {
      default: null,
      type: String
    },
    size: {
      default: null,
      type: String
    },
    inverse: {
      default: !1,
      type: Boolean
    },
    spaced: {
      default: null,
      type: Boolean
    },
    icon: {
      default: !1,
      type: Boolean
    },
    tabindex: {
      default: 0,
      type: [Number, String]
    },
    focused: {
      default: !1,
      type: [Boolean]
    },
    dataTestHandle: {
      default: null,
      type: String
    }
  },
  emits: ["click"],
  computed: {
    classes() {
      let e = ["cc-ui-button"];
      return this.version && this.version.match(/primary|secondary|tertiary|link|pill|red/) && e.push(`cc-ui-button--${this.version}`), this.inverse && e.push(`cc-ui-button--${this.version}-inverse`), this.icon && e.push("cc-ui-button--icon"), this.$attrs.class && e.push(this.$attrs.class), e;
    }
  },
  mounted() {
    var e;
    this.focused && ((e = this.$refs.button) == null || e.focus());
  }
}), pt = ["data-spaced", "data-size", "tabindex", "data-test-handle"];
function Lt(e, t, n, c, r, i) {
  return s(), o("button", j({
    ref: "button",
    class: e.classes
  }, e.$attrs, {
    "data-spaced": e.spaced,
    "data-size": e.size,
    tabindex: e.tabindex,
    "data-test-handle": e.dataTestHandle,
    onClick: t[0] || (t[0] = (_) => e.$emit("click", _))
  }), [
    V(e.$slots, "default")
  ], 16, pt);
}
const Ct = /* @__PURE__ */ d(yt, [["render", Lt]]);
const bt = {
  name: "DatePicker",
  props: {
    inverse: {
      default: !1,
      type: Boolean
    },
    dateType: {
      default: "date",
      type: String
    },
    min: {
      default: null,
      type: String
    },
    max: {
      default: null,
      type: String
    },
    value: {
      default: null,
      type: [String, Date]
    }
  },
  emits: ["change", "blur", "keypress", "keydown", "keyup", "update:value"],
  methods: {
    handleChange(e) {
      this.$emit("update:value", e.target.value), this.$emit("change", e);
    }
  }
}, Mt = ["type", "min", "max", "value"];
function $t(e, t, n, c, r, i) {
  return s(), o("input", {
    type: n.dateType,
    min: n.min,
    max: n.max,
    value: n.value,
    class: A({
      "cc-ui-datepicker": !0,
      "cc-ui-datepicker--inverse": n.inverse
    }),
    onChange: t[0] || (t[0] = (..._) => i.handleChange && i.handleChange(..._)),
    onBlur: t[1] || (t[1] = (_) => e.$emit("blur", _)),
    onKeypress: t[2] || (t[2] = (_) => e.$emit("keypress", _)),
    onKeydown: t[3] || (t[3] = (_) => e.$emit("keydown", _)),
    onKeyup: t[4] || (t[4] = (_) => e.$emit("keyup", _))
  }, null, 42, Mt);
}
const xt = /* @__PURE__ */ d(bt, [["render", $t]]);
const St = {
  name: "CoreDropdown",
  inject: ["eventBus"],
  props: {
    disabled: {
      default: !1,
      type: Boolean
    },
    group: {
      default: null,
      type: String
    },
    tooltip: {
      default: null,
      type: String
    },
    tooltipPos: {
      default: null,
      type: String
    },
    closeOnEvent: {
      default: null,
      type: String
    },
    closeOnLeave: {
      default: !1,
      type: Boolean
    },
    onToggleExpand: {
      default: null,
      type: Function
    },
    overlap: {
      default: !1,
      type: Boolean
    },
    name: {
      default: null,
      type: String
    },
    contentPos: {
      default: null,
      type: String
    },
    exclusive: {
      default: !1,
      type: Boolean
    },
    smallCta: {
      default: !1,
      type: Boolean
    },
    inverse: {
      default: !1,
      type: Boolean
    },
    version: {
      default: "link",
      type: String
    },
    variant: {
      default: "button",
      type: String
    },
    checkboxValue: {
      default: null,
      type: [String, Boolean]
    },
    dataTestHandle: {
      default: null,
      type: String
    },
    dataPrivacy: {
      default: null,
      type: Boolean
    },
    tabindex: {
      default: 0,
      type: [Number, String]
    }
  },
  data() {
    return {
      expanded: !1,
      uid: ""
    };
  },
  computed: {
    dynClasses() {
      return {
        "cc-ui-ddown": !0,
        "cc-ui-ddown--expanded": this.expanded,
        "cc-ui-ddown--overlap": this.overlap,
        [`cc-ui-ddown--${this.contentPos}`]: this.overlap && this.contentPos
      };
    },
    tooltipInfo() {
      return this.tooltip && this.tooltipPos ? {
        [`data-title-${this.tooltipPos}`]: this.tooltip
      } : {};
    }
  },
  watch: {
    expanded(e, t) {
      e !== t && this.onToggleExpand && this.onToggleExpand(e);
    }
  },
  created() {
    this.uid = crypto.randomUUID();
  },
  mounted() {
    if (this.exclusive) {
      let e = this.group ? `cc:ui:dropdown:toggle:${this.group}` : "cc:ui:dropdown:toggle";
      this.eventBus.$on(e, (t) => {
        this.uid !== t && (this.expanded = !1);
      });
    }
    this.closeOnEvent && this.eventBus.$on(this.closeOnEvent, () => {
      this.expanded = !1;
    }), this.eventBus.$on("cc:close:dropdown", () => {
      this.expanded = !1;
    }), this.variant === "checkbox" && this.checkboxValue && (this.expanded = !0);
  },
  methods: {
    dropdownHandler() {
      if (this.expanded = !this.expanded, this.exclusive) {
        let e = this.group ? `cc:ui:dropdown:toggle:${this.group}` : "cc:ui:dropdown:toggle";
        this.eventBus.$emit(e, this.uid);
      }
      this.variant === "checkbox" && this.eventBus.$emit("cc:ui:dropdown:toggle:checkbox", this.expanded);
    }
  }
};
function wt(e, t, n, c, r, i) {
  const _ = S("cognitive-button"), a = S("cognitive-field"), l = S("cognitive-block");
  return s(), o("section", {
    class: A(i.dynClasses),
    onMouseleave: t[0] || (t[0] = (f) => n.closeOnLeave && (r.expanded = !1))
  }, [
    n.variant === "button" ? (s(), T(_, j({
      key: 0,
      id: `dropdown-button-${r.uid}`,
      size: n.smallCta ? "sm" : null,
      disabled: n.disabled
    }, i.tooltipInfo, {
      inverse: n.inverse,
      version: n.version,
      "aria-label": n.name,
      class: "cc-ui-ddown__toggle",
      "data-test-handle": n.dataTestHandle,
      tabindex: n.tabindex,
      "data-privacy": n.dataPrivacy,
      onClick: i.dropdownHandler
    }), {
      default: b(() => [
        V(e.$slots, "buttonText")
      ]),
      _: 3
    }, 16, ["id", "size", "disabled", "inverse", "version", "aria-label", "data-test-handle", "tabindex", "data-privacy", "onClick"])) : n.variant === "checkbox" ? (s(), o(Z, { key: 1 }, [
      w(a, {
        value: n.checkboxValue,
        "input-type": "checkbox",
        inline: "",
        tabindex: n.tabindex,
        "data-test-handle": n.dataTestHandle,
        "data-privacy": n.dataPrivacy,
        onChange: i.dropdownHandler
      }, null, 8, ["value", "tabindex", "data-test-handle", "data-privacy", "onChange"]),
      V(e.$slots, "buttonText")
    ], 64)) : k("", !0),
    r.expanded ? (s(), T(l, {
      key: 2,
      id: `dropdown-content-${r.uid}`,
      padding: "md 0 md 0",
      class: "cc-ui-ddown__content"
    }, {
      default: b(() => [
        V(e.$slots, "blockText")
      ]),
      _: 3
    }, 8, ["id"])) : k("", !0)
  ], 34);
}
const kt = /* @__PURE__ */ d(St, [["render", wt]]);
const It = {
  name: "CoreError",
  props: {
    errorMessage: {
      default: null,
      type: String
    },
    errorSubMessage: {
      default: null,
      type: String
    },
    action: {
      default: null,
      type: Function
    },
    actionArgs: {
      default: null,
      type: [Object, String, Array, Number, Symbol, Function]
    }
  }
};
function zt(e, t, n, c, r, i) {
  const _ = S("cognitive-icon"), a = S("cognitive-paragraph"), l = S("cognitive-button"), f = S("cognitive-block");
  return s(), T(f, { class: "cc-error" }, {
    default: b(() => [
      w(f, { class: "cc-error__message" }, {
        default: b(() => [
          w(_, {
            class: "cc-error__icon",
            "icon-type": "css",
            "icon-name": "IconInfo",
            width: "64",
            height: "64"
          }),
          w(a, {
            size: "lg",
            padding: "md 0 0 0"
          }, {
            default: b(() => [
              E(B(n.errorMessage), 1)
            ]),
            _: 1
          }),
          n.errorSubMessage ? (s(), T(a, {
            key: 0,
            size: "xs",
            padding: "sm 0 sm 0"
          }, {
            default: b(() => [
              E(B(n.errorSubMessage), 1)
            ]),
            _: 1
          })) : k("", !0),
          n.action ? (s(), T(f, {
            key: 1,
            class: "cc-error__support"
          }, {
            default: b(() => [
              E(" Please "),
              w(l, {
                version: "link",
                onClick: t[0] || (t[0] = (I) => n.action(n.actionArgs))
              }, {
                default: b(() => [
                  E(" contact us ")
                ]),
                _: 1
              }),
              E(" if the error persists ")
            ]),
            _: 1
          })) : k("", !0)
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const Tt = /* @__PURE__ */ d(It, [["render", zt]]);
var fe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Oe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ht = "Expected a function", He = 0 / 0, Dt = "[object Symbol]", Zt = /^\s+|\s+$/g, Bt = /^[-+]0x[0-9a-f]+$/i, At = /^0b[01]+$/i, Vt = /^0o[0-7]+$/i, Nt = parseInt, Ot = typeof fe == "object" && fe && fe.Object === Object && fe, Pt = typeof self == "object" && self && self.Object === Object && self, Et = Ot || Pt || Function("return this")(), Ft = Object.prototype, Kt = Ft.toString, Yt = Math.max, Rt = Math.min, $e = function() {
  return Et.Date.now();
};
function jt(e, t, n) {
  var c, r, i, _, a, l, f = 0, I = !1, $ = !1, N = !0;
  if (typeof e != "function")
    throw new TypeError(Ht);
  t = De(t) || 0, we(n) && (I = !!n.leading, $ = "maxWait" in n, i = $ ? Yt(De(n.maxWait) || 0, t) : i, N = "trailing" in n ? !!n.trailing : N);
  function O(H) {
    var Y = c, ee = r;
    return c = r = void 0, f = H, _ = e.apply(ee, Y), _;
  }
  function X(H) {
    return f = H, a = setTimeout(ie, t), I ? O(H) : _;
  }
  function J(H) {
    var Y = H - l, ee = H - f, te = t - Y;
    return $ ? Rt(te, i - ee) : te;
  }
  function U(H) {
    var Y = H - l, ee = H - f;
    return l === void 0 || Y >= t || Y < 0 || $ && ee >= i;
  }
  function ie() {
    var H = $e();
    if (U(H))
      return se(H);
    a = setTimeout(ie, J(H));
  }
  function se(H) {
    return a = void 0, N && c ? O(H) : (c = r = void 0, _);
  }
  function ce() {
    a !== void 0 && clearTimeout(a), f = 0, c = l = r = a = void 0;
  }
  function me() {
    return a === void 0 ? _ : se($e());
  }
  function Q() {
    var H = $e(), Y = U(H);
    if (c = arguments, r = this, l = H, Y) {
      if (a === void 0)
        return X(l);
      if ($)
        return a = setTimeout(ie, t), O(l);
    }
    return a === void 0 && (a = setTimeout(ie, t)), _;
  }
  return Q.cancel = ce, Q.flush = me, Q;
}
function we(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function Ut(e) {
  return !!e && typeof e == "object";
}
function Wt(e) {
  return typeof e == "symbol" || Ut(e) && Kt.call(e) == Dt;
}
function De(e) {
  if (typeof e == "number")
    return e;
  if (Wt(e))
    return He;
  if (we(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = we(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(Zt, "");
  var n = At.test(e);
  return n || Vt.test(e) ? Nt(e.slice(2), n ? 2 : 8) : Bt.test(e) ? He : +e;
}
var Xt = jt;
const qt = /* @__PURE__ */ Oe(Xt);
const Gt = ["text", "number", "range", "textarea", "password"], Jt = ["select", "checkbox", "radio"], Qt = {
  name: "CoreField",
  props: {
    ...ne,
    label: {
      default: null,
      type: [String, Boolean]
    },
    list: {
      default: null,
      type: [Array, Object]
    },
    name: {
      default: null,
      type: String
    },
    inline: {
      default: !1,
      type: Boolean
    },
    disabled: {
      default: !1,
      type: Boolean
    },
    addEmpty: {
      default: !1,
      type: Boolean
    },
    listUseKeys: {
      default: !1,
      type: Boolean
    },
    listVal: {
      default: null,
      type: String
    },
    listKey: {
      default: null,
      type: String
    },
    listShowKey: {
      default: !1,
      type: Boolean
    },
    listShowKeyOnly: {
      default: !1,
      type: Boolean
    },
    required: {
      default: null,
      type: Boolean
    },
    inputType: {
      default: "text",
      type: String
    },
    value: {
      default: null,
      type: [String, Boolean, Number]
    },
    min: {
      default: null,
      type: Number
    },
    max: {
      default: null,
      type: Number
    },
    step: {
      default: null,
      type: Number
    },
    placeholder: {
      default: null,
      type: String
    },
    pattern: {
      default: null,
      type: String
    },
    validationMessage: {
      default: null,
      type: String
    },
    title: {
      default: "",
      type: String
    },
    autocomplete: {
      default: "off",
      type: String
    },
    minlength: {
      default: null,
      type: Number
    },
    maxlength: {
      default: null,
      type: Number
    },
    version: {
      default: null,
      type: String
    },
    labelDescription: {
      default: null,
      type: [String, Boolean]
    },
    removeHintIcon: {
      default: !1,
      type: Boolean
    },
    focused: {
      default: !1,
      type: Boolean
    },
    tabindex: {
      default: 0,
      type: [Number, String]
    },
    isInvalid: {
      default: !1,
      type: Boolean
    },
    validateBeforeTouched: {
      default: !1,
      type: Boolean
    },
    debounced: {
      default: !1,
      type: Boolean
    }
  },
  emits: ["update:value", "input", "keydown", "keyup", "keypress", "change", "blur"],
  data() {
    return {
      touched: !1,
      valid: !0,
      uid: "",
      localValue: this.value
    };
  },
  computed: {
    ...be,
    dynClasses() {
      return {
        "cc-ui-field": !0,
        "cc-ui-field--inline": this.inline,
        "cc-ui-field--inverse": this.version === "inverse",
        "cc-ui-field--error": (this.touched || this.validateBeforeTouched) && !this.valid,
        [this.dynPadClasses]: !0
      };
    },
    labelTooltip() {
      return this.removeHintIcon && this.labelDescription ? this.labelDescription : null;
    }
  },
  watch: {
    isInvalid: {
      handler: function() {
        this.valid = !this.isInvalid;
      },
      immediate: !0
    },
    value: {
      handler: function() {
        this.localValue = this.value;
      },
      immediate: !0
    }
  },
  created() {
    this.inputType === "range" && (this.uid = crypto.randomUUID()), this.debounced && (this.debouncedOnInput = qt(this.onInput, 200));
  },
  mounted() {
    var e;
    this.focused && ((e = this.$refs[this.inputType]) == null || e.focus());
  },
  methods: {
    async onInput(e) {
      console.log("input"), this.touched = !0, this.$emit("input", e), Gt.includes(this.inputType) && this.$emit("update:value", e.target.value), await this.$nextTick(), this.checkInputValidity();
    },
    onKeyDown(e) {
      this.$emit("keydown", e);
    },
    onKeyUp(e) {
      this.$emit("keyup", e);
    },
    onKeyPress(e) {
      this.$emit("keypress", e);
    },
    checkInputValidity() {
      if (this.pattern && this.touched) {
        const e = new RegExp(this.pattern);
        this.valid = e.test(this.value);
      }
    },
    onChanged(e) {
      this.$emit("change", e), Jt.includes(this.inputType) && this.$emit("update:value", this.inputType === "select" ? e.target.value : e.target.checked);
    }
  }
}, e1 = ["required"], t1 = ["for"], n1 = ["data-title-right", "innerHTML"], i1 = ["data-title"], s1 = ["name", "disabled", "required", "tabindex"], o1 = {
  key: 0,
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, a1 = {
  key: 1,
  value: ""
}, l1 = ["value", "selected"], c1 = ["value", "selected"], r1 = ["value", "selected"], u1 = ["value", "minlength", "maxlength", "disabled", "name", "required", "placeholder", "tabindex"], d1 = ["type", "disabled", "name", "value", "min", "max", "step", "required", "placeholder", "tabindex"], _1 = ["type", "disabled", "name", "value", "list", "min", "max", "step", "placeholder", "tabindex"], h1 = ["id"], f1 = ["value", "label"], g1 = ["type", "disabled", "name", "checked", "placeholder", "tabindex"], m1 = ["type", "disabled", "name", "required", "autocomplete", "placeholder", "pattern", "title", "minlength", "maxlength", "tabindex"], v1 = ["innerHTML"];
function y1(e, t, n, c, r, i) {
  const _ = S("cognitive-icon");
  return s(), o("div", {
    class: A(i.dynClasses),
    required: n.required
  }, [
    n.label ? (s(), o("label", {
      key: 0,
      for: n.name
    }, [
      y("span", {
        "data-title-right": i.labelTooltip,
        innerHTML: n.label
      }, null, 8, n1),
      !n.removeHintIcon && n.labelDescription ? (s(), o("span", {
        key: 0,
        class: "cc-ui-field__hint",
        "data-title": n.labelDescription
      }, [
        w(_, {
          "icon-type": "css",
          "icon-name": "IconHelp",
          width: "17",
          scale: "15"
        })
      ], 8, i1)) : k("", !0)
    ], 8, t1)) : k("", !0),
    n.inputType === "select" ? (s(), o("select", j({ key: 1 }, e.$attrs, {
      ref: "select",
      name: n.name,
      disabled: n.disabled,
      required: n.required,
      tabindex: n.tabindex,
      onChange: t[0] || (t[0] = (...a) => i.onChanged && i.onChanged(...a)),
      onBlur: t[1] || (t[1] = (a) => e.$emit("blur", a))
    }), [
      n.placeholder ? (s(), o("option", o1, B(n.placeholder), 1)) : k("", !0),
      n.addEmpty ? (s(), o("option", a1, "-")) : k("", !0),
      n.listUseKeys ? (s(!0), o(Z, { key: 2 }, q(n.list, (a, l) => (s(), o("option", {
        key: a.uuid,
        value: l,
        selected: n.value === l
      }, [
        n.listShowKeyOnly ? (s(), o(Z, { key: 0 }, [
          E(B(l), 1)
        ], 64)) : (s(), o(Z, { key: 1 }, [
          E(B(n.listShowKey ? `${l} - ${a}` : a), 1)
        ], 64))
      ], 8, l1))), 128)) : (s(), o(Z, { key: 3 }, [
        n.listKey && n.listKey !== null ? (s(!0), o(Z, { key: 0 }, q(n.list, (a, l) => (s(), o("option", {
          key: `list-${l}`,
          value: a[n.listKey],
          selected: n.value === a[n.listKey]
        }, B(a[n.listVal]), 9, c1))), 128)) : (s(!0), o(Z, { key: 1 }, q(n.list, (a, l) => (s(), o("option", {
          key: `list-${l}`,
          value: a[n.listVal],
          selected: n.value === a[n.listVal]
        }, B(a[n.listVal]), 9, r1))), 128))
      ], 64))
    ], 16, s1)) : n.inputType === "textarea" ? (s(), o("textarea", j({ key: 2 }, e.$attrs, {
      ref: "textarea",
      value: n.value,
      minlength: n.minlength,
      maxlength: n.maxlength,
      disabled: n.disabled,
      name: n.name,
      required: n.required,
      placeholder: n.placeholder,
      tabindex: n.tabindex,
      onInput: t[2] || (t[2] = (a) => n.debounced ? e.debouncedOnInput(a) : i.onInput(a)),
      onChange: t[3] || (t[3] = (...a) => i.onChanged && i.onChanged(...a)),
      onKeypress: t[4] || (t[4] = (...a) => i.onKeyPress && i.onKeyPress(...a)),
      onKeydown: t[5] || (t[5] = (...a) => i.onKeyDown && i.onKeyDown(...a)),
      onKeyup: t[6] || (t[6] = (...a) => i.onKeyUp && i.onKeyUp(...a)),
      onBlur: t[7] || (t[7] = (a) => e.$emit("blur", a))
    }), null, 16, u1)) : n.inputType === "number" ? (s(), o("input", j({ key: 3 }, e.$attrs, {
      ref: "number",
      type: n.inputType,
      disabled: n.disabled,
      name: n.name,
      value: n.value,
      min: n.min,
      max: n.max,
      step: n.step,
      required: n.required,
      placeholder: n.placeholder,
      tabindex: n.tabindex,
      onInput: t[8] || (t[8] = (a) => n.debounced ? e.debouncedOnInput(a) : i.onInput(a)),
      onChange: t[9] || (t[9] = (...a) => i.onChanged && i.onChanged(...a)),
      onKeypress: t[10] || (t[10] = (...a) => i.onKeyPress && i.onKeyPress(...a)),
      onKeydown: t[11] || (t[11] = (...a) => i.onKeyDown && i.onKeyDown(...a)),
      onKeyup: t[12] || (t[12] = (...a) => i.onKeyUp && i.onKeyUp(...a)),
      onBlur: t[13] || (t[13] = (a) => e.$emit("blur", a))
    }), null, 16, d1)) : n.inputType === "range" ? (s(), o(Z, { key: 4 }, [
      y("input", j(e.$attrs, {
        ref: "range",
        type: n.inputType,
        disabled: n.disabled,
        name: n.name,
        value: n.value,
        list: `list-${r.uid}`,
        min: n.min,
        max: n.max,
        step: n.step,
        placeholder: n.placeholder,
        tabindex: n.tabindex,
        onInput: t[14] || (t[14] = (a) => n.debounced ? e.debouncedOnInput(a) : i.onInput(a)),
        onChange: t[15] || (t[15] = (...a) => i.onChanged && i.onChanged(...a)),
        onKeypress: t[16] || (t[16] = (...a) => i.onKeyPress && i.onKeyPress(...a)),
        onKeydown: t[17] || (t[17] = (...a) => i.onKeyDown && i.onKeyDown(...a)),
        onKeyup: t[18] || (t[18] = (...a) => i.onKeyUp && i.onKeyUp(...a))
      }), null, 16, _1),
      n.list ? (s(), o("datalist", j({
        key: 0,
        id: `list-${r.uid}`
      }, e.$attrs), [
        (s(!0), o(Z, null, q(n.list, (a, l) => (s(), o("option", {
          key: `list-datalist-${l}`,
          value: a.value,
          label: a.label
        }, null, 8, f1))), 128))
      ], 16, h1)) : k("", !0)
    ], 64)) : n.inputType === "checkbox" || n.inputType === "radio" ? (s(), o("input", j({
      key: 5,
      ref: n.inputType,
      type: n.inputType,
      disabled: n.disabled,
      name: n.name,
      checked: n.value,
      placeholder: n.placeholder,
      tabindex: n.tabindex
    }, e.$attrs, {
      onInput: t[19] || (t[19] = (a) => r.touched = !0),
      onChange: t[20] || (t[20] = (...a) => i.onChanged && i.onChanged(...a)),
      onKeydown: t[21] || (t[21] = (...a) => i.onKeyDown && i.onKeyDown(...a)),
      onKeyup: t[22] || (t[22] = (...a) => i.onKeyUp && i.onKeyUp(...a)),
      onBlur: t[23] || (t[23] = (a) => e.$emit("blur", a))
    }), null, 16, g1)) : Ne((s(), o("input", j({ key: 6 }, e.$attrs, {
      ref: "text",
      "onUpdate:modelValue": t[24] || (t[24] = (a) => r.localValue = a),
      type: n.inputType,
      disabled: n.disabled,
      name: n.name,
      required: n.required,
      autocomplete: n.autocomplete,
      placeholder: n.placeholder,
      pattern: n.pattern,
      title: n.title,
      minlength: n.minlength,
      maxlength: n.maxlength,
      tabindex: n.tabindex,
      onInput: t[25] || (t[25] = (a) => n.debounced ? e.debouncedOnInput(a) : i.onInput(a)),
      onChange: t[26] || (t[26] = (...a) => i.onChanged && i.onChanged(...a)),
      onKeypress: t[27] || (t[27] = (...a) => i.onKeyPress && i.onKeyPress(...a)),
      onKeydown: t[28] || (t[28] = (...a) => i.onKeyDown && i.onKeyDown(...a)),
      onKeyup: t[29] || (t[29] = (...a) => i.onKeyUp && i.onKeyUp(...a)),
      onBlur: t[30] || (t[30] = (a) => e.$emit("blur", a))
    }), null, 16, m1)), [
      [Xe, r.localValue]
    ]),
    n.validationMessage && (r.touched || n.validateBeforeTouched) && !r.valid ? (s(), o(Z, { key: 7 }, [
      w(_, {
        class: "cc-ui-field__icon",
        "icon-type": "css",
        "icon-name": "IconInfo"
      }),
      y("p", {
        class: "cc-ui-field__message",
        innerHTML: n.validationMessage
      }, null, 8, v1)
    ], 64)) : k("", !0)
  ], 10, e1);
}
const p1 = /* @__PURE__ */ d(Qt, [["render", y1]]);
const L1 = {
  name: "FileUploader",
  props: {
    name: {
      default: null,
      type: String
    },
    multiple: {
      default: !1,
      type: Boolean
    },
    inline: {
      default: !1,
      type: Boolean
    },
    disabled: {
      default: !1,
      type: Boolean
    },
    allowedTypes: {
      default: null,
      type: String
    },
    fileNameMatch: {
      default: null,
      type: String
    },
    dragTextCopy: {
      default: null,
      type: String
    },
    dataTestHandle: {
      default: null,
      type: String
    },
    externalFiles: {
      default: () => [],
      type: [FileList, Array, null]
    }
  },
  emits: ["change"],
  data() {
    return {
      selectedFile: !1,
      file: null,
      fileName: "",
      fileExtensionError: "",
      fileNameError: ""
    };
  },
  computed: {
    dragCopy() {
      if (this.dragTextCopy)
        return this.dragTextCopy;
      let e = "";
      return this.allowedTypes && (e = `(${this.allowedTypes.toLowerCase()} only)`), this.multiple ? `<b>Choose a list of files</b><span> or drag them here ${e}</span>` : `<b>Choose a file</b><span> or drag it here ${e}</span>`;
    }
  },
  watch: {
    externalFiles: function(e) {
      this.setFile(e);
    }
  },
  methods: {
    setFile(e) {
      if (this.selectedFile = !1, this.fileName = "", this.multiple) {
        let t = "";
        if (this.file = e, !this.file || !this.file.length)
          return;
        for (t of this.file)
          this.fileTypeCheck(t);
      } else {
        if (this.file = e[0], !this.file)
          return;
        this.fileTypeCheck(this.file), this.fileNameCheck(this.file);
      }
      this.selectedFile = !0;
    },
    fileTypeCheck(e) {
      if (this.fileExtensionError = "", this.allowedTypes && e.name.split(".").pop().toLowerCase() !== this.allowedTypes.toLowerCase()) {
        this.fileExtensionError = `You are trying to upload .${e.name.split(".").pop().toLowerCase()} files, please upload .${this.allowedTypes.toLowerCase()} documents only.`, this.$refs.file.value = null, this.file = null;
        return;
      }
      this.setFileName(e);
    },
    fileNameCheck(e) {
      if (this.fileNameError = "", e) {
        let t = e.name.substring(0, e.name.lastIndexOf("."));
        if (this.fileNameMatch && t !== this.fileNameMatch) {
          this.fileNameError = `The file you are uploading does not match the required name of  <b>${this.fileNameMatch}.${this.allowedTypes.toLowerCase()}</b>`, this.$refs.file.value = null, this.file = null;
          return;
        }
      }
    },
    setFileName(e) {
      this.fileName += `<p>${e.name}</p>`;
    },
    changeHandler(e) {
      this.setFile(e.target.files), this.$emit("change", e);
    }
  }
}, C1 = ["data-test-handle", "name", "disabled", "multiple"], b1 = ["for"], M1 = ["innerHTML"], $1 = ["innerHTML"];
function x1(e, t, n, c, r, i) {
  const _ = S("cognitive-icon"), a = S("cognitive-button"), l = S("cognitive-paragraph");
  return s(), o("div", {
    class: A({
      "cc-ui-uploader": !0,
      "cc-ui-uploader--selected-file": r.selectedFile,
      "cc-ui-uploader--inline": n.inline,
      "cc-ui-uploader--disabled": n.disabled
    })
  }, [
    y("input", {
      ref: "file",
      class: "cc-ui-uploader__file",
      type: "file",
      "data-test-handle": n.dataTestHandle,
      name: n.name,
      disabled: n.disabled,
      multiple: n.multiple,
      onClick: t[0] || (t[0] = (f) => r.selectedFile = !1),
      onChange: t[1] || (t[1] = (...f) => i.changeHandler && i.changeHandler(...f))
    }, null, 40, C1),
    y("label", { for: n.name }, [
      r.selectedFile ? (s(), o(Z, { key: 1 }, [
        n.inline ? k("", !0) : (s(), T(_, {
          key: 0,
          class: "icon",
          "icon-type": "css",
          "icon-name": r.fileExtensionError === "" ? "IconSuccess" : "IconInfo",
          "icon-color": "#002b49",
          width: "56",
          height: "56"
        }, null, 8, ["icon-name"])),
        y("span", { innerHTML: r.fileName }, null, 8, $1),
        w(a, {
          version: "secondary",
          size: "sm"
        }, {
          default: b(() => [
            E(" Click to change selected " + B(n.multiple ? "files" : "file"), 1)
          ]),
          _: 1
        })
      ], 64)) : (s(), o(Z, { key: 0 }, [
        n.inline ? k("", !0) : (s(), T(_, {
          key: 0,
          class: "icon__upload",
          width: "56",
          height: "56",
          "icon-type": "css",
          "icon-name": "IconUpload"
        })),
        y("p", { innerHTML: i.dragCopy }, null, 8, M1)
      ], 64))
    ], 8, b1),
    r.fileExtensionError !== "" ? (s(), T(l, {
      key: 0,
      size: "xs",
      padding: "xs 0",
      class: "cc-ui-uploader__fileError",
      innerHTML: r.fileExtensionError
    }, null, 8, ["innerHTML"])) : k("", !0),
    r.fileNameError !== "" ? (s(), T(l, {
      key: 1,
      size: "xs",
      padding: "xs 0",
      class: "cc-ui-uploader__fileError",
      innerHTML: r.fileNameError
    }, null, 8, ["innerHTML"])) : k("", !0)
  ], 2);
}
const S1 = /* @__PURE__ */ d(L1, [["render", x1]]);
const w1 = {
  name: "CognitiveHeading",
  props: {
    decoration: {
      default: !1,
      type: Boolean
    }
  }
}, k1 = {
  key: 0,
  class: "cc-ui-heading__decoration"
};
function I1(e, t, n, c, r, i) {
  return s(), o("header", j(e.$attrs, { class: "cc-ui-heading" }), [
    n.decoration ? (s(), o("div", k1)) : k("", !0),
    V(e.$slots, "default")
  ], 16);
}
const z1 = /* @__PURE__ */ d(w1, [["render", I1]]), T1 = {
  name: "CognitiveIcon",
  props: {
    iconType: {
      default: "svg",
      type: String
    },
    iconName: {
      default: null,
      type: String
    },
    width: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: [Number, String],
      default: 16
    },
    iconColor: {
      type: String,
      default: "currentColor"
    },
    rotation: {
      default: null,
      type: String
    },
    scale: {
      type: [Number, String],
      default: null
    },
    transformOrigin: {
      default: "top left",
      type: String
    },
    secondaryColor: {
      type: String,
      default: "currentColor"
    },
    dataTestHandle: {
      type: String,
      default: null
    },
    viewBox: {
      type: String,
      default: "0 0 16 16"
    }
  }
}, H1 = ["width", "height", "viewBox", "aria-labelledby", "data-test-handle"], D1 = ["id"], Z1 = ["fill"], B1 = ["data-test-handle"];
function A1(e, t, n, c, r, i) {
  return n.iconType === "svg" ? (s(), o("svg", {
    key: 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: n.width,
    height: n.height,
    viewBox: n.viewBox,
    "aria-labelledby": n.iconName,
    role: "presentation",
    "data-test-handle": n.dataTestHandle
  }, [
    n.iconName ? (s(), o("title", {
      key: 0,
      id: n.iconName,
      lang: "en"
    }, B(n.iconName) + " icon", 9, D1)) : k("", !0),
    y("g", { fill: n.iconColor }, [
      V(e.$slots, "default")
    ], 8, Z1)
  ], 8, H1)) : (s(), o("div", j({ key: 1 }, e.$attrs, {
    class: "cc-ui-icon",
    "data-test-handle": n.dataTestHandle
  }), [
    (s(), T(Le(`CSS${n.iconName}`), {
      style: ae({
        "--width": `${+n.width / 16}rem`,
        "--height": `${+n.height / 16}rem`,
        "--iconColor": n.iconColor,
        "--rotation": `${n.rotation ? n.rotation : 0}deg`,
        "--scale": n.scale ? `${+n.scale / 16}` : `${+n.width / 16}`,
        "--transformOrigin": n.transformOrigin,
        "--secondaryColor": n.secondaryColor
      })
    }, null, 8, ["style"]))
  ], 16, B1));
}
const V1 = /* @__PURE__ */ d(T1, [["render", A1]]);
const N1 = {
  name: "CognitiveInitials",
  props: {
    user: {
      default: null,
      type: Object
    },
    size: {
      default: "md",
      type: String
    },
    bgColor: {
      default: null,
      type: String
    },
    textColor: {
      default: null,
      type: String
    },
    hasTooltip: {
      default: null,
      type: String
    }
  },
  computed: {
    userInitials() {
      var e, t, n, c;
      return (t = (e = this.user) == null ? void 0 : e.attributes) != null && t.given_name && ((c = (n = this.user) == null ? void 0 : n.attributes) != null && c.family_name) ? `${this.user.attributes.given_name.charAt(0)}${this.user.attributes.family_name.charAt(0)}` : "AN";
    },
    tooltip() {
      return this.hasTooltip ? `data-title-${this.hasTooltip}` : null;
    },
    classes() {
      const e = ["cc-ui-initials"];
      return this.size !== "md" && e.push(`cc-ui-initials--${this.size}`), e;
    },
    tooltipValue() {
      var e, t, n, c;
      return this.hasTooltip ? `${(t = (e = this.user) == null ? void 0 : e.attributes) == null ? void 0 : t.given_name} ${(c = (n = this.user) == null ? void 0 : n.attributes) == null ? void 0 : c.family_name}` : null;
    }
  }
};
function O1(e, t, n, c, r, i) {
  return s(), o("span", qe({
    class: i.classes,
    style: {
      color: n.textColor,
      backgroundColor: n.bgColor
    },
    [i.tooltip || ""]: i.tooltipValue
  }), B(i.userInitials), 17);
}
const P1 = /* @__PURE__ */ d(N1, [["render", O1]]);
const E1 = {
  name: "CognitiveInlineError",
  props: {
    ...ne,
    message: {
      default: null,
      type: String
    },
    size: {
      default: "sm",
      type: String
    }
  },
  computed: {
    ...be,
    dynClasses() {
      return {
        "cc-ui-inline-error": !0,
        [this.dynPadClasses]: !0
      };
    }
  }
};
function F1(e, t, n, c, r, i) {
  const _ = S("cognitive-icon"), a = S("cognitive-paragraph"), l = S("cognitive-block");
  return s(), T(l, {
    version: "card",
    class: A(i.dynClasses)
  }, {
    default: b(() => [
      w(_, {
        class: "cc-ui-inline-error__icon",
        "icon-type": "css",
        "icon-name": "IconInfo",
        width: "56",
        height: "56"
      }),
      w(a, { size: n.size }, {
        default: b(() => [
          E(B(n.message), 1)
        ]),
        _: 1
      }, 8, ["size"])
    ]),
    _: 1
  }, 8, ["class"]);
}
const K1 = /* @__PURE__ */ d(E1, [["render", F1]]);
const Y1 = {
  name: "CoreList",
  props: {
    ordered: {
      default: !1,
      type: Boolean
    },
    inline: {
      default: !1,
      type: Boolean
    },
    ...ne
  },
  computed: {
    classes() {
      let e = ["cc-ui-list"];
      return this.inline && e.push("cc-ui-list--inline"), this.padding && G(this.padding) && e.push(G(this.padding)), e;
    },
    tagName() {
      return this.ordered ? "ol" : "ul";
    }
  }
};
function R1(e, t, n, c, r, i) {
  return s(), T(Le(i.tagName), j({ class: i.classes }, e.$attrs), {
    default: b(() => [
      V(e.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]);
}
const j1 = /* @__PURE__ */ d(Y1, [["render", R1]]);
const U1 = ge({
  name: "ListItem",
  props: {
    ...ne,
    inline: {
      default: !1,
      type: Boolean
    }
  },
  setup(e, { attrs: t }) {
    return {
      classes: oe(() => {
        let c = ["cc-ui-list-item"];
        return e.inline && c.push("cc-ui-list-item--inline"), e.padding && G(e.padding) && c.push(G(e.padding)), t.class && c.push(t.class), c;
      })
    };
  }
});
function W1(e, t, n, c, r, i) {
  return s(), o("li", j({ class: e.classes }, e.$attrs), [
    V(e.$slots, "default")
  ], 16);
}
const X1 = /* @__PURE__ */ d(U1, [["render", W1]]), q1 = {}, G1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 711 615"
}, J1 = /* @__PURE__ */ y("path", {
  fill: "none",
  stroke: "#2A9D8F",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "40",
  d: "M174.633835,342 C145.399431,342 119.050397,335.100069 95.5859417,321.3 C72.1214862,307.499931 53.6579294,288.400122 40.1947172,264 C26.7315051,239.599878 20,212.000154 20,181.2 C20,150.399846 26.7315051,122.800122 40.1947172,98.4 C53.6579294,73.999878 72.1214862,55.000068 95.5859417,41.4 C119.050397,27.799932 145.399431,21 174.633835,21 C203.868238,21 230.217273,27.799932 253.681728,41.4 C277.146184,55.000068 295.513576,73.999878 308.784457,98.4 C320.601137,120.126398 327.2208,146.155683 328.5,172.5 C328.560916,173.754526 382.818704,169.685071 406.5,168 C406.5,157 406.725121,114.440234 440.5,72.5 C486,16 549.843557,21 550,21 C592.5,21 657,41.5 681,112.5 C692.642241,146.941629 699,212.5 657.5,264 C616,315.5 570.5,311 562.5,312.5 C562.5,314.014254 567.442715,355.511507 570.5,379 C614.5,375.5 681,393.5 690,479 C692.741832,505.047404 681,547.5 651,573.5 C604.5,610.5 531,593.5 507.5,560 C453.5,497 489.499817,410.961006 538,389 C555.515297,381.069029 564.632589,381.542545 570.5,379 C570.5,372.5 566.5,334 562.5,312.5 C555,311.5 504.5,321 455.5,278 C406.5,235 410,168 405.5,168 C403.466795,168 345,172.5 328.5,172.5 C330,200.5 324,233 309,264 C301.225342,280.067627 285.5,303 253.5,321.5 C229.841804,335.177395 203.50847,342.010728 174.5,342"
}, null, -1), Q1 = [
  J1
];
function en(e, t) {
  return s(), o("svg", G1, Q1);
}
const tn = /* @__PURE__ */ d(q1, [["render", en]]);
const nn = {
  name: "CoreLoader",
  components: {
    Logo: tn
  },
  props: {
    small: {
      default: !1,
      type: Boolean
    },
    filled: {
      default: !1,
      type: Boolean
    },
    showProgress: {
      default: !1,
      type: Boolean
    },
    progress: {
      default: null,
      type: String
    },
    customIcon: {
      default: null,
      type: String
    }
  }
}, sn = { class: "cc-ui-loader__wrapper" }, on = {
  key: 2,
  class: "cc-ui-loader__progress"
};
function an(e, t, n, c, r, i) {
  const _ = S("Logo");
  return s(), o("div", {
    class: A({
      "cc-ui-loader": !0,
      "cc-ui-loader--small": n.small,
      "cc-ui-loader--bg": n.filled
    })
  }, [
    y("div", sn, [
      n.customIcon ? (s(), T(Le(n.customIcon), { key: 0 })) : (s(), T(_, { key: 1 })),
      n.showProgress ? (s(), o("p", on, B(n.progress), 1)) : k("", !0)
    ])
  ], 2);
}
const ln = /* @__PURE__ */ d(nn, [["render", an]]);
var xe = { exports: {} }, Ze;
function Pe() {
  return Ze || (Ze = 1, function(e, t) {
    (function(n, c) {
      e.exports = c();
    })(fe, function() {
      var n = 1e3, c = 6e4, r = 36e5, i = "millisecond", _ = "second", a = "minute", l = "hour", f = "day", I = "week", $ = "month", N = "quarter", O = "year", X = "date", J = "Invalid Date", U = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, ie = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, se = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(C) {
        var g = ["th", "st", "nd", "rd"], h = C % 100;
        return "[" + C + (g[(h - 20) % 10] || g[h] || g[0]) + "]";
      } }, ce = function(C, g, h) {
        var p = String(C);
        return !p || p.length >= g ? C : "" + Array(g + 1 - p.length).join(h) + C;
      }, me = { s: ce, z: function(C) {
        var g = -C.utcOffset(), h = Math.abs(g), p = Math.floor(h / 60), m = h % 60;
        return (g <= 0 ? "+" : "-") + ce(p, 2, "0") + ":" + ce(m, 2, "0");
      }, m: function C(g, h) {
        if (g.date() < h.date())
          return -C(h, g);
        var p = 12 * (h.year() - g.year()) + (h.month() - g.month()), m = g.clone().add(p, $), M = h - m < 0, u = g.clone().add(p + (M ? -1 : 1), $);
        return +(-(p + (h - m) / (M ? m - u : u - m)) || 0);
      }, a: function(C) {
        return C < 0 ? Math.ceil(C) || 0 : Math.floor(C);
      }, p: function(C) {
        return { M: $, y: O, w: I, d: f, D: X, h: l, m: a, s: _, ms: i, Q: N }[C] || String(C || "").toLowerCase().replace(/s$/, "");
      }, u: function(C) {
        return C === void 0;
      } }, Q = "en", H = {};
      H[Q] = se;
      var Y = "$isDayjsObject", ee = function(C) {
        return C instanceof re || !(!C || !C[Y]);
      }, te = function C(g, h, p) {
        var m;
        if (!g)
          return Q;
        if (typeof g == "string") {
          var M = g.toLowerCase();
          H[M] && (m = M), h && (H[M] = h, m = M);
          var u = g.split("-");
          if (!m && u.length > 1)
            return C(u[0]);
        } else {
          var v = g.name;
          H[v] = g, m = v;
        }
        return !p && m && (Q = m), m || !p && Q;
      }, P = function(C, g) {
        if (ee(C))
          return C.clone();
        var h = typeof g == "object" ? g : {};
        return h.date = C, h.args = arguments, new re(h);
      }, D = me;
      D.l = te, D.i = ee, D.w = function(C, g) {
        return P(C, { locale: g.$L, utc: g.$u, x: g.$x, $offset: g.$offset });
      };
      var re = function() {
        function C(h) {
          this.$L = te(h.locale, null, !0), this.parse(h), this.$x = this.$x || h.x || {}, this[Y] = !0;
        }
        var g = C.prototype;
        return g.parse = function(h) {
          this.$d = function(p) {
            var m = p.date, M = p.utc;
            if (m === null)
              return /* @__PURE__ */ new Date(NaN);
            if (D.u(m))
              return /* @__PURE__ */ new Date();
            if (m instanceof Date)
              return new Date(m);
            if (typeof m == "string" && !/Z$/i.test(m)) {
              var u = m.match(U);
              if (u) {
                var v = u[2] - 1 || 0, L = (u[7] || "0").substring(0, 3);
                return M ? new Date(Date.UTC(u[1], v, u[3] || 1, u[4] || 0, u[5] || 0, u[6] || 0, L)) : new Date(u[1], v, u[3] || 1, u[4] || 0, u[5] || 0, u[6] || 0, L);
              }
            }
            return new Date(m);
          }(h), this.init();
        }, g.init = function() {
          var h = this.$d;
          this.$y = h.getFullYear(), this.$M = h.getMonth(), this.$D = h.getDate(), this.$W = h.getDay(), this.$H = h.getHours(), this.$m = h.getMinutes(), this.$s = h.getSeconds(), this.$ms = h.getMilliseconds();
        }, g.$utils = function() {
          return D;
        }, g.isValid = function() {
          return this.$d.toString() !== J;
        }, g.isSame = function(h, p) {
          var m = P(h);
          return this.startOf(p) <= m && m <= this.endOf(p);
        }, g.isAfter = function(h, p) {
          return P(h) < this.startOf(p);
        }, g.isBefore = function(h, p) {
          return this.endOf(p) < P(h);
        }, g.$g = function(h, p, m) {
          return D.u(h) ? this[p] : this.set(m, h);
        }, g.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, g.valueOf = function() {
          return this.$d.getTime();
        }, g.startOf = function(h, p) {
          var m = this, M = !!D.u(p) || p, u = D.p(h), v = function(de, W) {
            var le = D.w(m.$u ? Date.UTC(m.$y, W, de) : new Date(m.$y, W, de), m);
            return M ? le : le.endOf(f);
          }, L = function(de, W) {
            return D.w(m.toDate()[de].apply(m.toDate("s"), (M ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(W)), m);
          }, x = this.$W, z = this.$M, F = this.$D, he = "set" + (this.$u ? "UTC" : "");
          switch (u) {
            case O:
              return M ? v(1, 0) : v(31, 11);
            case $:
              return M ? v(1, z) : v(0, z + 1);
            case I:
              var ue = this.$locale().weekStart || 0, ve = (x < ue ? x + 7 : x) - ue;
              return v(M ? F - ve : F + (6 - ve), z);
            case f:
            case X:
              return L(he + "Hours", 0);
            case l:
              return L(he + "Minutes", 1);
            case a:
              return L(he + "Seconds", 2);
            case _:
              return L(he + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, g.endOf = function(h) {
          return this.startOf(h, !1);
        }, g.$set = function(h, p) {
          var m, M = D.p(h), u = "set" + (this.$u ? "UTC" : ""), v = (m = {}, m[f] = u + "Date", m[X] = u + "Date", m[$] = u + "Month", m[O] = u + "FullYear", m[l] = u + "Hours", m[a] = u + "Minutes", m[_] = u + "Seconds", m[i] = u + "Milliseconds", m)[M], L = M === f ? this.$D + (p - this.$W) : p;
          if (M === $ || M === O) {
            var x = this.clone().set(X, 1);
            x.$d[v](L), x.init(), this.$d = x.set(X, Math.min(this.$D, x.daysInMonth())).$d;
          } else
            v && this.$d[v](L);
          return this.init(), this;
        }, g.set = function(h, p) {
          return this.clone().$set(h, p);
        }, g.get = function(h) {
          return this[D.p(h)]();
        }, g.add = function(h, p) {
          var m, M = this;
          h = Number(h);
          var u = D.p(p), v = function(z) {
            var F = P(M);
            return D.w(F.date(F.date() + Math.round(z * h)), M);
          };
          if (u === $)
            return this.set($, this.$M + h);
          if (u === O)
            return this.set(O, this.$y + h);
          if (u === f)
            return v(1);
          if (u === I)
            return v(7);
          var L = (m = {}, m[a] = c, m[l] = r, m[_] = n, m)[u] || 1, x = this.$d.getTime() + h * L;
          return D.w(x, this);
        }, g.subtract = function(h, p) {
          return this.add(-1 * h, p);
        }, g.format = function(h) {
          var p = this, m = this.$locale();
          if (!this.isValid())
            return m.invalidDate || J;
          var M = h || "YYYY-MM-DDTHH:mm:ssZ", u = D.z(this), v = this.$H, L = this.$m, x = this.$M, z = m.weekdays, F = m.months, he = m.meridiem, ue = function(W, le, ye, Ce) {
            return W && (W[le] || W(p, M)) || ye[le].slice(0, Ce);
          }, ve = function(W) {
            return D.s(v % 12 || 12, W, "0");
          }, de = he || function(W, le, ye) {
            var Ce = W < 12 ? "AM" : "PM";
            return ye ? Ce.toLowerCase() : Ce;
          };
          return M.replace(ie, function(W, le) {
            return le || function(ye) {
              switch (ye) {
                case "YY":
                  return String(p.$y).slice(-2);
                case "YYYY":
                  return D.s(p.$y, 4, "0");
                case "M":
                  return x + 1;
                case "MM":
                  return D.s(x + 1, 2, "0");
                case "MMM":
                  return ue(m.monthsShort, x, F, 3);
                case "MMMM":
                  return ue(F, x);
                case "D":
                  return p.$D;
                case "DD":
                  return D.s(p.$D, 2, "0");
                case "d":
                  return String(p.$W);
                case "dd":
                  return ue(m.weekdaysMin, p.$W, z, 2);
                case "ddd":
                  return ue(m.weekdaysShort, p.$W, z, 3);
                case "dddd":
                  return z[p.$W];
                case "H":
                  return String(v);
                case "HH":
                  return D.s(v, 2, "0");
                case "h":
                  return ve(1);
                case "hh":
                  return ve(2);
                case "a":
                  return de(v, L, !0);
                case "A":
                  return de(v, L, !1);
                case "m":
                  return String(L);
                case "mm":
                  return D.s(L, 2, "0");
                case "s":
                  return String(p.$s);
                case "ss":
                  return D.s(p.$s, 2, "0");
                case "SSS":
                  return D.s(p.$ms, 3, "0");
                case "Z":
                  return u;
              }
              return null;
            }(W) || u.replace(":", "");
          });
        }, g.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, g.diff = function(h, p, m) {
          var M, u = this, v = D.p(p), L = P(h), x = (L.utcOffset() - this.utcOffset()) * c, z = this - L, F = function() {
            return D.m(u, L);
          };
          switch (v) {
            case O:
              M = F() / 12;
              break;
            case $:
              M = F();
              break;
            case N:
              M = F() / 3;
              break;
            case I:
              M = (z - x) / 6048e5;
              break;
            case f:
              M = (z - x) / 864e5;
              break;
            case l:
              M = z / r;
              break;
            case a:
              M = z / c;
              break;
            case _:
              M = z / n;
              break;
            default:
              M = z;
          }
          return m ? M : D.a(M);
        }, g.daysInMonth = function() {
          return this.endOf($).$D;
        }, g.$locale = function() {
          return H[this.$L];
        }, g.locale = function(h, p) {
          if (!h)
            return this.$L;
          var m = this.clone(), M = te(h, p, !0);
          return M && (m.$L = M), m;
        }, g.clone = function() {
          return D.w(this.$d, this);
        }, g.toDate = function() {
          return new Date(this.valueOf());
        }, g.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, g.toISOString = function() {
          return this.$d.toISOString();
        }, g.toString = function() {
          return this.$d.toUTCString();
        }, C;
      }(), _e = re.prototype;
      return P.prototype = _e, [["$ms", i], ["$s", _], ["$m", a], ["$H", l], ["$W", f], ["$M", $], ["$y", O], ["$D", X]].forEach(function(C) {
        _e[C[1]] = function(g) {
          return this.$g(g, C[0], C[1]);
        };
      }), P.extend = function(C, g) {
        return C.$i || (C(g, re, P), C.$i = !0), P;
      }, P.locale = te, P.isDayjs = ee, P.unix = function(C) {
        return P(1e3 * C);
      }, P.en = H[Q], P.Ls = H, P.p = {}, P;
    });
  }(xe)), xe.exports;
}
var cn = Pe();
const Me = /* @__PURE__ */ Oe(cn);
var rn = { exports: {} };
(function(e, t) {
  (function(n, c) {
    e.exports = c(Pe());
  })(fe, function(n) {
    function c(_) {
      return _ && typeof _ == "object" && "default" in _ ? _ : { default: _ };
    }
    var r = c(n), i = { name: "en-gb", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), weekStart: 1, yearStart: 4, relativeTime: { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd, D MMMM YYYY HH:mm" }, ordinal: function(_) {
      var a = ["th", "st", "nd", "rd"], l = _ % 100;
      return "[" + _ + (a[(l - 20) % 10] || a[l] || a[0]) + "]";
    } };
    return r.default.locale(i, null, !0), i;
  });
})(rn);
const un = {
  name: "CognitiveNotification",
  inject: ["eventBus"],
  props: {
    notification: {
      default: null,
      type: Object
    },
    action: {
      default: null,
      type: Function
    },
    args: {
      default: null,
      type: Object
    }
  },
  computed: {
    notificationType() {
      return this.notification.data.type.slice(this.notification.data.type.lastIndexOf(":") + 1) === "financials" ? "financial" : "description";
    },
    notificationCopy() {
      var e, t, n, c, r, i, _;
      return (t = (e = this.notification.data) == null ? void 0 : e.company) != null && t.name ? `There is a newer version of <b>${(r = (c = (n = this.notification) == null ? void 0 : n.data) == null ? void 0 : c.company) == null ? void 0 : r.name}</b> ${this.notificationType} data, updated at ${this.formatDate((_ = (i = this.notification) == null ? void 0 : i.data) == null ? void 0 : _.dateTime)}` : "A newer version of the data is available";
    }
  },
  methods: {
    handleAction() {
      this.action && (this.args ? this.action(this.args) : this.action);
    },
    viewUpdatedData() {
      var c, r, i, _;
      const e = (r = (c = this.notification) == null ? void 0 : c.data) == null ? void 0 : r.type.toString().split(":")[2], t = (_ = (i = this.notification.data) == null ? void 0 : i.company) == null ? void 0 : _.id, n = `/company/${t}/${e === "financials" ? "financials" : "description"}`;
      e === "financials" && this.eventBus.$emit("cc:notification:view", t), this.action && (this.args ? this.action(this.args) : this.action), n === this.$route.path ? this.$router.go() : this.$router.push(n);
    },
    formatDate(e) {
      if (e)
        return Me(e).format("DD MMM YYYY, H:mm");
    }
  }
}, dn = { class: "cc-ui-notification" };
function _n(e, t, n, c, r, i) {
  const _ = S("cognitive-paragraph"), a = S("cognitive-icon"), l = S("cognitive-button");
  return s(), o("article", dn, [
    w(_, {
      size: "xs",
      padding: "0 xs 0 0",
      class: "cc-ui-notification__copy",
      innerHTML: i.notificationCopy
    }, null, 8, ["innerHTML"]),
    n.action ? (s(), T(l, {
      key: 0,
      class: "cc-ui-notification__delete",
      onClick: i.handleAction
    }, {
      default: b(() => [
        w(a, {
          "icon-type": "css",
          "icon-name": "IconPlus",
          rotation: "45"
        })
      ]),
      _: 1
    }, 8, ["onClick"])) : k("", !0),
    w(l, {
      version: "primary",
      size: "sm",
      spaced: "",
      onClick: i.viewUpdatedData
    }, {
      default: b(() => [
        E(" view ")
      ]),
      _: 1
    }, 8, ["onClick"])
  ]);
}
const hn = /* @__PURE__ */ d(un, [["render", _n]]);
const fn = ge({
  name: "CognitiveParagraph",
  props: {
    inline: {
      default: !1,
      type: Boolean
    },
    italic: {
      default: !1,
      type: Boolean
    },
    size: {
      default: "",
      type: String,
      validator: (e) => ["", "xs", "sm", "md", "lg", "xl", "hg"].includes(e)
    },
    color: {
      default: "",
      type: String
    },
    ...ne
  },
  setup(e, { attrs: t }) {
    const n = oe(() => {
      let r = ["cc-ui-paragraph"];
      return e.inline && r.push("cc-ui-paragraph--inline"), e.italic && r.push("cc-ui-paragraph--italic"), e.size && r.push(`cc-ui-paragraph--${e.size}`), e.padding && G(e.padding) && r.push(G(e.padding)), t.class && r.push(t.class), r;
    }), c = oe(() => {
      let r = {};
      return e.color && (r.color = e.color), r;
    });
    return {
      classes: n,
      style: c
    };
  }
});
function gn(e, t, n, c, r, i) {
  return s(), o("p", j({
    class: e.classes,
    style: e.style
  }, e.$attrs), [
    V(e.$slots, "default")
  ], 16);
}
const mn = /* @__PURE__ */ d(fn, [["render", gn]]);
const vn = {
  name: "CognitiveResponsiveTable",
  props: {
    tableHeading: {
      default: () => [],
      type: Array,
      required: !0
    },
    rows: {
      default: () => [],
      type: Array
    },
    config: {
      default: null,
      type: Object
    },
    card: {
      default: !1,
      type: Boolean
    },
    boxes: {
      default: !1,
      type: Boolean
    },
    width: {
      default: null,
      type: String
    },
    dataTestHandle: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      sorting: Array.from({ length: this.tableHeading.length }, () => !1)
    };
  },
  methods: {
    sort(e, t) {
      e.action && (e.action(e.args), this.sorting[t] = !this.sorting[t]);
    },
    dynClassesHeading(e) {
      let t = "cc-ui-responsive-table-list__heading";
      return this.config && this.config.columns && this.config.columns[e] && (t += ` cc-ui-responsive-table-list__cell--${this.config.columns[e]} `), t += ` cc-ui-responsive-table-list__cell--${e}`, t;
    },
    dynClassesRow(e) {
      var n, c;
      let t = {
        "cc-ui-responsive-table-list__row": !0,
        "cc-ui-responsive-table-list__row--boxes": this.boxes
      };
      return (n = this.config) != null && n.offRows && ((c = this.config) == null ? void 0 : c.offRows.find((r) => r === e)) !== void 0 && (t["cc-ui-responsive-table-list__row--off"] = !0), t;
    },
    dynClassesColumn(e) {
      let t = `cc-ui-responsive-table-list__cell cc-ui-responsive-table-list__cell--${e}`;
      return this.config && this.config.actions && this.config.actions[e] && (t += " cc-ui-responsive-table-list__cell--actions"), t;
    },
    dynAlign(e) {
      return this.config && this.config.align && this.config.align[e] ? this.config.align[e] : "left";
    }
  }
}, yn = { class: "cc-ui-responsive-table-list__row" }, pn = ["align"], Ln = ["onClick"], Cn = ["data-label", "align"];
function bn(e, t, n, c, r, i) {
  const _ = S("cognitive-icon"), a = S("cognitive-block");
  return s(), T(a, {
    class: A({ "cc-ui-responsive-table-list": !0, "cc-ui-responsive-table-list__card": n.card }),
    "data-test-handle": n.dataTestHandle
  }, {
    default: b(() => [
      y("table", {
        class: "cc-ui-responsive-table-list__table",
        style: ae({ width: n.width || "100%" })
      }, [
        y("thead", null, [
          y("tr", yn, [
            (s(!0), o(Z, null, q(n.tableHeading, (l, f) => (s(), o("th", {
              key: `col-header-${f}`,
              scope: "col",
              class: A(i.dynClassesHeading(f)),
              align: i.dynAlign(f)
            }, [
              y("b", null, B(l.text), 1),
              l.action ? (s(), o("button", {
                key: 0,
                class: A({
                  "cc-ui-button": !0,
                  "cc-ui-button--link": !0
                }),
                "data-size": "sm",
                onClick: (I) => i.sort(l, f)
              }, [
                w(_, {
                  "icon-type": "css",
                  "icon-name": "IconArrow",
                  rotation: r.sorting[f] ? "180" : "0"
                }, null, 8, ["rotation"])
              ], 8, Ln)) : k("", !0)
            ], 10, pn))), 128))
          ])
        ]),
        y("tbody", null, [
          n.rows && n.rows.length > 0 ? (s(!0), o(Z, { key: 0 }, q(n.rows, (l, f) => (s(), o("tr", {
            key: `card-${f}`,
            class: A(i.dynClassesRow(f))
          }, [
            (s(!0), o(Z, null, q(n.tableHeading, (I, $) => (s(), o("td", {
              key: `data-${$}`,
              class: A(i.dynClassesColumn($)),
              "data-label": n.tableHeading[$].text,
              align: i.dynAlign($)
            }, [
              V(e.$slots, `td-${$}`, {
                item: l,
                index: f
              })
            ], 10, Cn))), 128))
          ], 2))), 128)) : k("", !0)
        ])
      ], 4)
    ]),
    _: 3
  }, 8, ["class", "data-test-handle"]);
}
const Mn = /* @__PURE__ */ d(vn, [["render", bn]]);
const $n = {
  name: "CoreTable",
  props: {
    headers: {
      default: () => [],
      type: Array
    },
    rows: {
      default: () => [],
      type: Array
    },
    zebra: {
      default: !1,
      type: Boolean
    },
    smallColumn: {
      default: () => [],
      type: Array
    },
    smallColumnWidth: {
      default: 10,
      type: Number
    },
    centerAlign: {
      default: () => [],
      type: Array
    },
    rightAlign: {
      default: () => [],
      type: Array
    },
    colCount: {
      default: 1,
      type: Number
    },
    sortable: {
      default: !1,
      type: Boolean
    },
    rowHeightSmall: {
      default: !1,
      type: Boolean
    },
    tableMinWidth: {
      default: null,
      type: Number
    },
    textExpanded: {
      default: !1,
      type: Boolean
    },
    dataTestHandle: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      sorting: this.headers.length > 0 && Array.from({ length: this.headers.length }, () => !1) || []
    };
  },
  computed: {
    totCols() {
      var e, t;
      return ((e = this.headers) == null ? void 0 : e.length) > 0 ? this.headers.length : ((t = this.rows) == null ? void 0 : t.length) > 0 ? Object.keys(this.rows[0]).length : this.colCount !== null ? this.colCount : 1;
    }
  },
  methods: {
    sort(e, t) {
      e.action && (e.action(e.args), this.sorting[t] = !this.sorting[t]);
    },
    styleSettings(e, t) {
      switch (e) {
        case "width": {
          let n = this.totCols - this.smallColumn.length, c = 100 - this.smallColumn.length * this.smallColumnWidth;
          return this.smallColumn.length ? this.smallColumn.indexOf(t) > -1 ? `${this.smallColumnWidth}%` : `${c / n}%` : `${100 / this.totCols}%`;
        }
        case "textAlign":
          return this.centerAlign.length || this.rightAlign.length ? this.centerAlign.indexOf(t) > -1 ? "center" : this.rightAlign.indexOf(t) > -1 ? "right" : "left" : "left";
        case "minWidth":
          if (this.tableMinWidth !== null)
            return `${this.tableMinWidth}px`;
          break;
        default:
          return;
      }
    }
  }
}, xn = {
  key: 0,
  class: "cc-ui-table__row",
  role: "row"
}, Sn = ["onClick"], wn = { key: 2 };
function kn(e, t, n, c, r, i) {
  const _ = S("cognitive-icon"), a = S("cognitive-button"), l = S("cognitive-block");
  return s(), T(l, {
    class: "cc-ui-table",
    "data-test-handle": n.dataTestHandle
  }, {
    default: b(() => [
      y("div", {
        class: "cc-ui-table__wrapper",
        role: "table",
        style: ae({ minWidth: i.styleSettings("minWidth") })
      }, [
        n.headers && n.headers.length > 0 ? (s(), o("div", xn, [
          (s(!0), o(Z, null, q(n.headers, (f, I) => (s(), o("div", {
            key: `header-${I}`,
            class: A({ "cc-ui-table__column": !0, "cc-ui-table__column--collapse": !n.textExpanded }),
            role: "columnheader",
            style: ae({
              width: i.styleSettings("width", I),
              textAlign: i.styleSettings("textAlign", I)
            })
          }, [
            n.sortable ? (s(), o(Z, { key: 0 }, [
              y("b", null, B(f.text), 1),
              f.action ? (s(), o("button", {
                key: 0,
                class: A({
                  "cc-ui-button": !0,
                  "cc-ui-button--link": !0,
                  "cc-ui-table__sort": !0
                }),
                onClick: ($) => i.sort(f, I)
              }, [
                w(_, {
                  "icon-type": "css",
                  "icon-name": "IconArrow",
                  rotation: r.sorting[I] ? "180" : "0"
                }, null, 8, ["rotation"])
              ], 8, Sn)) : k("", !0)
            ], 64)) : k("", !0),
            f.tooltip ? (s(), o("div", {
              key: 1,
              class: A({
                "cc-ui-table__tooltip": !0,
                "cc-ui-table__tooltip-wide": f.wideTooltip
              })
            }, [
              y("b", null, B(f.text), 1),
              w(a, {
                version: "link",
                "data-title-top-left": f.tooltip
              }, {
                default: b(() => [
                  w(_, {
                    "icon-type": "css",
                    "icon-name": "IconHelp"
                  })
                ]),
                _: 2
              }, 1032, ["data-title-top-left"])
            ], 2)) : (s(), o("b", wn, B(f.text), 1))
          ], 6))), 128))
        ])) : k("", !0),
        n.rows && n.rows.length > 0 ? (s(!0), o(Z, { key: 1 }, q(n.rows, (f, I) => (s(), o("div", {
          key: `row-${I - 1}`,
          class: A({
            "cc-ui-table__row": !0,
            "cc-ui-table__row--smaller": n.rowHeightSmall,
            "cc-ui-table__row--zebra": n.zebra
          }),
          role: "row"
        }, [
          (s(!0), o(Z, null, q(i.totCols, ($, N) => (s(), o("div", {
            key: `data-${N}`,
            class: A({ "cc-ui-table__column": !0, "cc-ui-table__column--collapse": !n.textExpanded }),
            role: "cell",
            style: ae({
              width: i.styleSettings("width", N),
              textAlign: i.styleSettings("textAlign", N)
            })
          }, [
            V(e.$slots, `td-${N}`, {
              item: f,
              index: I
            })
          ], 6))), 128))
        ], 2))), 128)) : k("", !0)
      ], 4)
    ]),
    _: 3
  }, 8, ["data-test-handle"]);
}
const In = /* @__PURE__ */ d($n, [["render", kn]]);
const zn = {
  name: "CoreTabs",
  props: {
    ...ne,
    tabHeaders: {
      default: () => [],
      type: Array
    },
    defaultTab: {
      default: null,
      type: Number
    },
    theme: {
      default: null,
      type: String
    },
    vertical: {
      default: !1,
      type: Boolean
    },
    size: {
      default: null,
      type: String
    },
    dataTestHandle: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      activeContentTab: 0
    };
  },
  computed: {
    ...be,
    dynClasses() {
      return {
        "cc-ui-tabs": !0,
        "cc-ui-tabs--vertical": this.vertical,
        [this.dynPadClasses]: !0
      };
    }
  },
  created() {
    this.defaultTab && this.defaultTab > 0 && (this.activeContentTab = this.defaultTab);
  },
  methods: {
    tabAction(e) {
      var t, n;
      this.activeContentTab = e, typeof ((t = this.tabHeaders[e]) == null ? void 0 : t.action) == "function" && ((n = this.tabHeaders[e]) != null && n.args ? this.tabHeaders[e].action(this.tabHeaders[e].args) : this.tabHeaders[e].action());
    }
  }
};
function Tn(e, t, n, c, r, i) {
  const _ = S("cognitive-button"), a = S("cognitive-list-item"), l = S("cognitive-list"), f = S("cognitive-block");
  return s(), T(f, {
    class: A(i.dynClasses),
    "data-test-handle": n.dataTestHandle
  }, {
    default: b(() => [
      w(l, { class: "cc-ui-tabs__navigation" }, {
        default: b(() => [
          (s(!0), o(Z, null, q(n.tabHeaders, (I, $) => (s(), T(a, {
            key: `tab-${$}`,
            inline: !n.vertical,
            class: A({
              "cc-ui-tabs__link": !0,
              "cc-ui-tabs__link--white": n.theme === "dark"
            })
          }, {
            default: b(() => [
              w(_, {
                version: "link",
                size: n.size,
                class: A({ "is-active": r.activeContentTab === $ }),
                "data-test-handle": `${n.dataTestHandle}-tabbutton-${$}`,
                onClick: (N) => i.tabAction($)
              }, {
                default: b(() => [
                  E(B(I.title), 1)
                ]),
                _: 2
              }, 1032, ["size", "class", "data-test-handle", "onClick"])
            ]),
            _: 2
          }, 1032, ["inline", "class"]))), 128))
        ]),
        _: 1
      }),
      w(l, { class: "cc-ui-tabs__content" }, {
        default: b(() => [
          (s(!0), o(Z, null, q(n.tabHeaders, (I, $) => (s(), T(a, {
            key: `header-${$}`,
            class: A({ "cc-ui-tabs__tab": !0, "cc-ui-tabs__tab--visible": r.activeContentTab === $ }),
            "data-test-handle": `${n.dataTestHandle}-tabcontent-${$}`
          }, {
            default: b(() => [
              V(e.$slots, `tabContent${$}`)
            ]),
            _: 2
          }, 1032, ["class", "data-test-handle"]))), 128))
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["class", "data-test-handle"]);
}
const Hn = /* @__PURE__ */ d(zn, [["render", Tn]]);
const Dn = ge({
  name: "CognitiveTag",
  props: {
    textColor: {
      default: "inherit",
      type: String
    },
    bgColor: {
      default: "inherit",
      type: String
    },
    size: {
      default: null,
      type: String
    },
    wide: {
      default: !1,
      type: Boolean
    },
    outline: {
      default: !1,
      type: Boolean
    }
  },
  setup(e, { attrs: t }) {
    const n = oe(() => {
      let r = ["cc-ui-tag"];
      return e.wide && r.push("cc-ui-tag--wide"), e.size && e.size.match(/xs|sm/) && r.push(`cc-ui-tag--${e.size}`), t.class && r.push(t.class), e.outline && r.push("cc-ui-tag--outline"), r;
    }), c = oe(() => {
      let r = {
        color: e.textColor,
        backgroundColor: e.bgColor
      };
      return e.outline && (r.borderColor = e.textColor, r.backgroundColor = "transparent"), r;
    });
    return {
      classes: n,
      style: c
    };
  }
});
function Zn(e, t, n, c, r, i) {
  return s(), o("span", j({
    class: e.classes,
    style: e.style
  }, e.$attrs), [
    V(e.$slots, "default")
  ], 16);
}
const Bn = /* @__PURE__ */ d(Dn, [["render", Zn]]);
const An = ge({
  name: "CoreTitle",
  props: {
    level: {
      default: 1,
      type: Number
    },
    version: {
      default: null,
      type: String
    },
    ...ne
  },
  computed: {
    tagName() {
      return `h${this.level}`;
    },
    classes() {
      let e = ["cc-ui-title"];
      return this.version && e.push(`cc-ui-title--${this.version}`), this.padding && G(this.padding) && e.push(G(this.padding)), e;
    }
  }
});
function Vn(e, t, n, c, r, i) {
  return s(), T(Le(e.tagName), j({ class: e.classes }, e.$attrs), {
    default: b(() => [
      V(e.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]);
}
const Nn = /* @__PURE__ */ d(An, [["render", Vn]]);
const On = {
  name: "CognitiveMessage",
  props: {
    status: {
      default: null,
      type: String
    },
    collapsible: {
      default: !1,
      type: Boolean
    },
    autoHideTime: {
      default: null,
      type: Number
    },
    hideAction: {
      default: null,
      type: Function
    },
    zIndex: {
      default: null,
      type: Number
    },
    position: {
      default: "absolute",
      type: String
    },
    contentPosition: {
      default: "left",
      type: String
    },
    hasClose: {
      default: !1,
      type: Boolean
    },
    textSize: {
      default: "sm",
      type: String
    },
    size: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      expanded: !0,
      closeMessage: !1,
      timer: null
    };
  },
  computed: {
    getStyle() {
      return {
        position: this.position,
        "z-index": this.zIndex
      };
    }
  },
  mounted() {
    this.autoHideTime && this.resetErrorMessage();
  },
  methods: {
    resetErrorMessage() {
      clearTimeout(this.timer), this.timer = setTimeout(() => {
        this.hideAction();
      }, this.autoHideTime);
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    toggleMessage() {
      this.closeMessage = !this.closeMessage, this.hideAction && this.hideAction();
    }
  }
}, Pn = ["data-height"];
function En(e, t, n, c, r, i) {
  const _ = S("cognitive-icon"), a = S("cognitive-button"), l = S("cognitive-paragraph");
  return n.status && !r.closeMessage ? (s(), o("div", {
    key: 0,
    "data-height": n.size,
    style: ae(i.getStyle),
    class: A({
      "cognitive-message": !0,
      "cognitive-message--success": n.status === "success",
      "cognitive-message--warning": n.status === "warning",
      "cognitive-message--error": n.status === "error",
      "cognitive-message--right": n.contentPosition === "right",
      "cognitive-message--left": n.contentPosition === "left",
      "cognitive-message__collapsible": n.collapsible && !r.expanded
    })
  }, [
    n.collapsible ? (s(), T(a, {
      key: 0,
      version: "link",
      onClick: i.toggleExpand
    }, {
      default: b(() => [
        w(_, {
          "icon-type": "css",
          "icon-name": r.expanded ? "IconMinus" : "IconPlus"
        }, null, 8, ["icon-name"])
      ]),
      _: 1
    }, 8, ["onClick"])) : k("", !0),
    w(l, {
      size: n.textSize,
      class: "cognitive-message__message cognitive-message__content"
    }, {
      default: b(() => [
        V(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["size"]),
    n.hasClose ? (s(), T(a, {
      key: 1,
      ref: "IconClose",
      version: "link",
      size: "sm",
      class: "cognitive-message__content",
      onClick: i.toggleMessage
    }, {
      default: b(() => [
        w(_, {
          "icon-type": "css",
          "icon-name": "IconPlus",
          rotation: "45"
        })
      ]),
      _: 1
    }, 8, ["onClick"])) : k("", !0)
  ], 14, Pn)) : k("", !0);
}
const Fn = /* @__PURE__ */ d(On, [["render", En]]);
const Kn = {
  name: "CognitiveExpandable",
  props: {
    ...ne,
    bgColor: {
      default: null,
      type: String
    },
    textColor: {
      default: null,
      type: String
    },
    toggleAction: {
      default: null,
      type: Function
    },
    defaultHeight: {
      default: "2rem",
      type: String
    },
    collapseOnLoad: {
      default: !1,
      type: Boolean
    },
    dataTestHandle: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      expanded: !0
    };
  },
  computed: {
    dynStyle() {
      const e = {};
      return this.bgColor && (e["background-color"] = this.bgColor), this.textColor && (e.color = this.textColor), this.defaultHeight && !this.expanded && (e["max-height"] = this.defaultHeight), e;
    },
    dynClasses() {
      let e = "cc-ui-expandable";
      return this.padding && (e += ` ${G(this.padding)}`), this.expanded && (e += " cc-ui-expandable--expanded"), e;
    }
  },
  created() {
    this.collapseOnLoad && (this.expanded = !1);
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded, this.toggleAction && this.toggleAction(this.expanded);
    }
  }
};
function Yn(e, t, n, c, r, i) {
  const _ = S("cognitive-block"), a = S("cognitive-icon"), l = S("cognitive-button");
  return s(), T(_, {
    class: A(i.dynClasses),
    style: ae(i.dynStyle),
    "data-test-handle": n.dataTestHandle
  }, {
    default: b(() => [
      w(_, { class: "cc-ui-expandable__content" }, {
        default: b(() => [
          V(e.$slots, "default")
        ]),
        _: 3
      }),
      w(l, {
        version: "link",
        onClick: i.toggleExpand
      }, {
        default: b(() => [
          w(a, {
            "icon-type": "css",
            "icon-name": r.expanded ? "IconMinus" : "IconPlus"
          }, null, 8, ["icon-name"])
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 3
  }, 8, ["class", "style", "data-test-handle"]);
}
const Rn = /* @__PURE__ */ d(Kn, [["render", Yn]]);
const { mapActions: jn, mapGetters: Un } = Je("Modal"), Wn = {
  name: "CoreModal",
  beforeRouteLeave(e, t, n) {
    n((c) => {
      c.closeModal({ name: c.name, reset: c.reset });
    });
  },
  props: {
    name: {
      default: null,
      type: String,
      required: !0
    },
    autoOpen: {
      default: !1,
      type: Boolean
    },
    reset: {
      default: !1,
      type: Boolean
    },
    titled: {
      default: !1,
      type: Boolean
    },
    fullscreen: {
      default: !1,
      type: Boolean
    },
    extended: {
      default: !1,
      type: Boolean
    },
    ctaDismissOnly: {
      default: !1,
      type: Boolean
    },
    hideCloseIcon: {
      default: !1,
      type: Boolean
    },
    draggable: {
      default: !1,
      type: Boolean
    },
    w: {
      default: 200,
      type: Number
    },
    h: {
      default: 100,
      type: Number
    },
    top: {
      default: 0,
      type: Number
    },
    left: {
      default: 0,
      type: Number
    },
    minw: {
      default: 0,
      type: Number
    },
    minh: {
      default: 0,
      type: Number
    },
    onClose: {
      default: null,
      type: Function
    },
    onResizeStart: {
      default: null,
      type: Function
    },
    onResize: {
      default: null,
      type: Function
    },
    onResizeStop: {
      default: null,
      type: Function
    },
    beforeClose: {
      default: null,
      type: Function
    },
    noResize: {
      default: !1,
      type: Boolean
    },
    dataTestHandle: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      showOnTop: !1,
      pos1: 0,
      pos2: 0,
      pos3: 0,
      pos4: 0,
      origWidth: this.w || 0,
      origHeight: this.h || 0,
      origX: this.left || 0,
      origY: this.top || 0,
      origMouseX: 0,
      origMouseY: 0,
      minStep: 10,
      resizeState: null,
      uid: ""
    };
  },
  computed: {
    ...Un(["modals", "selectedModal"]),
    currentModal() {
      var t;
      const e = (t = this.modals) == null ? void 0 : t.filter((n) => n.name === this.name)[0];
      return e || !1;
    },
    isModalVisible() {
      var e;
      return (e = this.currentModal) == null ? void 0 : e.visible;
    },
    defaultDialogStyle() {
      return {
        width: `${this.origWidth}px`,
        height: `${this.origHeight}px`,
        position: "absolute",
        top: `${this.origY}px`,
        left: `${this.origX}px`
      };
    },
    dynClasses() {
      return {
        "cc-ui-modal": !0,
        "cc-ui-modal--open": this.isModalVisible,
        "cc-ui-modal--titled": this.titled,
        "cc-ui-modal--extended": this.extended,
        "cc-ui-modal--fullscreen": this.fullscreen,
        "cc-ui-modal--draggable": this.draggable,
        "cc-ui-modal--active": this.draggable && this.selectedModal === this.uid
      };
    }
  },
  watch: {
    isModalVisible(e) {
      if (e && this.toggleBodyClass(), !e) {
        this.showOnTop = !1, this.toggleBodyClass("remove");
        return;
      }
      this.selectedModal !== this.uid && this.selectModal(this.uid);
    },
    selectedModal() {
      this.selectedModal ? this.showOnTop = this.selectedModal === this.uid : this.showOnTop = !1;
    }
  },
  created() {
    this.createModal({ name: this.name }), this.uid = crypto.randomUUID(), this.selectModal(this.uid), this.showOnTop = !0, this.autoOpen && this.openModal({ name: this.name });
  },
  methods: {
    ...jn(["closeModal", "createModal", "selectModal", "openModal"]),
    /**
     * Attach/Detach the class 'is-modal-visible' to the body
     * in order to better handling the CSS of components relying on the modals state
     * @param { String } action - The action to add or remove the class
     */
    toggleBodyClass(e) {
      const t = this.modals.find((c) => c.visible), n = document.body.classList;
      if (e) {
        n[e]("is-modal-visible"), this.draggable && n[e]("is-draggable-modal-visible");
        return;
      }
      t && n.contains("is-modal-visible") || (t && !n.contains("is-modal-visible") ? (n.add("is-modal-visible"), this.draggable && n.add("is-draggable-modal-visible")) : (n.remove("is-modal-visible"), this.draggable && n.remove("is-draggable-modal-visible")));
    },
    hideModal(e) {
      if (!(e.classList && e.classList.contains("cc-ui-modal--fullscreen") || e.classList && e.classList.contains("cc-ui-modal") && this.ctaDismissOnly)) {
        if (this.beforeClose) {
          this.showOnTop = !1, this.beforeClose();
          return;
        }
        this.onClose && this.onClose(), this.closeModal({ name: this.name, reset: this.reset });
      }
    },
    dragDialog(e) {
      e = e || window.event, e.preventDefault(), !(e.touches && (e = e == null ? void 0 : e.touches[0], e.target.tagName !== "HEADER")) && (this.selectedModal !== this.uid && (this.selectModal(this.uid), this.showOnTop = !0), this.pos3 = e.clientX, this.pos4 = e.clientY, document.onmouseup = this.stopDragDialog, document.ontouchend = this.stopDragDialog, document.onmousemove = this.draggingDialog, document.ontouchmove = this.draggingDialog);
    },
    stopDragDialog() {
      document.onmouseup = null, document.onmousemove = null, document.ontouchend = null, document.ontouchmove = null;
    },
    draggingDialog(e) {
      if (e = e || window.event, e.touches && (e = e == null ? void 0 : e.touches[0], e.target.tagName !== "HEADER"))
        return;
      this.pos1 = this.pos3 - e.clientX, this.pos2 = this.pos4 - e.clientY, this.pos3 = e.clientX, this.pos4 = e.clientY;
      let t, n;
      const c = this.$refs.dialog.getBoundingClientRect();
      this.$refs.dialog.offsetLeft - this.pos1 + c.width > window.innerWidth ? t = window.innerWidth - c.width : this.$refs.dialog.offsetLeft - this.pos1 < 0 ? t = 0 : t = this.$refs.dialog.offsetLeft - this.pos1, this.$refs.dialog.offsetTop - this.pos2 + c.height > window.innerHeight ? n = window.innerHeight - c.height : this.$refs.dialog.offsetTop - this.pos2 < 0 ? n = 0 : n = this.$refs.dialog.offsetTop - this.pos2, this.origY = n, this.origX = t;
    },
    startResize(e) {
      e = e || window.event, e.touches && (e = e == null ? void 0 : e.touches[0]), e.preventDefault(), this.resizeState = e.target.title, this.onResizeStart && this.onResizeStart();
      const t = this.$refs.dialog;
      this.origWidth = parseFloat(getComputedStyle(t, null).getPropertyValue("width").replace("px", "")), this.origHeight = parseFloat(getComputedStyle(t, null).getPropertyValue("height").replace("px", "")), this.origMouseX = e.pageX, this.origMouseY = e.pageY, document.onmouseup = this.stopResize, document.ontouchend = this.stopResize, document.onmouseup = this.stopResize, document.ontouchend = this.stopResize, document.onmousemove = this.resizeDialog, document.ontouchmove = this.resizeDialog;
    },
    resizeDialog(e) {
      e.preventDefault();
      const t = this.$refs.dialog;
      this.onResize && this.onResize();
      let n, c;
      this.resizeState === "bottom-right" ? (n = this.origWidth + (e.clientX - this.origMouseX), c = this.origHeight + (e.clientY - this.origMouseY), n > this.minStep && n > this.minw && n + this.origX < window.innerWidth && (t.style.width = n + "px"), c > this.minStep && c > this.minh && c + this.origY < window.innerHeight && (t.style.height = c + "px")) : this.resizeState === "top-left" && (n = this.origWidth - (e.clientX - this.origMouseX), c = this.origHeight - (e.clientY - this.origMouseY), n > this.minStep && n > this.minw && this.origX + (e.clientX - this.origMouseX) > 0 && (t.style.width = n + "px", t.style.left = this.origX + (e.clientX - this.origMouseX) + "px"), c > this.minStep && c > this.minh && this.origY + (e.clientY - this.origMouseY) > 0 && (t.style.height = c + "px", t.style.top = this.origY + (e.clientY - this.origMouseY) + "px"));
    },
    stopResize(e) {
      let t, n;
      if (this.resizeState === "bottom-right" ? (t = this.origWidth + (e.clientX - this.origMouseX), n = this.origHeight + (e.clientY - this.origMouseY)) : this.resizeState === "top-left" && (t = this.origWidth - (e.clientX - this.origMouseX), n = this.origHeight - (e.clientY - this.origMouseY), this.origX = this.origX + (e.clientX - this.origMouseX), this.origY = this.origY + (e.clientY - this.origMouseY)), this.origWidth = t, this.origHeight = n, document.onmouseup = null, document.ontouchend = null, document.onmousemove = null, document.ontouchmove = null, this.resizeState = null, this.onResizeStop) {
        const c = this.$refs.dialog, r = getComputedStyle(c, null), i = {
          x: parseFloat(r.getPropertyValue("left").replace("px", "")),
          y: parseFloat(r.getPropertyValue("top").replace("px", "")),
          w: parseFloat(r.getPropertyValue("width").replace("px", "")),
          h: parseFloat(r.getPropertyValue("height").replace("px", ""))
        };
        this.onResizeStop(i.x, i.y, i.w, i.h);
      }
    }
  }
}, Xn = { class: "cc-ui-modal__content" }, qn = {
  key: 0,
  class: "resizers"
}, Gn = {
  key: 1,
  ref: "dialog",
  role: "dialog",
  class: "cc-ui-modal__dialog"
}, Jn = {
  key: 0,
  class: "cc-ui-modal__heading"
}, Qn = {
  key: 1,
  class: "cc-ui-modal__content"
};
function ei(e, t, n, c, r, i) {
  const _ = S("cognitive-icon"), a = S("cognitive-block");
  return s(), T(a, {
    tabindex: "0",
    class: A(i.dynClasses),
    "data-test-handle": n.dataTestHandle,
    onClick: t[9] || (t[9] = R((l) => n.draggable ? null : i.hideModal(l.target), ["self"]))
  }, {
    default: b(() => [
      n.draggable ? (s(), o("article", {
        key: 0,
        ref: "dialog",
        role: "dialog",
        class: "cc-ui-modal__dialog",
        style: ae(i.defaultDialogStyle),
        onClickCapture: t[7] || (t[7] = (l) => (e.selectModal(r.uid), i.stopDragDialog(), r.showOnTop = !0))
      }, [
        y("header", {
          class: "cc-ui-modal__heading",
          onMousedown: t[1] || (t[1] = (l) => i.dragDialog(l)),
          onMouseup: t[2] || (t[2] = (l) => i.stopDragDialog(l)),
          onTouchstart: t[3] || (t[3] = R((l) => i.dragDialog(l), ["stop"])),
          onTouchend: t[4] || (t[4] = R((l) => i.stopDragDialog(l), ["stop"]))
        }, [
          n.hideCloseIcon ? k("", !0) : (s(), o("button", {
            key: 0,
            class: "cc-ui-modal__close",
            onClick: t[0] || (t[0] = R((...l) => i.hideModal && i.hideModal(...l), ["stop"]))
          }, [
            w(_, {
              "icon-type": "css",
              "icon-name": "IconPlus",
              rotation: "45",
              width: "20",
              height: "20"
            })
          ]))
        ], 32),
        y("section", Xn, [
          V(e.$slots, "default")
        ]),
        n.noResize ? k("", !0) : (s(), o("div", qn, [
          y("div", {
            title: "top-left",
            class: "resizer top-left",
            onMousedown: t[5] || (t[5] = (l) => i.startResize(l))
          }, null, 32),
          y("div", {
            title: "bottom-right",
            class: "resizer bottom-right",
            onMousedown: t[6] || (t[6] = (l) => i.startResize(l))
          }, null, 32)
        ]))
      ], 36)) : (s(), o("article", Gn, [
        n.hideCloseIcon ? k("", !0) : (s(), o("header", Jn, [
          y("button", {
            class: "cc-ui-modal__close",
            onClick: t[8] || (t[8] = (...l) => i.hideModal && i.hideModal(...l))
          }, [
            w(_, {
              "icon-type": "css",
              "icon-name": "IconPlus",
              rotation: "45",
              width: "20",
              height: "20"
            })
          ])
        ])),
        i.isModalVisible ? (s(), o("section", Qn, [
          V(e.$slots, "default")
        ])) : k("", !0)
      ]))
    ]),
    _: 3
  }, 8, ["class", "data-test-handle"]);
}
const ti = /* @__PURE__ */ d(Wn, [["render", ei]]), ze = Qe("Modal", () => {
  const e = K([]), t = K(null);
  return {
    modals: e,
    selectedModal: t,
    updateModalData: ({ name: a, data: l }) => {
      const f = e.value.find((I) => I.name === a);
      f.data = l;
    },
    openModal: (a) => {
      const l = e.value.find((f) => f.name === a.name);
      l && (l.visible = !0), a.data && (l.data = a.data);
    },
    closeModal: (a) => {
      if (a) {
        const l = e.value.find((f) => f.name === a.name);
        l && (l.visible = !1, a.reset && (l.data = null));
      } else
        e.value = e.value.map((l) => (l.visible = !1, l));
    },
    createModal: ({ name: a, data: l }) => {
      if (!a || e.value.find((f) => f.name === a))
        return !1;
      e.value = [...e.value, { visible: !1, name: a, data: l }];
    },
    selectModal: (a) => {
      t.value = a;
    }
  };
});
const ni = ["onClick"], ii = { class: "cc-ui-modal__content" }, si = {
  key: 0,
  class: "resizers"
}, oi = {
  key: 1,
  ref: "dialog",
  role: "dialog",
  class: "cc-ui-modal__dialog"
}, ai = {
  key: 0,
  class: "cc-ui-modal__heading"
}, li = {
  key: 1,
  class: "cc-ui-modal__content"
}, ci = {
  __name: "CognitiveModalPinia",
  props: {
    name: {
      default: null,
      type: String,
      required: !0
    },
    autoOpen: {
      default: !1,
      type: Boolean
    },
    reset: {
      default: !1,
      type: Boolean
    },
    titled: {
      default: !1,
      type: Boolean
    },
    fullscreen: {
      default: !1,
      type: Boolean
    },
    extended: {
      default: !1,
      type: Boolean
    },
    ctaDismissOnly: {
      default: !1,
      type: Boolean
    },
    hideCloseIcon: {
      default: !1,
      type: Boolean
    },
    draggable: {
      default: !1,
      type: Boolean
    },
    w: {
      default: 200,
      type: Number
    },
    h: {
      default: 100,
      type: Number
    },
    top: {
      default: 0,
      type: Number
    },
    left: {
      default: 0,
      type: Number
    },
    minw: {
      default: 0,
      type: Number
    },
    minh: {
      default: 0,
      type: Number
    },
    onClose: {
      default: null,
      type: Function
    },
    onResizeStart: {
      default: null,
      type: Function
    },
    onResize: {
      default: null,
      type: Function
    },
    onResizeStop: {
      default: null,
      type: Function
    },
    beforeClose: {
      default: null,
      type: Function
    },
    noResize: {
      default: !1,
      type: Boolean
    },
    dataTestHandle: {
      default: null,
      type: String
    }
  },
  setup(e) {
    const t = e;
    tt((u, v, L) => {
      L((x) => {
        x.closeModal({ name: x.name, reset: x.reset });
      });
    });
    const n = K(null), c = K(!1), r = K(0), i = K(0), _ = K(0), a = K(0), l = K(t.w || 0), f = K(t.h || 0), I = K(t.left || 0), $ = K(t.top || 0), N = K(0), O = K(0), X = K(10), J = K(null), U = K(""), ie = ze(), { selectModal: se, createModal: ce, openModal: me, closeModal: Q } = ie, { modals: H, selectedModal: Y } = et(ie), ee = oe(() => {
      var v;
      const u = (v = H.value) == null ? void 0 : v.find((L) => L.name === t.name);
      return u || !1;
    }), te = oe(() => {
      var u;
      return (u = ee.value) == null ? void 0 : u.visible;
    }), P = oe(() => ({
      width: `${l.value}px`,
      height: `${f.value}px`,
      position: "absolute",
      top: `${$.value}px`,
      left: `${I.value}px`
    })), D = oe(() => ({
      "cc-ui-modal": !0,
      "cc-ui-modal--open": te.value,
      "cc-ui-modal--titled": t.titled,
      "cc-ui-modal--extended": t.extended,
      "cc-ui-modal--fullscreen": t.fullscreen,
      "cc-ui-modal--draggable": t.draggable,
      "cc-ui-modal--active": t.draggable && Y.value === U.value
    }));
    Te(
      () => te,
      (u) => {
        if (u && re(), !u) {
          c.value = !1, re("remove");
          return;
        }
        Y.value !== U.value && se(U);
      }
    ), Te(
      () => Y,
      (u) => {
        u ? c.value = u === U.value : c.value = !1;
      }
    ), ce({ name: t.name }), U.value = crypto.randomUUID(), se(U.value), c.value = !0, t.autoOpen && me({ name: t.name });
    const re = (u) => {
      const v = H.find((x) => x.visible), L = document.body.classList;
      if (u) {
        L[u]("is-modal-visible"), t.draggable && L[u]("is-draggable-modal-visible");
        return;
      }
      v && L.contains("is-modal-visible") || (v && !L.contains("is-modal-visible") ? (L.add("is-modal-visible"), t.draggable && L.add("is-draggable-modal-visible")) : (L.remove("is-modal-visible"), t.draggable && L.remove("is-draggable-modal-visible")));
    }, _e = (u) => {
      if (!(u.classList && u.classList.contains("cc-ui-modal--fullscreen") || u.classList && u.classList.contains("cc-ui-modal") && t.ctaDismissOnly)) {
        if (t.beforeClose) {
          c.value = !1, t.beforeClose();
          return;
        }
        t.onClose && t.onClose(), Q({ name: t.name, reset: t.reset });
      }
    }, C = (u) => {
      u = u || window.event, u.preventDefault(), !(u.touches && (u = u == null ? void 0 : u.touches[0], u.target.tagName !== "HEADER")) && (Y !== U.value && (se(U), c.value = !0), _.value = u.clientX, a.value = u.clientY, document.onmouseup = g, document.ontouchend = g, document.onmousemove = h, document.ontouchmove = h);
    }, g = () => {
      document.onmouseup = null, document.onmousemove = null, document.ontouchend = null, document.ontouchmove = null;
    }, h = (u) => {
      if (u = u || window.event, u.touches && (u = u == null ? void 0 : u.touches[0], u.target.tagName !== "HEADER"))
        return;
      r.value = _.value - u.clientX, i.value = a.value - u.clientY, _.value = u.clientX, a.value = u.clientY;
      let v, L;
      const x = n.value.getBoundingClientRect();
      n.value.offsetLeft - r.value + x.width > window.innerWidth ? v = window.innerWidth - x.width : n.value.offsetLeft - r.value < 0 ? v = 0 : v = n.value.offsetLeft - r.value, n.value.offsetTop - i.value + x.height > window.innerHeight ? L = window.innerHeight - x.height : n.value.offsetTop - i.value < 0 ? L = 0 : L = n.value.offsetTop - i.value, $.value = L, I.value = v;
    }, p = (u) => {
      u = u || window.event, u.touches && (u = u == null ? void 0 : u.touches[0]), u.preventDefault(), J.value = u.target.title, t.onResizeStart && t.onResizeStart();
      const v = n.value;
      l.value = parseFloat(getComputedStyle(v, null).getPropertyValue("width").replace("px", "")), f.value = parseFloat(getComputedStyle(v, null).getPropertyValue("height").replace("px", "")), N.value = u.pageX, O.value = u.pageY, document.onmouseup = M, document.ontouchend = M, document.onmouseup = M, document.ontouchend = M, document.onmousemove = m, document.ontouchmove = m;
    }, m = (u) => {
      u.preventDefault();
      const v = n.value;
      t.onResize && t.onResize();
      let L, x;
      J.value === "bottom-right" ? (L = l.value + (u.clientX - N.value), x = f.value + (u.clientY - O.value), L > X.value && L > t.minw && L + I.value < window.innerWidth && (v.style.width = L + "px"), x > X.value && x > t.minh && x + $.value < window.innerHeight && (v.style.height = x + "px")) : J.value === "top-left" && (L = l.value - (u.clientX - N.value), x = f.value - (u.clientY - O.value), L > X.value && L > t.minw && I.value + (u.clientX - N.value) > 0 && (v.style.width = L + "px", v.style.left = I.value + (u.clientX - N.value) + "px"), x > X.value && x > t.minh && $.value + (u.clientY - O.value) > 0 && (v.style.height = x + "px", v.style.top = $.value + (u.clientY - O.value) + "px"));
    }, M = (u) => {
      let v, L;
      if (J.value === "bottom-right" ? (v = l.value + (u.clientX - N.value), L = f.value + (u.clientY - O.value)) : J.value === "top-left" && (v = l.value - (u.clientX - N.value), L = f.value - (u.clientY - O.value), I.value = I.value + (u.clientX - N.value), $.value = $.value + (u.clientY - O.value)), l.value = v, f.value = L, document.onmouseup = null, document.ontouchend = null, document.onmousemove = null, document.ontouchmove = null, J.value = null, t.onResizeStop) {
        const x = n.value, z = getComputedStyle(x, null), F = {
          x: parseFloat(z.getPropertyValue("left").replace("px", "")),
          y: parseFloat(z.getPropertyValue("top").replace("px", "")),
          w: parseFloat(z.getPropertyValue("width").replace("px", "")),
          h: parseFloat(z.getPropertyValue("height").replace("px", ""))
        };
        t.onResizeStop(F.x, F.y, F.w, F.h);
      }
    };
    return (u, v) => {
      const L = S("cognitive-icon"), x = S("cognitive-block");
      return s(), T(x, {
        tabindex: "0",
        class: A(D.value),
        "data-test-handle": e.dataTestHandle,
        onClick: v[7] || (v[7] = R((z) => e.draggable ? null : _e(z.target), ["self"]))
      }, {
        default: b(() => [
          e.draggable ? (s(), o("article", {
            key: 0,
            ref: "dialog",
            role: "dialog",
            class: "cc-ui-modal__dialog",
            style: ae(P.value),
            onClickCapture: v[6] || (v[6] = (z) => (Ge(se)(U.value), g(), c.value = !0))
          }, [
            y("header", {
              class: "cc-ui-modal__heading",
              onMousedown: v[0] || (v[0] = (z) => C(z)),
              onMouseup: v[1] || (v[1] = (z) => g()),
              onTouchstart: v[2] || (v[2] = R((z) => C(z), ["stop"])),
              onTouchend: v[3] || (v[3] = R((z) => g(), ["stop"]))
            }, [
              e.hideCloseIcon ? k("", !0) : (s(), o("button", {
                key: 0,
                class: "cc-ui-modal__close",
                onClick: R(_e, ["stop"])
              }, [
                w(L, {
                  "icon-type": "css",
                  "icon-name": "IconPlus",
                  rotation: "45",
                  width: "20",
                  height: "20"
                })
              ], 8, ni))
            ], 32),
            y("section", ii, [
              V(u.$slots, "default")
            ]),
            e.noResize ? k("", !0) : (s(), o("div", si, [
              y("div", {
                title: "top-left",
                class: "resizer top-left",
                onMousedown: v[4] || (v[4] = (z) => p(z))
              }, null, 32),
              y("div", {
                title: "bottom-right",
                class: "resizer bottom-right",
                onMousedown: v[5] || (v[5] = (z) => p(z))
              }, null, 32)
            ]))
          ], 36)) : (s(), o("article", oi, [
            e.hideCloseIcon ? k("", !0) : (s(), o("header", ai, [
              y("button", {
                class: "cc-ui-modal__close",
                onClick: _e
              }, [
                w(L, {
                  "icon-type": "css",
                  "icon-name": "IconPlus",
                  rotation: "45",
                  width: "20",
                  height: "20"
                })
              ])
            ])),
            te.value ? (s(), o("section", li, [
              V(u.$slots, "default")
            ])) : k("", !0)
          ]))
        ]),
        _: 3
      }, 8, ["class", "data-test-handle"]);
    };
  }
}, ri = {
  modals: [],
  selectedModal: null
}, ui = {
  modals: (e) => e.modals,
  selectedModal: (e) => e.selectedModal
}, Ee = (...e) => [...new Set([].concat(...e))], Be = (e, t, n) => {
  let c = [...e];
  const r = c.find((i) => i.name === t);
  return r && (r.visible = n, c = Ee(e, [r])), c;
}, Se = (e, t, n) => {
  const c = e, r = c.findIndex((i) => i.name === t);
  if (r > -1) {
    const i = c[r];
    i.data = n, c[r] = i;
  }
  return c;
}, Fe = "SET - New modal", Ke = "SET - Open modal", ke = "SET - Close modal", Ye = "SET - Select modal", Re = "SET - Update modal data", di = {
  [Fe](e, t) {
    e.modals = Ee(...e.modals, [{ visible: !1, name: t.name, data: t.data }]);
  },
  [Ke](e, t) {
    e.modals = Be(e.modals, t.name, !0), t.data && (e.modals = Se(e.modals, t.name, t.data));
  },
  [Re](e, t) {
    t.data && (e.modals = Se(e.modals, t.name, t.data));
  },
  [ke](e, t) {
    t ? (e.modals = Be(e.modals, t.name, !1), t.reset && (e.modals = Se(e.modals, t.name, null))) : e.modals = e.modals.map((n) => (n.visible = !1, n));
  },
  [Ye](e, t) {
    e.selectedModal = t;
  }
}, _i = {
  openModal({ commit: e }, t) {
    return t ? e(Ke, t) : !1;
  },
  updateModalData({ commit: e }, t) {
    return t ? e(Re, t) : !1;
  },
  closeModal({ commit: e }, t) {
    return !t || !t.name ? e(ke) : e(ke, t);
  },
  createModal({ commit: e, state: t }, n) {
    return !n || !n.name || t.modals.filter((c) => c.name === n.name)[0] ? !1 : e(Fe, n);
  },
  selectModal({ commit: e }, t) {
    e(Ye, t);
  }
}, hi = {
  namespaced: !0,
  state: ri,
  getters: ui,
  actions: _i,
  mutations: di
}, fi = {
  install(e, t) {
    if (t.pinia)
      e.component("CognitiveModal", ci);
    else {
      if (!(t != null && t.store))
        throw new Error("Please initialise plugin with a Vuex store.");
      t.store.hasModule("Modal") || t.store.registerModule("Modal", hi), e.component("CognitiveModal", ti);
    }
  }
};
const gi = {
  name: "CognitiveDiscard",
  props: {
    leaveAction: {
      default: null,
      type: Function
    },
    cancelAction: {
      default: null,
      type: Function
    },
    args: {
      default: null,
      type: [Number, String, Array, Object]
    },
    isNotModal: {
      default: !1,
      type: Boolean
    }
  },
  methods: {
    async runAction(e) {
      if (this[e] && (this.args ? await this[e](this.args) : await this[e]()), !this.isNotModal)
        if (this.$store)
          this.$store.dispatch("Modal/closeModal", { name: "discard" });
        else {
          const { closeModal: t } = ze();
          t({ name: "discard" });
        }
    },
    closeModalAction() {
      this.cancelAction && this.cancelAction();
    }
  }
};
function mi(e, t, n, c, r, i) {
  const _ = S("cognitive-paragraph"), a = S("cognitive-button"), l = S("cognitive-block"), f = S("cognitive-modal");
  return n.isNotModal ? (s(), T(l, {
    key: 0,
    class: "cc-ui-discard"
  }, {
    default: b(() => [
      w(_, {
        size: "xs",
        class: "cc-ui-discard__text"
      }, {
        default: b(() => [
          V(e.$slots, "messageText")
        ]),
        _: 3
      }),
      w(l, { class: "cc-ui-discard__actions" }, {
        default: b(() => [
          w(a, {
            version: "primary",
            inverse: "",
            size: "sm",
            onClick: t[0] || (t[0] = (I) => i.runAction("cancelAction"))
          }, {
            default: b(() => [
              E(" Cancel ")
            ]),
            _: 1
          }),
          w(a, {
            version: "red",
            size: "sm",
            onClick: t[1] || (t[1] = (I) => i.runAction("leaveAction"))
          }, {
            default: b(() => [
              V(e.$slots, "buttonText")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  })) : (s(), T(f, {
    key: 1,
    name: "discard",
    "auto-open": "",
    "on-close": i.closeModalAction
  }, {
    default: b(() => [
      w(l, { class: "cc-ui-discard" }, {
        default: b(() => [
          w(_, {
            size: "xs",
            class: "cc-ui-discard__message"
          }, {
            default: b(() => [
              V(e.$slots, "messageText")
            ]),
            _: 3
          }),
          w(l, { class: "cc-ui-discard__actions" }, {
            default: b(() => [
              w(a, {
                version: "primary",
                inverse: "",
                size: "sm",
                onClick: t[2] || (t[2] = (I) => i.runAction("cancelAction"))
              }, {
                default: b(() => [
                  E(" Cancel ")
                ]),
                _: 1
              }),
              w(a, {
                version: "red",
                size: "sm",
                onClick: t[3] || (t[3] = (I) => i.runAction("leaveAction"))
              }, {
                default: b(() => [
                  V(e.$slots, "buttonText")
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["on-close"]));
}
const vi = /* @__PURE__ */ d(gi, [["render", mi]]), yi = {}, pi = { d: "M.5 0c.27614238 0 .5.23878147.5.53333333V15h14.4666667C15.7612185 15 16 15.2238576 16 15.5s-.2387815.5-.5333333.5H.5c-.13567412 0-.25872697-.0576406-.34880968-.1512163-.07483977-.0720454-.12669771-.1652083-.1444473-.2690568L0 15.4666667V.53333333C0 .23878147.22385763 0 .5 0zm13 8c.2761424 0 .5.22385763.5.5v3c0 .2454599-.1768752.4496084-.4101244.4919443L13.5 12H4.714l1.56087373 1.5606602c.19526215.1952621.19526215.5118446 0 .7071068-.19526214.1952621-.51184463.1952621-.70710678 0l-2.41421356-2.4142136c-.19526215-.1952622-.19526215-.5118446 0-.7071068l2.41421356-2.41421355c.19526215-.19526215.51184464-.19526215.70710678 0 .19526215.19526214.19526215.51184463 0 .70710678L4.714 11H13V8.5c0-.27614237.2238576-.5.5-.5zM11.4348737.73223305l2.4142136 2.41421356c.1952621.19526215.1952621.51184463 0 .70710678l-2.4142136 2.41421356c-.1952621.19526215-.5118446.19526215-.7071067 0-.1952622-.19526214-.1952622-.51184463 0-.70710678L12.288 4H4v2.5c0 .27614237-.22385763.5-.5.5-.27614237 0-.5-.22385763-.5-.5v-3c0-.27614237.22385763-.5.5-.5h8.788l-1.560233-1.56066017c-.1952622-.19526215-.1952622-.51184464 0-.70710678.1952621-.19526215.5118446-.19526215.7071067 0z" };
function Li(e, t) {
  return s(), o("path", pi);
}
const Ci = /* @__PURE__ */ d(yi, [["render", Li]]), bi = {}, Mi = { d: "M15.4666667 16H.5c-.13567412 0-.25872697-.0576406-.34880968-.1512163-.07483977-.0720454-.12669771-.1652083-.1444473-.2690568L0 15.4666667V.53333333C0 .23878147.22385763 0 .5 0c.27614238 0 .5.23878147.5.53333333V15l1.02519452.0009341c-.00822679-.0403694-.01450783-.0814464-.01874091-.1231289L2 14.75v-7.5c0-.64720869.49187466-1.1795339 1.12219476-1.24354639L3.25 6h.5c.64720869 0 1.1795339.49187466 1.24354639 1.12219476L5 7.25v7.5c0 .0859465-.00867406.1698671-.02519452.2509341h2.05038904l-.01879243-.1236372L7 14.75V4.25c0-.64720869.49187466-1.1795339 1.12219476-1.24354639L8.25 3h.5c.64720869 0 1.1795339.49187466 1.24354639 1.12219476L10 4.25v10.5c0 .0859465-.00867406.1698671-.02519452.2509341h2.05038902l-.0187924-.1236372L12 14.75v-5.5c0-.64720869.4918747-1.1795339 1.1221948-1.24354639L13.25 8h.5c.6472087 0 1.1795339.49187466 1.2435464 1.12219476L15 9.25v5.5c0 .0859465-.0086741.1698671-.0251945.2509341L15.4666667 15C15.7612185 15 16 15.2238576 16 15.5s-.2387815.5-.5333333.5zM3.75 7h-.5c-.11834673 0-.21748682.08223341-.24339732.19267729L3 7.25v7.5c0 .1183467.08223341.2174868.19267729.2433973L3.25 15h.5c.11834673 0 .21748682-.0822334.24339732-.1926773L4 14.75v-7.5c0-.11834673-.08223341-.21748682-.19267729-.24339732L3.75 7zm5-3h-.5c-.11834673 0-.21748682.08223341-.24339732.19267729L8 4.25v10.5c0 .1183467.08223341.2174868.19267729.2433973L8.25 15h.5c.11834673 0 .21748682-.0822334.24339732-.1926773L9 14.75V4.25c0-.11834673-.08223341-.21748682-.19267729-.24339732L8.75 4zm5 5h-.5c-.1183467 0-.2174868.08223341-.2433973.19267729L13 9.25v5.5c0 .1183467.0822334.2174868.1926773.2433973L13.25 15h.5c.1183467 0 .2174868-.0822334.2433973-.1926773L14 14.75v-5.5c0-.11834673-.0822334-.21748682-.1926773-.24339732L13.75 9z" };
function $i(e, t) {
  return s(), o("path", Mi);
}
const xi = /* @__PURE__ */ d(bi, [["render", $i]]), Si = {}, wi = { d: "M12.5 1c.2761424 0 .5.22385763.5.5V2h1c1.0543618 0 1.9181651.81587779 1.9945143 1.85073766L16 4v10c0 1.1045695-.8954305 2-2 2H2c-1.1045695 0-2-.8954305-2-2V4c0-1.1045695.8954305-2 2-2h1v-.5c0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5V2h8v-.5c0-.27614237.2238576-.5.5-.5zM1 7v7c0 .5522847.44771525 1 1 1h12c.5522847 0 1-.4477153 1-1V7H1zm0-1h14V4c0-.55228475-.4477153-1-1-1h-1v1.5c0 .27614237-.2238576.5-.5.5s-.5-.22385763-.5-.5V3H4v1.5c0 .27614237-.22385763.5-.5.5-.27614237 0-.5-.22385763-.5-.5V3H2c-.51283584 0-.93550716.38604019-.99327227.88337887L1 4v2z" };
function ki(e, t) {
  return s(), o("path", wi);
}
const Ii = /* @__PURE__ */ d(Si, [["render", ki]]), zi = {}, Ti = { d: `M13-1v1h.9230769C14.5178451 0 15 .44771525 15 1v14c0 .5522847-.4821549 1-1.0769231 1H2.07692308C1.48215488 16 1
  15.5522847 1 15V1c0-.55228475.48215488-1 1.07692308-1H7v-1h6zm.4230769 2H13v6l-3-2.14285714L7
  7V1H2.57692308c-.27614238 0-.5.22385763-.5.5v13c0 .2761424.22385762.5.5.5H13.4230769c.2761424 0
  .5-.2238576.5-.5v-13c0-.27614237-.2238576-.5-.5-.5zM12 1H8v4l2-1.40625L12 5V1z M1.92382812
  15l.96679688-2.4975586h3.14746094L7.015625 15h.9453125L4.87255859 7.11523438h-.7680664L1
  15h.92382812zm3.82958985-3.3193359H3.21289062l.92382813-2.43310551c.1468099-.41178385.25960286-.78955078.33837891-1.13330078.12532552.44759115.24707031.82535808.36523437
  1.13330078l.91308594 2.43310551zm4.58154293 3.4267578c.436849 0 .8011882-.0653483
  1.0930176-.1960449.2918294-.1306967.5845541-.3804525.8781738-.7492676h.0429688L12.5263672
  15h.6606445v-4.0175781c0-.6875-.1691894-1.18701174-.5075683-1.49853518s-.8584799-.46728516-1.5603028-.46728516c-.3473307
  0-.6937663.04475912-1.0393066.13427735-.34554038.08951823-.66333009.21305338-.95336916.37060547l.27392578.68212892c.61946618-.30078127
  1.17447918-.45117189 1.66503908-.45117189.4368489 0
  .7546387.11010742.9533691.33032229.1987305.2202148.2980957.5612793.2980957
  1.0231933v.3652344l-.9990234.0322266c-1.90136719.0572916-2.85205079.6803385-2.85205079 1.8691406 0
  .555013.16560873.9829102.49682617 1.2836914.33121745.3007812.7886556.4511719
  1.37231442.4511719zm.1772461-.7358399c-.3509114
  0-.62394203-.0841471-.81909177-.2524414-.19514974-.1682942-.29272461-.4135742-.29272461-.7358398
  0-.4117839.15665691-.7152507.46997071-.9104004.31331377-.1951497.82446287-.3052572
  1.53344727-.3303223l.8916016-.0375976v.5317383c0 .5478515-.1584473.9739583-.4753418
  1.2783203-.3168946.3043619-.7528483.4565429-1.3078614.4565429z` };
function Hi(e, t) {
  return s(), o("path", Ti);
}
const Di = /* @__PURE__ */ d(zi, [["render", Hi]]), Zi = {}, Bi = {
  "fill-rule": "evenodd",
  d: "M0.5,0 L12.5,0 C12.7761424,0 13,0.223857625 13,0.5 C13,0.776142375 12.7761424,1 12.5,1 L0.5,1 C0.223857625,1 0,0.776142375 0,0.5 C0,0.223857625 0.223857625,0 0.5,0 Z M12.5,15 C12.7761424,15 13,15.2238576 13,15.5 C13,15.7761424 12.7761424,16 12.5,16 L0.5,16 C0.223857625,16 0,15.7761424 0,15.5 C0,15.2238576 0.223857625,15 0.5,15 L12.5,15 Z M8.5,4 C10.9852814,4 13,6.01471863 13,8.5 C13,9.56240691 12.6318328,10.5388238 12.0161235,11.3086256 L15.3535534,14.6464466 C15.5488155,14.8417088 15.5488155,15.1582912 15.3535534,15.3535534 C15.1582912,15.5488155 14.8417088,15.5488155 14.6464466,15.3535534 L11.3086256,12.0161235 C10.5388238,12.6318328 9.56240691,13 8.5,13 C6.01471863,13 4,10.9852814 4,8.5 C4,6.01471863 6.01471863,4 8.5,4 Z M3.5,12 C3.77614237,12 4,12.2238576 4,12.5 C4,12.7761424 3.77614237,13 3.5,13 L0.5,13 C0.223857625,13 0,12.7761424 0,12.5 C0,12.2238576 0.223857625,12 0.5,12 L3.5,12 Z M8.5,5 C6.56700338,5 5,6.56700338 5,8.5 C5,10.4329966 6.56700338,12 8.5,12 C10.4329966,12 12,10.4329966 12,8.5 C12,6.56700338 10.4329966,5 8.5,5 Z M2.5,9 C2.77614237,9 3,9.22385763 3,9.5 C3,9.77614237 2.77614237,10 2.5,10 L0.5,10 C0.223857625,10 0,9.77614237 0,9.5 C0,9.22385763 0.223857625,9 0.5,9 L2.5,9 Z M2.5,6 C2.77614237,6 3,6.22385763 3,6.5 C3,6.77614237 2.77614237,7 2.5,7 L0.5,7 C0.223857625,7 0,6.77614237 0,6.5 C0,6.22385763 0.223857625,6 0.5,6 L2.5,6 Z M4.5,3 C4.77614237,3 5,3.22385763 5,3.5 C5,3.77614237 4.77614237,4 4.5,4 L0.5,4 C0.223857625,4 0,3.77614237 0,3.5 C0,3.22385763 0.223857625,3 0.5,3 L4.5,3 Z"
};
function Ai(e, t) {
  return s(), o("path", Bi);
}
const Vi = /* @__PURE__ */ d(Zi, [["render", Ai]]), Ni = {}, Oi = { d: "M14.086,-2.84217094e-14 L14.793,0.707 L10.7051957,4.795303 L13.734459,4.795303 C14.0097182,4.795303 14.2334546,5.01903936 14.2334546,5.2942986 C14.2327488,5.43192823 14.1769912,5.55685358 14.0866497,5.64719507 C13.9963082,5.73753657 13.8720886,5.794 13.7337532,5.794 L9.4989956,5.794 C9.22373636,5.794 9,5.57026364 9,5.2950044 L9,1.06024681 C9,0.784987567 9.22373636,0.561251208 9.4989956,0.561251208 C9.77425485,0.561251208 9.9979912,0.784987567 9.9979912,1.06024681 L9.9979912,4.08951007 L14.086,-2.84217094e-14 Z M5.2980044,9 C5.57326364,9 5.797,9.22373636 5.797,9.4989956 L5.797,13.7337532 C5.79629421,13.8713828 5.74053657,13.9963082 5.65019507,14.0866497 C5.55985358,14.1769912 5.43563402,14.2334546 5.2972986,14.2334546 C5.02203936,14.2334546 4.798303,14.0097182 4.798303,13.734459 L4.798303,10.7051957 L0.707,14.796 L4.48530102e-14,14.089 L4.0896869,10.0008144 L1.06042364,10.0008144 C0.785164395,10.0008144 0.561428036,9.77707802 0.561428036,9.50181877 C0.561428036,9.22655953 0.785164395,9.00282317 1.06042364,9.00282317 L5.29518123,9.00282317 L5.2980044,9 Z" };
function Pi(e, t) {
  return s(), o("path", Oi);
}
const Ei = /* @__PURE__ */ d(Ni, [["render", Pi]]), Fi = {}, Ki = { d: "M14.5714286,0 C15.3604068,0 16,0.559644063 16,1.25 L16,15 L15.9714234,15 C15.8390604,15.5705601 15.2625594,16 14.5714286,16 L1.42857143,16 C0.639593215,16 0,15.4403559 0,14.75 L0,1.25 C0,0.559644063 0.639593215,0 1.42857143,0 L14.5714286,0 Z M1,13 L1,14 C1,14.5522847 1.52233446,15 2.16666667,15 L2.999,15 L2.999,13 L1,13 Z M9,13 L6.999,13 L6.999,15 L9,15 L9,13 Z M12,13 L10,13 L10,15 L12,15 L12,13 Z M15,13 L13,13 L13,15 L15,15 L15,13 Z M9,10 L7,10 L7,12 L9,12 L9,10 Z M12,10 L10,10 L10,12 L12,12 L12,10 Z M15,10 L13,10 L13,12 L15,12 L15,10 Z M9,7 L7,7 L7,9 L9,9 L9,7 Z M12,7 L10,7 L10,9 L12,9 L12,7 Z M15,7 L13,7 L13,9 L15,9 L15,7 Z M3,7 L1,7 L1,9 L3,9 L3,7 Z M9,4 L7,4 L7,6 L9,6 L9,4 Z M12,4 L10,4 L10,6 L12,6 L12,4 Z M15,4 L13,4 L13,6 L15,6 L15,4 Z M3,4 L1,4 L1,6 L3,6 L3,4 Z M14.4166667,1 L1.58333333,1 C1.26116723,1 1,1.22385763 1,1.5 L1,3 L15,3 L15,1.5 C15,1.22385763 14.7388328,1 14.4166667,1 Z M1,12 L3,12 L3,10 L1,10 L1,12 Z" };
function Yi(e, t) {
  return s(), o("path", Ki);
}
const Ri = /* @__PURE__ */ d(Fi, [["render", Yi]]), ji = {}, Ui = /* @__PURE__ */ y("path", { d: "M2.199 7c-.077 0-.14.224-.14.5s.063.5.14.5H5.8c.039 0 .073-.057.098-.148.026-.09.041-.216.041-.353 0-.276-.062-.5-.139-.5L2.2 7zM10.698 7c-.076 0-.138.224-.138.5s.062.5.138.5h3.603c.039 0 .073-.057.098-.148.026-.09.041-.216.041-.353 0-.276-.062-.5-.138-.5L10.698 7zM11.559 9c-.061 0-.111.224-.111.5s.05.5.11.5h2.883c.03 0 .058-.057.079-.148.02-.09.032-.216.032-.353 0-.276-.05-.5-.11-.5L11.558 9zM11.559 11c-.061 0-.111.224-.111.5s.05.5.11.5h2.883c.03 0 .058-.057.079-.148.02-.09.032-.216.032-.353 0-.276-.05-.5-.11-.5L11.558 11zM2.318 9c-.123 0-.222.224-.222.5s.1.5.222.5h5.764c.062 0 .117-.057.157-.148a.903.903 0 00.066-.353c0-.276-.1-.5-.223-.5L2.318 9zM2.397 11c-.153 0-.277.224-.277.5s.124.5.277.5h7.206c.077 0 .146-.057.196-.148a.747.747 0 00.082-.353c0-.276-.125-.5-.278-.5L2.397 11zM2.397 13c-.153 0-.277.224-.277.5s.124.5.277.5h7.206c.077 0 .146-.057.196-.148a.747.747 0 00.082-.353c0-.276-.125-.5-.278-.5L2.397 13z" }, null, -1), Wi = /* @__PURE__ */ y("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.354.146l4.5 4.5A.504.504 0 0116 5v7.5c0 .827-.673 1.5-1.5 1.5H11v-1h3.5a.5.5 0 00.5-.5V6h-3.5c-.827 0-1.5-.673-1.5-1.5V1H5.5a.5.5 0 00-.5.5V3H4V1.5C4 .673 4.673 0 5.5 0H11a.5.5 0 01.354.146zM11.5 5h3.293L11 1.207V4.5a.5.5 0 00.5.5z"
}, null, -1), Xi = /* @__PURE__ */ y("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.854 6.646l-4.5-4.5A.5.5 0 007 2H1.5C.673 2 0 2.673 0 3.5v11c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5V7a.504.504 0 00-.146-.354zM10.793 7H7.5a.5.5 0 01-.5-.5V3.207L10.793 7zm-.293 8a.5.5 0 00.5-.5V8H7.5C6.673 8 6 7.327 6 6.5V3H1.5a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h9z"
}, null, -1), qi = [
  Ui,
  Wi,
  Xi
];
function Gi(e, t) {
  return s(), o("g", null, qi);
}
const Ji = /* @__PURE__ */ d(ji, [["render", Gi]]), Qi = {}, es = /* @__PURE__ */ y("path", { d: "M4,3 L4,1.5 C4,0.673 4.673,0 5.5,0 L11,0 C11.133,0 11.26,0.052 11.354,0.146 L15.854,4.646 C15.947,4.74 16,4.867 16,5 L16,12.5 C16,13.327 15.327,14 14.5,14 L8.25,14 L11,14 L11,13 L14.5,13 C14.776,13 15,12.776 15,12.5 L15,6 L11.5,6 C10.673,6 10,5.327 10,4.5 L10,1 L5.5,1 C5.224,1 5,1.224 5,1.5 L5,3 L4,3 Z M14.793,5 L11,1.207 L11,4.5 C11,4.776 11.224,5 11.5,5 L14.793,5 Z" }, null, -1), ts = /* @__PURE__ */ y("path", { d: "M11.854,6.646 L7.354,2.146 C7.26,2.052 7.133,2 7,2 L1.5,2 C0.673,2 0,2.673 0,3.5 L0,14.5 C0,15.327 0.673,16 1.5,16 L10.5,16 C11.327,16 12,15.327 12,14.5 L12,7 C12,6.867 11.947,6.74 11.854,6.646 Z M10.793,7 L7.5,7 C7.224,7 7,6.776 7,6.5 L7,3.207 L10.793,7 Z M11,14.5 C11,14.776 10.776,15 10.5,15 L1.5,15 C1.224,15 1,14.776 1,14.5 L1,3.5 C1,3.224 1.224,3 1.5,3 L6,3 L6,6.5 C6,7.327 6.673,8 7.5,8 L11,8 L11,14.5 Z" }, null, -1), ns = [
  es,
  ts
];
function is(e, t) {
  return s(), o("g", null, ns);
}
const ss = /* @__PURE__ */ d(Qi, [["render", is]]), os = {}, as = { d: "M1.5 16c-.778 0-1.42-.596-1.493-1.356L0 14.5v-13C0 .722.596.08 1.356.007L1.5 0H8a.5.5 0 01.294.095l.06.051 4.5 4.5a.505.505 0 01.14.275L13 5v3h2a1 1 0 011 1v6a1 1 0 01-1 1H1.5zM7 1H1.5a.5.5 0 00-.492.41L1 1.5v13a.5.5 0 00.41.492L1.5 15H4V9a1 1 0 011-1h7V6H7.809l-.862 1.724a.5.5 0 01-.903-.017l-.03-.085-.786-3.144-1.374 1.376a.5.5 0 01-.275.14L3.5 6h-1a.5.5 0 01-.09-.992L2.5 5h.792l1.854-1.853a.5.5 0 01.81.15l.03.082.671 2.687.396-.79a.5.5 0 01.094-.13 1.484 1.484 0 01-.14-.502L7 4.5V1zm2 8v6l3-3-3-3zM8 1.207V4.5a.5.5 0 00.41.492L8.5 5h3.293L8 1.207z" };
function ls(e, t) {
  return s(), o("path", as);
}
const cs = /* @__PURE__ */ d(os, [["render", ls]]), rs = {}, us = { d: "M1.5 16c-.778 0-1.42-.596-1.493-1.356L0 14.5v-13C0 .722.596.08 1.356.007L1.5 0H8a.5.5 0 01.294.095l.06.051 4.5 4.5a.505.505 0 01.14.275L13 5v3h2a1 1 0 011 1v6a1 1 0 01-1 1H1.5zM7 1H1.5a.5.5 0 00-.492.41L1 1.5v13a.5.5 0 00.41.492L1.5 15H4V9a1 1 0 011-1h7V6H7.809l-.862 1.724a.5.5 0 01-.903-.017l-.03-.085-.786-3.144-1.374 1.376a.5.5 0 01-.275.14L3.5 6h-1a.5.5 0 01-.09-.992L2.5 5h.792l1.854-1.853a.5.5 0 01.81.15l.03.082.671 2.687.396-.79a.5.5 0 01.094-.13 1.484 1.484 0 01-.14-.502L7 4.5V1zm3 8c-2.761 0-5 2-5 3s2.239 3 5 3 5-2 5-3-2.239-3-5-3zm0 2a1 1 0 110 2 1 1 0 010-2zM8 1.207V4.5a.5.5 0 00.41.492L8.5 5h3.293L8 1.207z" };
function ds(e, t) {
  return s(), o("path", us);
}
const _s = /* @__PURE__ */ d(rs, [["render", ds]]), hs = {}, fs = { d: "M15.875 15.2336266l-.640625.6412512C15.140625 15.9582926 15.03125 16 14.90625 16s-.2291667-.0417074-.3125-.1251222l-2.359375-2.3616813c-.5520833.3232323-1.1302083.4848485-1.734375.4848485-.96875 0-1.79427083-.3414793-2.4765625-1.024438C7.34114583 12.2906484 7 11.4643206 7 10.4946237c0-.67774524.18229167-1.30074947.546875-1.86901275S8.39583333 7.63245357 9 7.35092864V6.0058651l-.75146625-.00440742C8.11103719 6.00065124 8 5.8889609 8 5.75146198V5.25c0-.13807119.11192881-.25.25-.25h1.5c.13807119 0 .25.11192881.25.25v1.80376344c.2395833-.03128055.40625-.04692082.5-.04692082.9479167 0 1.765625.33365917 2.453125 1.00097752H13V6.0058651l-.7514663-.00440742C12.1110372 6.00065124 12 5.8889609 12 5.75146198V5.25c0-.13807119.1119288-.25.25-.25h1.5c.1380712 0 .25.11192881.25.25v2.75782014l.748045-.00584982c.138067-.0010797.2508677.10997042.2519474.24803738A.24980326.24980326 0 0115 8.25196268v.49966873c0 .13743243-.1109338.24909488-.2483633.24999465l-1.0953867.00717159C13.8854167 9.49885956 14 9.9941349 14 10.4946237c0 .6151841-.1614583 1.1990876-.484375 1.7517106L15.875 14.5923754c.0833333.0938416.125.2007168.125.3206256 0 .1199087-.0416667.2267839-.125.3206256zM10.5 8.00782014c-.6875 0-1.27604167.24242424-1.765625.72727272C8.24479167 9.21994135 8 9.80905833 8 10.5024438c0 .6933855.24479167 1.2825024.734375 1.7673509s1.078125.7272727 1.765625.7272727 1.2760417-.2424242 1.765625-.7272727C12.7552083 11.7849462 13 11.1958293 13 10.5024438c0-.69338547-.2447917-1.28250245-.734375-1.76735094-.4895833-.48484848-1.078125-.72727272-1.765625-.72727272zM6.75 9h-2.5C4.11192881 9 4 8.88807119 4 8.75v-3.5c0-.13807119.11192881-.25.25-.25h2.5c.13807119 0 .25.11192881.25.25v3.5c0 .13807119-.11192881.25-.25.25zm-1-3h-.5c-.13807119 0-.25.11192881-.25.25v1.5c0 .13807119.11192881.25.25.25h.5c.13807119 0 .25-.11192881.25-.25v-1.5C6 6.11192881 5.88807119 6 5.75 6zm-3-2H.25C.11192881 4 0 3.88807119 0 3.75V.25C0 .11192881.11192881 0 .25 0h2.5c.13807119 0 .25.11192881.25.25v3.5c0 .13807119-.11192881.25-.25.25zm-1-3h-.5c-.13807119 0-.25.11192881-.25.25v1.5c0 .13807119.11192881.25.25.25h.5c.13807119 0 .25-.11192881.25-.25v-1.5C2 1.11192881 1.88807119 1 1.75 1zm1 13H.25c-.13807119 0-.25-.1119288-.25-.25v-3.5c0-.1380712.11192881-.25.25-.25h2.5c.13807119 0 .25.1119288.25.25v3.5c0 .1380712-.11192881.25-.25.25zm-1-3h-.5c-.13807119 0-.25.1119288-.25.25v1.5c0 .1380712.11192881.25.25.25h.5c.13807119 0 .25-.1119288.25-.25v-1.5c0-.1380712-.11192881-.25-.25-.25zm9-7h-2.5C8.11192881 4 8 3.88807119 8 3.75V.25c0-.13807119.11192881-.25.25-.25h2.5c.1380712 0 .25.11192881.25.25v3.5c0 .13807119-.1119288.25-.25.25zm-1-3h-.5c-.13807119 0-.25.11192881-.25.25v1.5c0 .13807119.11192881.25.25.25h.5c.13807119 0 .25-.11192881.25-.25v-1.5c0-.13807119-.11192881-.25-.25-.25zM4 10.7526737V10.25c0-.1380712.11192881-.25.25-.25h1.5c.13807119 0 .25.1119288.25.25v2.7627077l.74682333-.0094904c.13806004-.0017544.25140206.1087431.25315649.2468031A.25011488.25011488 0 017 13.2531971V13.75c0 .1380712-.11192881.25-.25.25h-2.5c-.13807119 0-.25-.1119288-.25-.25v-.4968029c0-.1380712.11192881-.25.25-.25a.24917331.24917331 0 01.00317667.0000202L5 13.0127077v-2.001955l-.75268802-.0080934C4.11029731 11.001186 4 10.8896963 4 10.7526737zM0 5.75267372V5.25C0 5.11192881.11192881 5 .25 5h1.5c.13807119 0 .25.11192881.25.25v2.76270772l.74682333-.00949042c.13806004-.00175443.25140206.1087431.25315649.24680314A.2501011.2501011 0 013 8.25319712V8.75c0 .13807119-.11192881.25-.25.25H.25C.11192881 9 0 8.88807119 0 8.75v-.49680288c0-.13807119.11192881-.25.25-.25a.24991495.24991495 0 01.00317667.00002018L1 8.01270772V6.01075269l-.75268802-.00809342C.11029731 6.00118599 0 5.88969632 0 5.75267372zm4-5V.25c0-.13807119.11192881-.25.25-.25h1.5c.13807119 0 .25.11192881.25.25v2.76270772l.74682333-.00949042c.13806004-.00175443.25140206.1087431.25315649.24680314A.2501011.2501011 0 017 3.25319712V3.75c0 .13807119-.11192881.25-.25.25h-2.5C4.11192881 4 4 3.88807119 4 3.75v-.49680288c0-.13807119.11192881-.25.25-.25a.24991373.24991373 0 01.00317667.00002018L5 3.01270772V1.01075269l-.75268802-.00809342C4.11029731 1.00118599 4 .88969632 4 .75267372zm8 0V.25c0-.13807119.1119288-.25.25-.25h1.5c.1380712 0 .25.11192881.25.25v2.76270772l.7468233-.00949042c.1380601-.00175443.2514021.1087431.2531565.24680314A.24917488.24917488 0 0115 3.25319712V3.75c0 .13807119-.1119288.25-.25.25h-2.5c-.1380712 0-.25-.11192881-.25-.25v-.49680288c0-.13807119.1119288-.25.25-.25a.24992907.24992907 0 01.0031767.00002018L13 3.01270772V1.01075269l-.752688-.00809342C12.1102973 1.00118599 12 .88969632 12 .75267372z" };
function gs(e, t) {
  return s(), o("path", fs);
}
const ms = /* @__PURE__ */ d(hs, [["render", gs]]), vs = {}, ys = {
  "fill-rule": "evenodd",
  d: "M7.5 0c.27614237 0 .5.22385763.5.5V1h6c1.0543618 0 1.9181651.81587779 1.9945143 1.85073766L16 3v10c0 1.0543618-.8158778 1.9181651-1.8507377 1.9945143L14 15H8v.5c0 .2761424-.22385763.5-.5.5-.27614237 0-.5-.2238576-.5-.5V15H6v-1h1V.5c0-.27614237.22385763-.5.5-.5ZM1 13c0 .5128358.38604019.9355072.88337887.9932723L2 14v1C.9456382 15 .08183488 14.1841222.00548574 13.1492623L0 13h1Zm4 1v1H3v-1h2Zm9-12H8v12h6c.5128358 0 .9355072-.3860402.9932723-.8833789L15 13V3c0-.51283584-.3860402-.93550716-.8833789-.99327227L14 2ZM1 10v2H0v-2h1Zm0-3v2H0V7h1Zm0-3v2H0V4h1Zm2-3v1H2c-.51283584 0-.93550716.38604019-.99327227.88337887L1 3H0l.00548574-.14926234c.07253168-.98311688.85574077-1.76860243 1.83786379-1.84469319L2 1h1Zm3 0v1H4V1h2Z"
};
function ps(e, t) {
  return s(), o("path", ys);
}
const Ls = /* @__PURE__ */ d(vs, [["render", ps]]), Cs = {}, bs = { d: "M12.854 4.646l-4.5-4.5C8.26.052 8.133 0 8 0H1.5C.673 0 0 .673 0 1.5v13c0 .827.673 1.5 1.5 1.5h10c.827 0 1.5-.673 1.5-1.5V5c0-.133-.053-.26-.146-.354zM11.793 5H8.5c-.276 0-.5-.224-.5-.5V1.207L11.793 5zM12 14.5c0 .276-.224.5-.5.5h-10c-.276 0-.5-.224-.5-.5v-13c0-.276.224-.5.5-.5H7v3.5C7 5.327 7.673 6 8.5 6H12v8.5z" };
function Ms(e, t) {
  return s(), o("path", bs);
}
const $s = /* @__PURE__ */ d(Cs, [["render", Ms]]), xs = {}, Ss = { "fill-rule": "evenodd" }, ws = /* @__PURE__ */ y("g", { transform: "translate(4 1)" }, [
  /* @__PURE__ */ y("circle", {
    cx: "1.5",
    cy: "1.5",
    r: "1.5"
  }),
  /* @__PURE__ */ y("circle", {
    cx: "1.5",
    cy: "13.5",
    r: "1.5"
  }),
  /* @__PURE__ */ y("circle", {
    cx: "1.5",
    cy: "7.5",
    r: "1.5"
  })
], -1), ks = /* @__PURE__ */ y("g", { transform: "translate(9 1)" }, [
  /* @__PURE__ */ y("circle", {
    cx: "1.5",
    cy: "1.5",
    r: "1.5"
  }),
  /* @__PURE__ */ y("circle", {
    cx: "1.5",
    cy: "13.5",
    r: "1.5"
  }),
  /* @__PURE__ */ y("circle", {
    cx: "1.5",
    cy: "7.5",
    r: "1.5"
  })
], -1), Is = [
  ws,
  ks
];
function zs(e, t) {
  return s(), o("g", Ss, Is);
}
const Ts = /* @__PURE__ */ d(xs, [["render", zs]]), Hs = {}, Ds = { d: "M8.9106287,6.79587003 L8.20412997,6.0893713 L12.2926869,2.00081438 L9.26342364,2.00081438 C8.9881644,2.00081438 8.76442804,1.77707802 8.76442804,1.50181877 C8.76442804,1.22655953 8.9881644,1.00282317 9.26342364,1.00282317 L13.4981812,1.00282317 L13.5010044,1 C13.7762636,1 14,1.22373636 14,1.4989956 L14,5.73375319 C13.9992942,5.87138281 13.9435366,5.99630816 13.8531951,6.08664966 C13.7628536,6.17699115 13.638634,6.23345458 13.5002986,6.23345458 C13.2250394,6.23345458 13.001303,6.00971823 13.001303,5.73445898 L13.001303,2.70519572 L8.9106287,6.79587003 Z M6.7932499,8.91324882 L2.70519572,13.001303 L5.73445898,13.001303 C6.00971823,13.001303 6.23345458,13.2250394 6.23345458,13.5002986 C6.23274879,13.6379282 6.17699115,13.7628536 6.08664966,13.8531951 C5.99630816,13.9435366 5.8720886,14 5.73375319,14 L1.4989956,14 C1.22373636,14 1,13.7762636 1,13.5010044 L1,9.26624681 C1,8.99098757 1.22373636,8.76725121 1.4989956,8.76725121 C1.77425485,8.76725121 1.9979912,8.99098757 1.9979912,9.26624681 L1.9979912,12.2955101 L6.08675118,8.2067501 L6.7932499,8.91324882 Z" };
function Zs(e, t) {
  return s(), o("path", Ds);
}
const Bs = /* @__PURE__ */ d(Hs, [["render", Zs]]), As = {}, Vs = { d: "M10.5513892.00371324c.1127725-.01508098.2270136.01622079.3130971.08578776C10.9505697.15906798 11 .260047 11 .36625105V15.6338533c0 .1060567-.049357.2068975-.1352563.2764375-.0858993.06954-.1999204.1009483-.3125689.0861003L.67488037 14.6817338C.28768046 14.630326 0 14.3212529 0 13.9566582V2.04344615c0-.36459466.28768047-.67366777.67488037-.72507561L10.5513892.00371324ZM12 1h2.4c.3313708 0 .6.34822297.6.77777778V14.2222222C15 14.651777 14.7313708 15 14.4 15H12V1ZM5.9 8 8 5H6.2L5 6.7145 3.8 5H2l2.1 3L2 11h1.8L5 9.2855 6.2 11H8L5.9 8Z" };
function Ns(e, t) {
  return s(), o("path", Vs);
}
const Os = /* @__PURE__ */ d(As, [["render", Ns]]), Ps = {}, Es = { d: "M8 6.29289322V0h1v6.29289322l1.1464466-1.14644661c.1952622-.19526215.5118446-.19526215.7071068 0 .1952621.19526215.1952621.51184463 0 .70710678l-2.00000001 2c-.19526215.19526215-.51184463.19526215-.70710678 0l-2-2c-.19526215-.19526215-.19526215-.51184463 0-.70710678.19526215-.19526215.51184463-.19526215.70710678 0L8 6.29289322ZM2 12v1h12v-1h1v1c.5522847 0 1 .4477153 1 1v1c0 .5522847-.4477153 1-1 1H1c-.55228475 0-1-.4477153-1-1v-1c0-.5522847.44771525-1 1-1v-1h1Zm1-3v1h-.75c-.13807119 0-.25.1119288-.25.25V11H1V9.66666667C1 9.29847683 1.39175084 9 1.875 9H3Zm11.125 0c.4832492 0 .875.29847683.875.66666667V11h-1v-1h-1V9h1.125ZM7 9v1H5V9h2Zm4 0v1H9V9h2Z" };
function Fs(e, t) {
  return s(), o("path", Es);
}
const Ks = /* @__PURE__ */ d(Ps, [["render", Fs]]), Ys = {}, Rs = { d: "M7.13812069,-7.10542736e-15 C7.62715821,-7.10542736e-15 8.21687108,0.114993994 8.907277,0.344985432 L8.5715332,1.26617432 C8.03534753,0.886232588 7.37701416,1 7,1 C6.4361685,1 6.17731174,1.26360803 5.94717644,1.54441153 C5.71704114,1.82521503 5.60197521,2.29722526 5.60197521,2.96045638 L5.60197521,4.00775146 L8,4.00775146 L8,5 L5.60197521,5 L5.04223633,12.9862671 C5.04223633,13.9704165 4.76202635,14.8299889 4.30750912,15.2979948 C3.85299189,15.7660006 3.10218672,16 2.05507109,16 C1.65808769,16 1.36821649,16.1016241 1,16 L1,14.8848145 C1.40273678,14.98109 1.64904366,15 2,15 C2.54657135,15 2.9684149,14.7404034 3.18992013,14.4676228 C3.41142537,14.1948423 3.73376465,13.6296169 3.73376465,12.9862671 L4.1693901,5 L2.25352327,5 L2.25352327,4.5 L4.1693901,4.00775146 L4.1693901,2.99254805 C4.1693901,1.94956362 4.4023986,1.19006841 4.86842259,0.714039615 C5.33444659,0.238010825 6.09100505,-7.10542736e-15 7.13812069,-7.10542736e-15 Z M13.3046875,7 L14.0546875,7.7734375 L11.3046875,10.5390625 L14.0390625,13.2890625 L13.2890625,14.0625 L10.5234375,11.3203125 L7.8046875,14.0625 L7.015625,13.2890625 L9.75,10.5390625 L7,7.7890625 L7.78125,7 L10.5390625,9.7734375 L13.3046875,7 Z" };
function js(e, t) {
  return s(), o("path", Rs);
}
const Us = /* @__PURE__ */ d(Ys, [["render", js]]), Ws = {}, Xs = { d: "M4,2 L4,4 L7,4 L7,2 L8,2 L8,4 L11,4 L11,2 L12,2 L12,4 L14,4 L14,5 L12,5 L12,8 L14,8 L14,9 L12,9 L12,12 L14,12 L14,13 L12,13 L12,14 L11,14 L11,13 L7.999,13 L8,14 L7,14 L6.999,13 L3.999,13 L4,14 L3,14 L2.999,13 L2,13 L2,12 L2.999,12 L2.999,9 L2,9 L2,8 L3,8 L3,5 L2,5 L2,4 L3,4 L3,2 L4,2 Z M6.999,9 L3.999,9 L3.999,12 L6.999,12 L6.999,9 Z M11,9 L7.999,9 L7.999,12 L11,12 L11,9 Z M11,5 L8,5 L8,8 L11,8 L11,5 Z M7,5 L4,5 L4,8 L7,8 L7,5 Z" };
function qs(e, t) {
  return s(), o("path", Xs);
}
const Gs = /* @__PURE__ */ d(Ws, [["render", qs]]), Js = {}, Qs = /* @__PURE__ */ y("path", { d: "M8.492 9.422h-.984v-6h.984v6zM8.05 12.5a.75.75 0 100-1.5.75.75 0 000 1.5z" }, null, -1), eo = /* @__PURE__ */ y("path", { d: "M8 16c4.418278 0 8-3.581722 8-8s-3.581722-8-8-8-8 3.581722-8 8 3.581722 8 8 8zm0-1c-3.86599325 0-7-3.1340068-7-7 0-3.86599325 3.13400675-7 7-7 3.8659932 0 7 3.13400675 7 7 0 3.8659932-3.1340068 7-7 7z" }, null, -1), to = [
  Qs,
  eo
];
function no(e, t) {
  return s(), o("g", null, to);
}
const io = /* @__PURE__ */ d(Js, [["render", no]]), so = {}, oo = /* @__PURE__ */ y("path", { d: "M8 16A8 8 0 108 0a8 8 0 000 16zm0-1A7 7 0 118 1a7 7 0 010 14z" }, null, -1), ao = /* @__PURE__ */ y("path", { d: "M7.33 12h-.984l1.37-6.422h.985L7.331 12zm.662-8.063a.77.77 0 01.188-.536.624.624 0 01.486-.208c.344 0 .516.176.516.528a.795.795 0 01-.197.545.59.59 0 01-.454.222.541.541 0 01-.386-.143c-.102-.096-.153-.232-.153-.407z" }, null, -1), lo = [
  oo,
  ao
];
function co(e, t) {
  return s(), o("g", null, lo);
}
const ro = /* @__PURE__ */ d(so, [["render", co]]), uo = {}, _o = { d: "M13.854,4.646 L9.354,0.146 C9.26,0.052 9.133,0 9,0 L2.5,0 C1.673,0 1,0.673 1,1.5 L1,14.5 C1,15.327 1.673,16 2.5,16 L12.5,16 C13.327,16 14,15.327 14,14.5 L14,5 C14,4.867 13.947,4.74 13.854,4.646 Z M12.793,5 L9.5,5 C9.224,5 9,4.776 9,4.5 L9,1.207 L12.793,5 Z M13,14.5 C13,14.776 12.776,15 12.5,15 L2.5,15 C2.224,15 2,14.776 2,14.5 L2,1.5 C2,1.224 2.224,1 2.5,1 L8,1 L8,4.5 C8,5.327 8.673,6 9.5,6 L13,6 L13,14.5 Z M6.14525 7.14625c.17333333-.17333333.44306173-.19259259.63781619-.05777778L6.85225 7.14625l3 3c.097.098.146.226.146.354 0 .128-.048.256-.146.354-.17333333.1733333-.44306173.1925926-.63781619.0577778L9.14525 10.85425l-2.146-2.146v5.293c0 .276-.224.5-.5.5-.24533333 0-.44958025-.1769877-.49193964-.4101619L5.99925 14.00125v-5.293l-2.146 2.146c-.195.195-.512.195-.707 0-.17333333-.1733333-.19259259-.4430617-.05777778-.6378162L3.14625 10.14725l2.999-3.001z" };
function ho(e, t) {
  return s(), o("path", _o);
}
const fo = /* @__PURE__ */ d(uo, [["render", ho]]), go = {}, mo = { d: "M2 12l2 4H0l2-4zm8.5 2c.2761424 0 .5.2238576.5.5s-.2238576.5-.5.5h-4c-.27614237 0-.5-.2238576-.5-.5s.22385763-.5.5-.5h4zm4-2c.2761424 0 .5.2238576.5.5s-.2238576.5-.5.5h-8c-.27614237 0-.5-.2238576-.5-.5s.22385763-.5.5-.5h8zM4 6v4H0V6h4zm6.5 2c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5h-4c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5h4zm4-2c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5h-8c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5h8zM2 0c1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2-2-.8954305-2-2 .8954305-2 2-2zm8.5 2c.2761424 0 .5.22385763.5.5 0 .27614237-.2238576.5-.5.5h-4c-.27614237 0-.5-.22385763-.5-.5 0-.27614237.22385763-.5.5-.5h4zm4-2c.2761424 0 .5.22385763.5.5 0 .27614238-.2238576.5-.5.5h-8C6.22385763 1 6 .77614238 6 .5c0-.27614237.22385763-.5.5-.5h8z" };
function vo(e, t) {
  return s(), o("path", mo);
}
const yo = /* @__PURE__ */ d(go, [["render", vo]]), po = {}, Lo = /* @__PURE__ */ y("path", { d: "M 8.5456 10.3984 c -0.7544 0 -1.5088 -0.2872 -2.0832 -0.8616 c -0.156 -0.156 -0.156 -0.4096 0 -0.5656 s 0.4096 -0.156 0.5656 0 c 0.8368 0.8368 2.1976 0.8368 3.0344 0 l 2.9088 -2.9088 c 0.8368 -0.8368 0.8368 -2.1976 0 -3.0344 s -2.1976 -0.8368 -3.0344 0 l -2.4544 2.4544 c -0.156 0.156 -0.4096 0.156 -0.5656 0 s -0.156 -0.4096 0 -0.5656 l 2.4544 -2.4544 c 1.1488 -1.1488 3.0176 -1.1488 4.1656 0 s 1.1488 3.0176 0 4.1656 l -2.9088 2.9088 c -0.5744 0.5744 -1.3288 0.8616 -2.0832 0.8616 z" }, null, -1), Co = /* @__PURE__ */ y("path", { d: "M 3.7456 15.1984 c -0.7544 0 -1.5088 -0.2872 -2.0832 -0.8616 c -1.1488 -1.1488 -1.1488 -3.0176 0 -4.1656 l 2.9088 -2.9088 c 1.1488 -1.1488 3.0176 -1.1488 4.1656 0 c 0.156 0.156 0.156 0.4096 0 0.5656 s -0.4096 0.156 -0.5656 0 c -0.8368 -0.8368 -2.1976 -0.8368 -3.0344 0 l -2.9088 2.9088 c -0.8368 0.8368 -0.8368 2.1976 0 3.0344 s 2.1976 0.8368 3.0344 0 l 2.4544 -2.4544 c 0.156 -0.156 0.4096 -0.156 0.5656 0 s 0.156 0.4096 0 0.5656 l -2.4544 2.4544 c -0.5744 0.5744 -1.3288 0.8616 -2.0832 0.8616 z" }, null, -1), bo = [
  Lo,
  Co
];
function Mo(e, t) {
  return s(), o("g", null, bo);
}
const $o = /* @__PURE__ */ d(po, [["render", Mo]]), xo = {}, So = { d: "M13.5 6c.8284271 0 1.5.67157288 1.5 1.5S14.3284271 9 13.5 9 12 8.32842712 12 7.5 12.6715729 6 13.5 6zm-5 0c.82842712 0 1.5.67157288 1.5 1.5S9.32842712 9 8.5 9 7 8.32842712 7 7.5 7.67157288 6 8.5 6zm-5 0C4.32842712 6 5 6.67157288 5 7.5S4.32842712 9 3.5 9 2 8.32842712 2 7.5 2.67157288 6 3.5 6z" };
function wo(e, t) {
  return s(), o("path", So);
}
const ko = /* @__PURE__ */ d(xo, [["render", wo]]), Io = {}, zo = { d: "M8,14 C8.55228475,14 9,14.4477153 9,15 C9,15.5522847 8.55228475,16 8,16 C7.44771525,16 7,15.5522847 7,15 C7,14.4477153 7.44771525,14 8,14 Z M13,7 C13,4.23857625 10.7614237,2 8,2 C5.3112453,2 3.11818189,4.12230671 3.00461951,6.78311038 L3,7 L3,12 L2,12 L2,7 C2,4.02554217 4.16441316,1.55661012 7.00418559,1.08225776 L7,1 C7,0.44771525 7.44771525,0 8,0 C8.55228475,0 9,0.44771525 9,1 L8.99653742,1.08381389 L8.99653742,1.08381389 C11.8355868,1.55661012 14,4.02554217 14,7 L14,12 L15,12 L15,13 L1,13 L1,12 L13,12 L13,7 Z" };
function To(e, t) {
  return s(), o("path", zo);
}
const Ho = /* @__PURE__ */ d(Io, [["render", To]]), Do = {}, Zo = { d: "M8,14 C8.55228475,14 9,14.4477153 9,15 C9,15.5522847 8.55228475,16 8,16 C7.44771525,16 7,15.5522847 7,15 C7,14.4477153 7.44771525,14 8,14 Z M8,0 C8.55228475,0 9,0.44771525 9,1 L8.99653742,1.08381389 C10.5686158,1.34561727 11.9338362,2.21947863 12.8392544,3.45231218 L14.863961,1.42893219 L15.5710678,2.13603897 L13.3760639,4.33282103 C13.7754241,5.13621525 14,6.04188137 14,7 L14,12 L15,12 L15,13 L4.707,13 L2.13603897,15.5710678 L1.42893219,14.863961 L3.291,13 L1,13 L1,12 L2,12 L2,7 C2,4.02554217 4.16441316,1.55661012 7.00418559,1.08225776 L7,1 C7,0.44771525 7.44771525,0 8,0 Z M8,2 C5.3112453,2 3.11818189,4.12230671 3.00461951,6.78311038 L3,7 L3,12 L4.291,12 L12.1226618,4.17009932 C11.2212471,2.85940678 9.71098616,2 8,2 Z M12.6211189,5.08731905 L5.707,12 L13,12 L13,7 C13,6.41930676 12.9010082,5.8617343 12.7189793,5.34323736 L12.6211189,5.08731905 Z" };
function Bo(e, t) {
  return s(), o("path", Zo);
}
const Ao = /* @__PURE__ */ d(Do, [["render", Bo]]), Vo = {}, No = { d: "M15.3023262,0.697707019 C14.8521624,0.247521778 14.2538131,0 13.6170155,0 C12.980218,0 12.3818686,0.247521778 11.9317048,0.697707019 L1.71891421,10.9109843 C1.67726204,10.9526384 1.64602292,11.002303 1.62599784,11.0575748 L0.0239914699,15.4633023 C-0.0288747403,15.6098929 0.00717040303,15.7733053 0.116907839,15.883048 C0.193003142,15.9591469 0.29553155,16 0.400462967,16 C0.446120149,16 0.492578333,15.9919896 0.537434512,15.9759688 L4.94295203,14.3738861 C4.99822125,14.35386 5.04788345,14.3218184 5.08953561,14.2809653 L15.3023262,4.06768799 C15.75249,3.61750275 16,3.01912486 16,2.38229699 C16,1.74546911 15.75249,1.14709122 15.3023262,0.696905978 L15.3023262,0.697707019 Z M4.58570461,13.6521478 L1.07010163,14.9306098 L2.34850271,11.4148393 L11.214006,2.54891359 L13.4512079,4.78622209 L4.58570461,13.6521478 Z M14.735216,3.50135176 L14.0175171,4.21908481 L11.7803152,1.98177631 L12.4980141,1.26404326 C12.7967883,0.965254831 13.1940858,0.801041354 13.6162145,0.801041354 C14.0383432,0.801041354 14.4356408,0.965254831 14.734415,1.26404326 C15.0331892,1.56283168 15.1973948,1.96014819 15.1973948,2.38229699 C15.1973948,2.80444578 15.0331892,3.20176229 14.734415,3.50055072 L14.735216,3.50135176 Z" };
function Oo(e, t) {
  return s(), o("path", No);
}
const Po = /* @__PURE__ */ d(Vo, [["render", Oo]]), Eo = {}, Fo = { transform: "scale(0.88 0.84)" }, Ko = /* @__PURE__ */ y("path", { d: "M18,5.793 L12.707,0.5 C12.519,0.312 12.267,0.208 12,0.208 C11.733,0.208 11.481,0.312 11.293,0.5 L11,0.793 C10.71,1.083 10.5,1.59 10.5,2 L10.5,3 C10.5,3.142 10.394,3.399 10.293,3.5 L7.5,6.293 C7.399,6.394 7.142,6.5 7,6.5 L6,6.5 C5.59,6.5 5.083,6.71 4.793,7 L4.5,7.293 C4.11,7.683 4.11,8.317 4.5,8.707 L6.053,10.26 L1.103,16.695 C0.95,16.894 0.968,17.176 1.146,17.353 C1.243,17.45 1.371,17.499 1.5,17.499 C1.607,17.499 1.714,17.465 1.805,17.395 L8.24,12.445 L9.793,13.998 C9.981,14.186 10.233,14.29 10.5,14.29 C10.767,14.29 11.019,14.186 11.207,13.998 L11.5,13.705 C11.79,13.415 12,12.908 12,12.498 L12,11.498 C12,11.356 12.106,11.099 12.207,10.998 L15,8.205 C15.101,8.104 15.358,7.998 15.5,7.998 L16.5,7.998 C16.91,7.998 17.417,7.788 17.707,7.498 L18,7.205 C18.188,7.017 18.292,6.765 18.292,6.498 C18.292,6.231 18.188,5.979 18,5.791 L18,5.793 Z M4.234,14.266 L6.767,10.973 L7.527,11.733 L4.234,14.266 L4.234,14.266 Z M17,6.793 C16.899,6.894 16.642,7 16.5,7 L15.5,7 C15.09,7 14.583,7.21 14.293,7.5 L11.5,10.293 C11.21,10.583 11,11.09 11,11.5 L11,12.5 C11,12.642 10.894,12.899 10.793,13 L10.501,13.292 C10.501,13.292 10.5,13.292 10.5,13.292 L10.5,13.293 L5.207,8 L5.5,7.707 C5.601,7.606 5.858,7.5 6,7.5 L7,7.5 C7.41,7.5 7.917,7.29 8.207,7 L11,4.207 C11.29,3.917 11.5,3.41 11.5,3 L11.5,2 C11.5,1.858 11.606,1.601 11.707,1.5 L12,1.207 L17.293,6.5 L17,6.793 Z" }, null, -1), Yo = [
  Ko
];
function Ro(e, t) {
  return s(), o("g", Fo, Yo);
}
const jo = /* @__PURE__ */ d(Eo, [["render", Ro]]), Uo = {}, Wo = /* @__PURE__ */ y("path", { d: "M8 16c4.418278 0 8-3.581722 8-8s-3.581722-8-8-8-8 3.581722-8 8 3.581722 8 8 8zm0-1c-3.86599325 0-7-3.1340068-7-7 0-3.86599325 3.13400675-7 7-7 3.8659932 0 7 3.13400675 7 7 0 3.8659932-3.1340068 7-7 7z" }, null, -1), Xo = /* @__PURE__ */ y("polygon", { points: "7 4 7 12 11 8" }, null, -1), qo = [
  Wo,
  Xo
];
function Go(e, t) {
  return s(), o("g", null, qo);
}
const Jo = /* @__PURE__ */ d(Uo, [["render", Go]]), Qo = {}, e5 = { d: "m2 0 12.057593.00165986.1744009.01174561c.8658555.10056776 1.5614617.75115697 1.7335693 1.64250644l.0260492.16987393L16 2l-.0016599 12.057593-.0117456.1744009c-.1005677.8658555-.7511569 1.5614617-1.6425064 1.7335693l-.1698739.0260492L14 16H3.53518376c-.61298085 0-1.18878468-.2808227-1.56620692-.7561942l-.09789367-.1344054-1.53518376-2.3027756c-.1877343-.2816015-.30042161-.6054334-.32878667-.9408617L0 11.6972244l.00165986-9.75481743.01174561-.17440092C.11397323.90215058.76456244.20654445 1.65591191.03443678l.16987393-.0260492L2 0Zm9 11H4v4h7v-4Zm3-10v6c0 .55228475-.4477153 1-1 1H3c-.55228475 0-1-.44771525-1-1V1l-.11662113.00672773c-.42082504.04887817-.76196299.35902055-.85696816.76398144l-.01968298.1126697L1 2v9.6972244c0 .15794.03740034.3130529.10843045.4528854l.05951926.1018148 1.53518375 2.3027756c.07868921.1180338.18019781.2160687.29653357.2898273L3 11c0-.5522847.44771525-1 1-1h7c.5522847 0 1 .4477153 1 1v4h2l.1166211-.0067277c.4208251-.0488782.761963-.3590206.8569682-.7639815l.019683-.1126697L15 14V2l-.0067277-.11662113c-.0488782-.42082504-.3590206-.76196299-.7639815-.85696816l-.1126697-.01968298L14 1ZM5.5 12c.27614237 0 .5.2238576.5.5v1c0 .2761424-.22385763.5-.5.5-.27614237 0-.5-.2238576-.5-.5v-1c0-.2761424.22385763-.5.5-.5ZM13 1H3v6h10V1Z" };
function t5(e, t) {
  return s(), o("path", e5);
}
const n5 = /* @__PURE__ */ d(Qo, [["render", t5]]), i5 = {}, s5 = { "fill-rule": "nonzero" }, o5 = /* @__PURE__ */ y("path", { d: "m2 0 12.057593.00165986.1744009.01174561c.8658555.10056776 1.5614617.75115697 1.7335693 1.64250644l.0260492.16987393L16 2l-.0002497 9.1824454c-.0076847-.4662474-.192545-.903197-.5230306-1.23366678L15 9.472V2l-.0067277-.11662113c-.0488782-.42082504-.3590206-.76196299-.7639815-.85696816l-.1126697-.01968298L14 1v6c0 .39796989-.232475.74164235-.5690323.90262472L12.527 6.999 13 7V1H3v6l4.471-.001 1 1L3 8c-.55228475 0-1-.44771525-1-1V1l-.11662113.00672773c-.42082504.04887817-.76196299.35902055-.85696816.76398144l-.01968298.1126697L1 2v9.6972244c0 .15794.03740034.3130529.10843045.4528854l.05951926.1018148 1.53518375 2.3027756c.07868921.1180338.18019781.2160687.29653357.2898273L3 11c0-.5522847.44771525-1 1-1l6.472-.001L12 11.527V15h2l.1166211-.0067277c.4208251-.0488782.761963-.3590206.8569682-.7639815l.019683-.1126697L15 14l.0016817-1.1820063c.173958-.0855562.3345079-.2001248.4756388-.341249C15.8143587 12.1391218 16 11.6903598 16 11.2127616l-.002.0292384.0003401 2.815593-.0117456.1744009c-.1005677.8658555-.7511569 1.5614617-1.6425064 1.7335693l-.1698739.0260492L14 16H3.53518376c-.61298085 0-1.18878468-.2808227-1.56620692-.7561942l-.09789367-.1344054-1.53518376-2.3027756c-.1877343-.2816015-.30042161-.6054334-.32878667-.9408617L0 11.6972244l.00165986-9.75481743.01174561-.17440092C.11397323.90215058.76456244.20654445 1.65591191.03443678l.16987393-.0260492L2 0Zm9 11H4v4h7v-4Zm-5.5 1c.27614237 0 .5.2238576.5.5v1c0 .2761424-.22385763.5-.5.5-.27614237 0-.5-.2238576-.5-.5v-1c0-.2761424.22385763-.5.5-.5Z" }, null, -1), a5 = /* @__PURE__ */ y("path", { d: "M14.8004 11.2119616c0-.1196798-.03340026-.2302943-.09752333-.3255422l-.07426486-.0898924L7.1108 3.278l-1.3056-.4752.4752 1.3056 7.51774193 7.5189963c.08431571.0843117.18611029.1387954.29907749.1607678l.11645784.0110359c.15961988 0 .30311438-.0593881.41478006-.1710478.11245013-.1126452.17194268-.2565003.17194268-.4161906Z" }, null, -1), l5 = [
  o5,
  a5
];
function c5(e, t) {
  return s(), o("g", s5, l5);
}
const r5 = /* @__PURE__ */ d(i5, [["render", c5]]), u5 = {}, d5 = { d: "M.5 0c.27614238 0 .5.23878147.5.53333333V15h14.4666667C15.7612185 15 16 15.2238576 16 15.5s-.2387815.5-.5333333.5H.5c-.12656525 0-.24214708-.0501607-.33022613-.1328614-.02350461-.0217349-.04591173-.045217-.06583436-.0705232-.0489945-.062234-.08296322-.1354998-.09688543-.2150906L0 15.4666667V.53333333C0 .23878147.22385763 0 .5 0zm3.50007802 11.000156l.11661338.0065799C4.61399617 11.0645327 5 11.4871883 5 12c0 .5522847-.44771525 1-1 1s-1-.4477153-1-1c0-.5128358.38604019-.9355072.88344134-.9931473l.11663668-.0066967zm5-1l.11661338.0065799C9.61399617 10.0645327 10 10.4871883 10 11c0 .5522847-.44771525 1-1 1s-1-.4477153-1-1c0-.5128358.38604019-.9355072.88344134-.9931473l.11663668-.0066967zM13.000078 7.00015604l.1166134.00657985C13.6139962 7.06453265 14 7.48718831 14 8c0 .55228475-.4477153 1-1 1s-1-.44771525-1-1c0-.51283584.3860402-.93550716.8834413-.99314733l.1166367-.00669663zm-5.99999998-1l.11661338.00657985C7.61399617 6.06453265 8 6.48718831 8 7c0 .55228475-.44771525 1-1 1s-1-.44771525-1-1c0-.51283584.38604019-.93550716.88344134-.99314733l.11663668-.00669663zm-2-4l.11661338.00657985C5.61399617 2.06453265 6 2.48718831 6 3c0 .55228475-.44771525 1-1 1s-1-.44771525-1-1c0-.51283584.38604019-.93550716.88344134-.99314733l.11663668-.00669663zm5.99999998 0l.1166134.00657985C11.6139962 2.06453265 12 2.48718831 12 3c0 .55228475-.4477153 1-1 1s-1-.44771525-1-1c0-.51283584.3860402-.93550716.8834413-.99314733l.1166367-.00669663z" };
function _5(e, t) {
  return s(), o("path", d5);
}
const h5 = /* @__PURE__ */ d(u5, [["render", _5]]), f5 = {}, g5 = { d: "M6 0c3.3137085 0 6 2.6862915 6 6 0 1.73116165-.7331617 3.29108421-1.9059232 4.3862057l4.2594766 4.2602409c.1952621.1952622.1952621.5118446 0 .7071068-.1952622.1952621-.5118446.1952621-.7071068 0l-4.34401552-4.343372C8.3552042 11.6358004 7.22013379 12 6 12c-3.3137085 0-6-2.6862915-6-6s2.6862915-6 6-6zm0 1C3.23857625 1 1 3.23857625 1 6s2.23857625 5 5 5 5-2.23857625 5-5-2.23857625-5-5-5z" };
function m5(e, t) {
  return s(), o("path", g5);
}
const v5 = /* @__PURE__ */ d(f5, [["render", m5]]), y5 = {}, p5 = { d: "M15 13v2h-2v-1h1v-1h1zM4 14v1H1v-1h3zm4 0v1H6v-1h2zm4 0v1h-2v-1h2zM2 10v2H1v-2h1zm0-4v2H1V6h1zm13 0v2h-1V6h1zM3 1v1H2v2H1V1h2zm12 0v3h-1V2h-2V1h3zm-5 0v1H8V1h2zM6 1v1H4V1h2zm8 9h1v2h-1v-2z M.5.5h2v2h-2zM13.5.5h2v2h-2zM13.5 13.5h2v2h-2zM.5 13.5h2v2h-2z" };
function L5(e, t) {
  return s(), o("path", p5);
}
const C5 = /* @__PURE__ */ d(y5, [["render", L5]]), b5 = {}, M5 = { d: "M1.7962963 7l.83333333-2.21730245h2.71296296L6.18518519 7H7L4.33796296 0h-.66203703L1 7h.7962963zM5 4H3l.72727273-2.04668675C3.84284708 1.60692771 3.931642 1.28915663 3.99365751 1c.09866102.37650602.19450317.69427711.28752642.95331325L5 4zm2 12v-.875H2.2L7 9.875V9H1c.02613038.45035644.02613038.74202311 0 .875h4.8L1 15.125V16h6zM12 14.2928932V.5c0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5v13.7928932l2.14644661-2.1464466c.19526215-.1952621.51184463-.1952621.70710678 0 .19526215.1952622.19526215.5118446 0 .7071068l-3 3c-.19526215.1952621-.51184463.1952621-.70710678 0l-3-3c-.19526215-.1952622-.19526215-.5118446 0-.7071068.19526214-.1952621.51184463-.1952621.70710678 0L12 14.2928932z" };
function $5(e, t) {
  return s(), o("path", M5);
}
const x5 = /* @__PURE__ */ d(b5, [["render", $5]]), S5 = {}, w5 = { d: "M1.7962963 16l.83333333-2.2173025h2.71296296L6.18518519 16H7L4.33796296 9h-.66203703L1 16h.7962963zM5 13H3l.72727273-2.0466867c.11557435-.3463856.20436927-.6641567.26638478-.9533133.09866102.376506.19450317.6942771.28752642.9533133L5 13zm2-6v-.875H2.2L7 .875V0H1c.02613038.45035644.02613038.74202311 0 .875h4.8L1 6.125V7h6zM12 14.2928932V.5c0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5v13.7928932l2.14644661-2.1464466c.19526215-.1952621.51184463-.1952621.70710678 0 .19526215.1952622.19526215.5118446 0 .7071068l-3 3c-.19526215.1952621-.51184463.1952621-.70710678 0l-3-3c-.19526215-.1952622-.19526215-.5118446 0-.7071068.19526214-.1952621.51184463-.1952621.70710678 0L12 14.2928932z" };
function k5(e, t) {
  return s(), o("path", w5);
}
const I5 = /* @__PURE__ */ d(S5, [["render", k5]]), z5 = {}, T5 = { d: "M8 0c4.418278 0 8 3.581722 8 8s-3.581722 8-8 8-8-3.581722-8-8 3.581722-8 8-8Zm0 1C4.13400675 1 1 4.13400675 1 8c0 3.8659932 3.13400675 7 7 7 3.8659932 0 7-3.1340068 7-7 0-3.86599325-3.1340068-7-7-7Zm4.8991425 5.20041663c.1484951.19674803.1293267.46671349-.0332055.64086825l-.0676223.06048677-5.96685861 3.99802955c-.17561946.1308861-.41260001.1320614-.58794687.0122119l-.07101658-.0587484-3.02483376-3.00580729c-.19687851-.19564012-.19687851-.51283543 0-.70847556.17500312-.17390233.4466578-.19322481.64313904-.05796744l.06982112.05796744 2.71574274 2.69876743L12.193348 6.10022306c.2227426-.16600615.5387376-.12114796.7057945.10019357Z" };
function H5(e, t) {
  return s(), o("path", T5);
}
const D5 = /* @__PURE__ */ d(z5, [["render", H5]]), Z5 = {}, B5 = { d: "M14.5714286,0 C15.3604068,0 16,0.559644063 16,1.25 L16,15 L15.9714234,15 C15.8390604,15.5705601 15.2625594,16 14.5714286,16 L1.42857143,16 C0.639593215,16 0,15.4403559 0,14.75 L0,1.25 C0,0.559644063 0.639593215,0 1.42857143,0 L14.5714286,0 Z M1,13 L1,14 C1,14.5522847 1.52233446,15 2.16666667,15 L2.999,15 L2.999,13 L1,13 Z M9,13 L6.999,13 L6.999,15 L9,15 L9,13 Z M5.999,13 L3.999,13 L3.999,15 L5.999,15 L5.999,13 Z M12,13 L10,13 L10,15 L12,15 L12,13 Z M15,13 L13,13 L13,15 L15,15 L15,13 Z M6,10 L4,10 L4,12 L6,12 L6,10 Z M9,10 L7,10 L7,12 L9,12 L9,10 Z M12,10 L10,10 L10,12 L12,12 L12,10 Z M15,10 L13,10 L13,12 L15,12 L15,10 Z M6,7 L4,7 L4,9 L6,9 L6,7 Z M9,7 L7,7 L7,9 L9,9 L9,7 Z M12,7 L10,7 L10,9 L12,9 L12,7 Z M15,7 L13,7 L13,9 L15,9 L15,7 Z M3,7 L1,7 L1,9 L3,9 L3,7 Z M6,4 L4,4 L4,6 L6,6 L6,4 Z M9,4 L7,4 L7,6 L9,6 L9,4 Z M12,4 L10,4 L10,6 L12,6 L12,4 Z M15,4 L13,4 L13,6 L15,6 L15,4 Z M3,4 L1,4 L1,6 L3,6 L3,4 Z M14.4166667,1 L1.58333333,1 C1.26116723,1 1,1.22385763 1,1.5 L1,3 L15,3 L15,1.5 C15,1.22385763 14.7388328,1 14.4166667,1 Z M1,12 L3,12 L3,10 L1,10 L1,12 Z" };
function A5(e, t) {
  return s(), o("path", B5);
}
const V5 = /* @__PURE__ */ d(Z5, [["render", A5]]), N5 = {}, O5 = { transform: "rotate(45 8.83 11.076)" }, P5 = /* @__PURE__ */ y("path", { d: "M4.53392856,0.573113276 L1.15892856,4.83977994 C1.01287866,5.02441586 0.933928556,5.24898505 0.933928556,5.47977994 L0.933928556,15.0797799 C0.933928556,15.6688837 1.43760821,16.1464466 2.05892856,16.1464466 L8.80892856,16.1464466 C9.4302489,16.1464466 9.93392856,15.6688837 9.93392856,15.0797799 L9.93392856,5.47977994 C9.93392856,5.24898505 9.85497845,5.02441586 9.70892856,4.83977994 L6.33392856,0.573113276 C5.88392856,0.00422438719 4.98392856,0.00422438719 4.53392856,0.573113276 Z M5.43392856,1.21311328 L8.80892856,5.47977994 L8.80892856,15.0797799 L2.05892856,15.0797799 L2.05892856,5.47977994 L5.43392856,1.21311328 Z" }, null, -1), E5 = /* @__PURE__ */ y("path", { d: "M5.31064573,4.9524531 C5.86293048,4.9524531 6.31064573,5.40016835 6.31064573,5.9524531 C6.31064573,6.50473785 5.86293048,6.9524531 5.31064573,6.9524531 C4.75836098,6.9524531 4.31064573,6.50473785 4.31064573,5.9524531 C4.31064573,5.40016835 4.75836098,4.9524531 5.31064573,4.9524531 Z" }, null, -1), F5 = [
  P5,
  E5
];
function K5(e, t) {
  return s(), o("g", O5, F5);
}
const Y5 = /* @__PURE__ */ d(N5, [["render", K5]]), R5 = {}, j5 = { d: "M16,1 L16,3 L11,3 L11,15 L9,15 L9,3 L4,3 L4,1 L16,1 Z M1,11 C1.55228475,11 2,11.4477153 2,12 C2,12.5522847 1.55228475,13 1,13 C0.44771525,13 0,12.5522847 0,12 C0,11.4477153 0.44771525,11 1,11 Z M1,3 C1.55228475,3 2,3.44771525 2,4 C2,4.55228475 1.55228475,5 1,5 C0.44771525,5 0,4.55228475 0,4 C0,3.44771525 0.44771525,3 1,3 Z" };
function U5(e, t) {
  return s(), o("path", j5);
}
const W5 = /* @__PURE__ */ d(R5, [["render", U5]]), X5 = {}, q5 = { "fill-rule": "evenodd" }, G5 = /* @__PURE__ */ y("path", { d: "M16,12 L16,15 L11,15 L11,12 L16,12 Z M15,1 L15,2 L12,2 L12,1 L15,1 Z M15,13 L15,14 L12,14 L12,13 L15,13 Z M5,6 L5,9 L0,9 L0,6 L5,6 Z M14,5 L14,7 L16,7 L16,8 L14,8 L14,10 L13,10 L13,8 L11,8 L11,7 L13,7 L13,5 L14,5 Z M4,7 L4,8 L1,8 L1,7 L4,7 Z M16,0 L16,3 L11,3 L11,0 L16,0 Z" }, null, -1), J5 = /* @__PURE__ */ y("path", {
  d: "M7.43933983,2.14644661 L8.99978644,3.707 L9,2.91421356 C9,2.63807119 9.22385763,2.41421356 9.5,2.41421356 C9.77614237,2.41421356 10,2.63807119 10,2.91421356 L10,4.91421356 C10,5.15967345 9.82312484,5.36382193 9.58987563,5.40615789 L9.5,5.41421356 L7.5,5.41421356 C7.22385763,5.41421356 7,5.19035594 7,4.91421356 C7,4.63807119 7.22385763,4.41421356 7.5,4.41421356 L8.29278644,4.414 L6.73223305,2.85355339 C6.5369709,2.65829124 6.5369709,2.34170876 6.73223305,2.14644661 C6.92749519,1.95118446 7.24407768,1.95118446 7.43933983,2.14644661 Z",
  transform: "rotate(-90 8.293 3.707)"
}, null, -1), Q5 = /* @__PURE__ */ y("path", { d: "M7.43933983,10.1464466 L8.99978644,11.707 L9,10.9142136 C9,10.6380712 9.22385763,10.4142136 9.5,10.4142136 C9.77614237,10.4142136 10,10.6380712 10,10.9142136 L10,12.9142136 C10,13.1596735 9.82312484,13.3638219 9.58987563,13.4061579 L9.5,13.4142136 L7.5,13.4142136 C7.22385763,13.4142136 7,13.1903559 7,12.9142136 C7,12.6380712 7.22385763,12.4142136 7.5,12.4142136 L8.29278644,12.414 L6.73223305,10.8535534 C6.5369709,10.6582912 6.5369709,10.3417088 6.73223305,10.1464466 C6.92749519,9.95118446 7.24407768,9.95118446 7.43933983,10.1464466 Z" }, null, -1), e2 = [
  G5,
  J5,
  Q5
];
function t2(e, t) {
  return s(), o("g", q5, e2);
}
const n2 = /* @__PURE__ */ d(X5, [["render", t2]]), i2 = {}, s2 = { "fill-rule": "evenodd" }, o2 = /* @__PURE__ */ y("path", { d: "M5 12L5 15 0 15 0 12 5 12zM4 1L4 2 1 2 1 1 4 1zM4 13L4 14 1 14 1 13 4 13zM16 6L16 9 11 9 11 6 16 6zM3 5L3 7 5 7 5 8 3 8 3 10 2 10 2 8 0 8 0 7 2 7 2 5 3 5zM15 7L15 8 12 8 12 7 15 7zM5 0L5 3 0 3 0 0 5 0zM7.43933983 1.73223305L8.99978644 3.29278644 9 2.5C9 2.22385763 9.22385763 2 9.5 2 9.77614237 2 10 2.22385763 10 2.5L10 4.5C10 4.74545989 9.82312484 4.94960837 9.58987563 4.99194433L9.5 5 7.5 5C7.22385763 5 7 4.77614237 7 4.5 7 4.22385763 7.22385763 4 7.5 4L8.29278644 3.99978644 6.73223305 2.43933983C6.5369709 2.24407768 6.5369709 1.92749519 6.73223305 1.73223305 6.92749519 1.5369709 7.24407768 1.5369709 7.43933983 1.73223305z" }, null, -1), a2 = /* @__PURE__ */ y("path", {
  d: "M7.43933983,10.1464466 L8.99978644,11.707 L9,10.9142136 C9,10.6380712 9.22385763,10.4142136 9.5,10.4142136 C9.77614237,10.4142136 10,10.6380712 10,10.9142136 L10,12.9142136 C10,13.1596735 9.82312484,13.3638219 9.58987563,13.4061579 L9.5,13.4142136 L7.5,13.4142136 C7.22385763,13.4142136 7,13.1903559 7,12.9142136 C7,12.6380712 7.22385763,12.4142136 7.5,12.4142136 L8.29278644,12.414 L6.73223305,10.8535534 C6.5369709,10.6582912 6.5369709,10.3417088 6.73223305,10.1464466 C6.92749519,9.95118446 7.24407768,9.95118446 7.43933983,10.1464466 Z",
  transform: "rotate(-90 8.293 11.707)"
}, null, -1), l2 = [
  o2,
  a2
];
function c2(e, t) {
  return s(), o("g", s2, l2);
}
const r2 = /* @__PURE__ */ d(i2, [["render", c2]]), u2 = {}, d2 = { d: "M14.3636364,3 C14.7150903,3 15,3.24251243 15,3.54166667 L15,15.4583333 C15,15.7574876 14.7150903,16 14.3636364,16 L1.63636364,16 C1.2849097,16 1,15.7574876 1,15.4583333 L1,3.54166667 C1,3.24251243 1.2849097,3 1.63636364,3 L14.3636364,3 Z M14,4 L2,4 L2,15 L14,15 L14,4 Z M4,5 L4,14 L3,14 L3,5 L4,5 Z M10,5 L10,14 L9,14 L9,5 L10,5 Z M7,5 L7,14 L6,14 L6,5 L7,5 Z M13,5 L13,14 L12,14 L12,5 L13,5 Z M10.5454545,0 C10.857858,0 11.1176834,0.176875161 11.1715655,0.410124368 L11.1818182,0.5 L11.1818182,1 L14.6818182,1 C14.8324413,1 14.9586196,1.08223341 14.9915966,1.19267729 L15,1.25 L15,1.75 C15,1.86834673 14.8953393,1.96748682 14.7547744,1.99339732 L14.6818182,2 L1.31818182,2 C1.1675587,2 1.04138041,1.91776659 1.00840341,1.80732271 L1,1.75 L1,1.25 C1,1.13165327 1.10466071,1.03251318 1.24522565,1.00660268 L1.31818182,1 L4.81818182,1 L4.81818182,0.5 C4.81818182,0.254540111 5.04329566,0.0503916296 5.34015829,0.00805566941 L5.45454545,0 L10.5454545,0 Z" };
function _2(e, t) {
  return s(), o("path", d2);
}
const h2 = /* @__PURE__ */ d(u2, [["render", _2]]), f2 = {}, g2 = { d: "M3.8125 12c.4807836 0 .87703796.3860402.93119275.8833789L4.75 13c0 .5522847.41973305 1 .9375 1h5.625c.4807836 0 .877038-.3860402.9311928-.8833789L12.25 13c0-.5522847.419733-1 .9375-1h1.875c.517767 0 .9375.4477153.9375 1v2c0 .5522847-.419733 1-.9375 1H1.9375C1.41973305 16 1 15.5522847 1 15v-2c0-.5522847.41973305-1 .9375-1h1.875zM8.7507211.05347034l.09002051.05133153 4.45452719 3.82608696c.235233.16500457.2733718.46597048.0851854.67222619-.1672768.18333841-.4570724.23013159-.6846179.12237866l-.0820507-.04768686L9 1.5266087v9.9951304C9 11.7858753 8.77614237 12 8.5 12c-.24545989 0-.44960837-.1691849-.49194433-.3922929L8 11.5217391V1.5266087L4.38621442 4.67780682c-.235233.16500457-.57848223.13156391-.76666863-.0746918-.1672768-.1833384-.15572874-.44150957.01411429-.61250548L8.15925839.10480187c.170751-.11977357.40310955-.13688408.59146271-.05133153z" };
function m2(e, t) {
  return s(), o("path", g2);
}
const v2 = /* @__PURE__ */ d(f2, [["render", m2]]), y2 = {}, p2 = { d: "M6.5 0a6.5 6.5 0 014.936 10.729l4.216 4.216a.5.5 0 01-.638.765l-.07-.058-4.215-4.216A6.5 6.5 0 116.5 0zm0 1a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm0 1a.5.5 0 01.5.5V6h3.5a.5.5 0 110 1H7v3.5a.5.5 0 11-1 0V7H2.5a.5.5 0 010-1H6V2.5a.5.5 0 01.5-.5z" };
function L2(e, t) {
  return s(), o("path", p2);
}
const C2 = /* @__PURE__ */ d(y2, [["render", L2]]), b2 = {}, M2 = { d: "M192-212q-26 0-43-17t-17-43v-416q0-26 17-43t43-17h576q26 0 43 17t17 43v416q0 26-17 43t-43 17H192Zm288-274L160-698v426q0 14 9 23t23 9h576q14 0 23-9t9-23v-426L480-486Zm0-34 304-200H176l304 200ZM160-698v-22 448q0 14 9 23t23 9h-32v-458Z" };
function $2(e, t) {
  return s(), o("path", M2);
}
const x2 = /* @__PURE__ */ d(b2, [["render", $2]]), Ae = {
  IconAxisSwap: Ci,
  IconBarChart: xi,
  IconCalendar: Ii,
  IconChangeDict: Di,
  IconCloudWatch: Vi,
  IconCollapse: Ei,
  IconColumnSelection: Ri,
  IconComparison: Ji,
  IconCopy: ss,
  IconDataCheckRun: cs,
  IconDataCheckView: _s,
  IconDebug: ms,
  IconDiff: Ls,
  IconDoc: $s,
  IconDraggable: Ts,
  IconEnlarge: Bs,
  IconExcel: Os,
  IconFlattening: Ks,
  IconFormula: Us,
  IconGridlines: Gs,
  IconInfo: io,
  IconInspect: ro,
  IconJsonUploader: fo,
  IconLegend: yo,
  IconLink: $o,
  IconMore: ko,
  IconNotification: Ho,
  IconNotificationOffline: Ao,
  IconPencil: Po,
  IconPin: jo,
  IconRun: Jo,
  IconSave: n5,
  IconSaveAs: r5,
  IconScatterPlot: h5,
  IconSearch: v5,
  IconSelection: C5,
  IconSortAZ: x5,
  IconSortZA: I5,
  IconSuccess: D5,
  IconTable: V5,
  IconTag: Y5,
  IconTicker: W5,
  IconTraceDep: n2,
  IconTracePrec: r2,
  IconTrash: h2,
  IconUpload: v2,
  IconZoomIn: C2,
  IconEmail: x2
};
const S2 = {}, w2 = { class: "iconArrow" };
function k2(e, t) {
  return s(), o("div", w2);
}
const I2 = /* @__PURE__ */ d(S2, [["render", k2]]);
const z2 = {}, T2 = { class: "iconAsk" };
function H2(e, t) {
  return s(), o("div", T2);
}
const D2 = /* @__PURE__ */ d(z2, [["render", H2]]);
const Z2 = {}, B2 = { class: "iconCalendar" };
function A2(e, t) {
  return s(), o("div", B2);
}
const V2 = /* @__PURE__ */ d(Z2, [["render", A2]]);
const N2 = {}, O2 = { class: "iconChangeDict" };
function P2(e, t) {
  return s(), o("div", O2);
}
const E2 = /* @__PURE__ */ d(N2, [["render", P2]]);
const F2 = {}, K2 = { class: "iconCollapse" };
function Y2(e, t) {
  return s(), o("div", K2);
}
const R2 = /* @__PURE__ */ d(F2, [["render", Y2]]);
const j2 = {}, U2 = { class: "iconColumnSelection" };
function W2(e, t) {
  return s(), o("div", U2);
}
const X2 = /* @__PURE__ */ d(j2, [["render", W2]]);
const q2 = {}, G2 = { class: "iconComment" };
function J2(e, t) {
  return s(), o("div", G2);
}
const Q2 = /* @__PURE__ */ d(q2, [["render", J2]]);
const ea = {}, ta = { class: "iconDoc" };
function na(e, t) {
  return s(), o("div", ta);
}
const ia = /* @__PURE__ */ d(ea, [["render", na]]);
const sa = {}, oa = { class: "iconExternal" };
function aa(e, t) {
  return s(), o("div", oa);
}
const la = /* @__PURE__ */ d(sa, [["render", aa]]);
const ca = {}, ra = { class: "iconEye" };
function ua(e, t) {
  return s(), o("div", ra);
}
const da = /* @__PURE__ */ d(ca, [["render", ua]]);
const _a = {}, ha = { class: "iconEye" }, fa = /* @__PURE__ */ y("span", { class: "iconEye__close" }, null, -1), ga = [
  fa
];
function ma(e, t) {
  return s(), o("div", ha, ga);
}
const va = /* @__PURE__ */ d(_a, [["render", ma]]);
const ya = {}, pa = { class: "iconFormula" };
function La(e, t) {
  return s(), o("div", pa);
}
const Ca = /* @__PURE__ */ d(ya, [["render", La]]);
const ba = {}, Ma = { class: "iconGridlines" };
function $a(e, t) {
  return s(), o("div", Ma);
}
const xa = /* @__PURE__ */ d(ba, [["render", $a]]);
const Sa = {}, wa = { class: "iconHelp" };
function ka(e, t) {
  return s(), o("div", wa);
}
const Ia = /* @__PURE__ */ d(Sa, [["render", ka]]);
const za = {}, Ta = { class: "iconInfo" };
function Ha(e, t) {
  return s(), o("div", Ta);
}
const Da = /* @__PURE__ */ d(za, [["render", Ha]]);
const Za = {}, Ba = { class: "iconInspect" };
function Aa(e, t) {
  return s(), o("div", Ba);
}
const Va = /* @__PURE__ */ d(Za, [["render", Aa]]);
const Na = {}, Oa = { class: "iconJsonUploader" };
function Pa(e, t) {
  return s(), o("div", Oa);
}
const Ea = /* @__PURE__ */ d(Na, [["render", Pa]]);
const Fa = {}, Ka = { class: "iconLegend" };
function Ya(e, t) {
  return s(), o("div", Ka);
}
const Ra = /* @__PURE__ */ d(Fa, [["render", Ya]]);
const ja = {}, Ua = { class: "iconMinus" };
function Wa(e, t) {
  return s(), o("div", Ua);
}
const Xa = /* @__PURE__ */ d(ja, [["render", Wa]]);
const qa = {}, Ga = { class: "iconMore" };
function Ja(e, t) {
  return s(), o("span", Ga);
}
const Qa = /* @__PURE__ */ d(qa, [["render", Ja]]);
const el = {}, tl = { class: "iconNewIssue" };
function nl(e, t) {
  return s(), o("div", tl);
}
const il = /* @__PURE__ */ d(el, [["render", nl]]);
const sl = {}, ol = { class: "iconNotification" };
function al(e, t) {
  return s(), o("div", ol);
}
const ll = /* @__PURE__ */ d(sl, [["render", al]]);
const cl = {}, rl = { class: "iconNotificationOffline" };
function ul(e, t) {
  return s(), o("div", rl);
}
const dl = /* @__PURE__ */ d(cl, [["render", ul]]);
const _l = {}, hl = { class: "iconPause" };
function fl(e, t) {
  return s(), o("div", hl);
}
const gl = /* @__PURE__ */ d(_l, [["render", fl]]);
const ml = {}, vl = { class: "iconPencil" };
function yl(e, t) {
  return s(), o("div", vl);
}
const pl = /* @__PURE__ */ d(ml, [["render", yl]]);
const Ll = {}, Cl = { class: "iconPlay" };
function bl(e, t) {
  return s(), o("div", Cl);
}
const Ml = /* @__PURE__ */ d(Ll, [["render", bl]]);
const $l = {}, xl = { class: "iconPlus" };
function Sl(e, t) {
  return s(), o("div", xl);
}
const wl = /* @__PURE__ */ d($l, [["render", Sl]]);
const kl = {}, Il = { class: "iconRun" };
function zl(e, t) {
  return s(), o("div", Il);
}
const Tl = /* @__PURE__ */ d(kl, [["render", zl]]);
const Hl = {}, Dl = { class: "iconSearch" };
function Zl(e, t) {
  return s(), o("div", Dl);
}
const Bl = /* @__PURE__ */ d(Hl, [["render", Zl]]);
const Al = {}, Vl = { class: "iconSelection" };
function Nl(e, t) {
  return s(), o("div", Vl);
}
const Ol = /* @__PURE__ */ d(Al, [["render", Nl]]);
const Pl = {}, El = { class: "iconSortAZ" };
function Fl(e, t) {
  return s(), o("div", El);
}
const Kl = /* @__PURE__ */ d(Pl, [["render", Fl]]);
const Yl = {}, Rl = { class: "iconSortZA" };
function jl(e, t) {
  return s(), o("div", Rl);
}
const Ul = /* @__PURE__ */ d(Yl, [["render", jl]]);
const Wl = {}, Xl = { class: "iconStar" };
function ql(e, t) {
  return s(), o("span", Xl);
}
const Gl = /* @__PURE__ */ d(Wl, [["render", ql]]);
const Jl = {}, Ql = { class: "iconSuccess" };
function ec(e, t) {
  return s(), o("div", Ql);
}
const tc = /* @__PURE__ */ d(Jl, [["render", ec]]);
const nc = {}, ic = { class: "iconTable" };
function sc(e, t) {
  return s(), o("div", ic);
}
const oc = /* @__PURE__ */ d(nc, [["render", sc]]);
const ac = {}, lc = { class: "iconTag" };
function cc(e, t) {
  return s(), o("div", lc);
}
const rc = /* @__PURE__ */ d(ac, [["render", cc]]);
const uc = {}, dc = { class: "iconTick" };
function _c(e, t) {
  return s(), o("span", dc);
}
const hc = /* @__PURE__ */ d(uc, [["render", _c]]);
const fc = {}, gc = { class: "iconTicker" };
function mc(e, t) {
  return s(), o("div", gc);
}
const vc = /* @__PURE__ */ d(fc, [["render", mc]]);
const yc = {}, pc = { class: "iconTrash" };
function Lc(e, t) {
  return s(), o("span", pc);
}
const Cc = /* @__PURE__ */ d(yc, [["render", Lc]]);
const bc = {}, Mc = { class: "iconUpload" };
function $c(e, t) {
  return s(), o("div", Mc);
}
const xc = /* @__PURE__ */ d(bc, [["render", $c]]);
const Sc = {}, wc = { class: "iconZoomIn" };
function kc(e, t) {
  return s(), o("div", wc);
}
const Ic = /* @__PURE__ */ d(Sc, [["render", kc]]);
const zc = {}, Tc = { class: "iconBack" };
function Hc(e, t) {
  return s(), o("div", Tc);
}
const Dc = /* @__PURE__ */ d(zc, [["render", Hc]]), Ve = {
  IconArrow: I2,
  IconAsk: D2,
  IconCalendar: V2,
  IconChangeDict: E2,
  IconCollapse: R2,
  IconColumnSelection: X2,
  IconComment: Q2,
  IconDoc: ia,
  IconExternal: la,
  IconEye: da,
  IconEyeClosed: va,
  IconFormula: Ca,
  IconGridlines: xa,
  IconHelp: Ia,
  IconInfo: Da,
  IconInspect: Va,
  IconJsonUploader: Ea,
  IconLegend: Ra,
  IconMinus: Xa,
  IconMore: Qa,
  IconNewIssue: il,
  IconNotification: ll,
  IconNotificationOffline: dl,
  IconPause: gl,
  IconPencil: pl,
  IconPlay: Ml,
  IconPlus: wl,
  IconRun: Tl,
  IconSearch: Bl,
  IconSelection: Ol,
  IconSortAZ: Kl,
  IconSortZA: Ul,
  IconStar: Gl,
  IconSuccess: tc,
  IconTable: oc,
  IconTag: rc,
  IconTick: hc,
  IconTicker: vc,
  IconTrash: Cc,
  IconUpload: xc,
  IconZoomIn: Ic,
  IconBack: Dc
}, Zc = {
  white: "#fafafa",
  // Core
  blackPearl: "#041c2c",
  prussianBlue: "#002b49",
  cloudBurst: "#1d2e43",
  jungleGreen: "#279989",
  keppel: "#3ba293",
  tradewind: "#50ab9f",
  // Support
  goldenTanoi: "#ffc658",
  brickRed: "#d32a37",
  punch: "#dd3848",
  jacksonsBlue: "#1e4294",
  stTropaz: "#2d519a",
  grayChateau: "#a9b0b7",
  platinum: "#e8e7ea",
  porcelain: "#f2f3f4",
  babyPowder: "#fcfdfd",
  allPorts: "#007da0",
  curiousBlue: "#2587cc",
  hotCinnamon: "#de5722",
  feijoa: "#a2d780",
  // Sheets set
  carnation: "#f86e6c",
  salmon: "#ff8a5f",
  picasso: "#FFEB95",
  dandelion: "#ffd966",
  koromiko: "#ffbc64",
  celadon: "#a9dd9e",
  chatams: "#115b89",
  havelock: "#60aee2",
  blizzardBlue: "#98daec",
  rockBlue: "#96a8cc",
  nubes: "#bfddf2",
  mischka: "#a5a9b2",
  chateauGreen: "#3Eaf68",
  cannonPink: "#874273",
  highlighterYellow: "#ffff52",
  highlighterGreen: "#31B217",
  // Derived colours
  jungleGreen50: "#95cac3",
  jacksonsBlue75: "#5772af",
  stTropaz50: "#96a8cc",
  stTropaz25: "#cad3e6",
  goldenTanoi70: "#ffd78a",
  salmon75: "#fea68b",
  havelock75: "#88c3e6",
  allPorts50: "#7fbecf",
  // Desatured
  blackPearlOff: "#181818",
  prussianBlueOff: "#242424",
  jungleGreenOff: "#606060",
  tradewindOff: "#7d7d7d",
  alpha: function(e, t) {
    let n = parseInt(e.slice(1, 3), 16), c = parseInt(e.slice(3, 5), 16), r = parseInt(e.slice(5, 7), 16);
    return `rgba(${n}, ${c}, ${r}, ${t})`;
  }
}, Bc = (e, t) => e ? t && e.length > t ? `${e.slice(0, t)}...` : e : "", Ac = (e) => {
  if (e)
    return `${e[0].toUpperCase()}${e.substring(1)}`;
}, Vc = (e) => {
  if (e)
    return e.slice(e.indexOf("-") + 1, e.length);
}, Nc = (e) => {
  if (e)
    return e.replace(/-/g, " ");
}, je = (e, t) => {
  if (!t || !e)
    return e;
  const n = t.split("."), c = Number(e);
  return n.length <= 1 ? parseInt(e, 10) : c.toFixed(n[1].length);
}, Ue = (e) => {
  if (!e)
    return;
  e += "";
  let t = e.split("."), n = t[0], c = t.length > 1 ? "." + t[1] : "";
  const r = /(\d+)(\d{3})/;
  for (; r.test(n); )
    n = n.replace(r, "$1,$2");
  return n + c;
}, Oc = (e, t = "0.0") => Ue(je(e, t)), Pc = (e, t, n, c) => {
  if (e == null || !t)
    return;
  const r = n ? n.indexOf("%") > -1 : t.indexOf("%") > -1, i = n ? n.indexOf("x") > -1 : t.indexOf("x") > -1, _ = t.match(/([0-9]{2})+\s([A-z])+\s([0-9])+/), a = new Date(e).getYear() > 70 && _, l = t.indexOf(".") > 0 ? t.slice(t.indexOf(".") + 1, t.length).match(/[0-9]/g).length : 0, f = {
    minimumFractionDigits: c ? 0 : l,
    maximumFractionDigits: c ? 0 : l
  };
  return a ? Me(e).format("DD MMM [']YY") : isNaN(e) || _ ? e : r ? `${e.toLocaleString("en-US", f)}%` : i ? `${e.toLocaleString("en-US", f)}x` : l > 0 && e < 0 ? `(${e.toLocaleString("en-US", f).slice(1)})` : e.toLocaleString("en-US", f);
}, Ec = (e, t) => e ? e.toString().match(/-/) ? `${e.toLocaleString("en-US", { minimumFractionDigits: t || 1, maximumFractionDigits: t || 1 }).replace("-", "(")})` : e.toLocaleString("en-US", {
  minimumFractionDigits: t || 1,
  maximumFractionDigits: t || 1
}) : void 0, Fc = (e, t) => `${Math.floor(e / t * 100)}%`, Kc = (e) => Me(e).format("DD MMM YYYY, H:mm"), Yc = (e) => e ? Me(e).format("DD MMM YYYY") : "", Rc = {
  cutLongText: Bc,
  capitalize: Ac,
  justHash: Vc,
  elegantFakeDate: Nc,
  elegantNumber: Ec,
  formatDigitPlaces: je,
  commaSeparatedThousands: Ue,
  formatAndCommaSeparateThousands: Oc,
  formatValueFromRef: Pc,
  simplePercentage: Fc,
  medDate: Kc,
  medDateNoTime: Yc
}, Ie = {
  CognitiveAutoSuggest: ft,
  CognitiveBlock: vt,
  CognitiveButton: Ct,
  CognitiveDropdown: kt,
  CognitiveError: Tt,
  CognitiveField: p1,
  CognitiveFileUploader: S1,
  CognitiveHeading: z1,
  CognitiveIcon: V1,
  CognitiveInitials: P1,
  CognitiveInlineError: K1,
  CognitiveList: j1,
  CognitiveListItem: X1,
  CognitiveLoader: ln,
  CognitiveNotification: hn,
  CognitiveParagraph: mn,
  CognitiveResponsiveTable: Mn,
  CognitiveTable: In,
  CognitiveTabs: Hn,
  CognitiveTag: Bn,
  CognitiveTitle: Nn,
  CognitiveMessage: Fn,
  CognitiveDiscard: vi,
  CognitiveDatePicker: xt,
  CognitiveExpandable: Rn
}, jc = {
  install(e) {
    for (const t in Ae)
      e.component(t, Ae[t]);
    for (const t in Ve)
      e.component(`CSS${t}`, Ve[t]);
    for (const t in Ie)
      e.component(t, Ie[t]);
  }
}, Gc = {
  components: {
    ...Ie
  },
  plugins: {
    CognitiveModal: fi,
    ComponentPlugin: jc
  },
  colours: Zc,
  filters: Rc,
  useModalStore: ze
};
export {
  Zc as colours,
  Gc as default,
  Rc as filters,
  ze as useModalStore
};
